/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(24);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Box; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Button; });
/* unused harmony export Card */
/* unused harmony export Checkbox */
/* unused harmony export Collection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Column; });
/* unused harmony export Container */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Divider; });
/* unused harmony export Flyout */
/* unused harmony export GroupAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IconButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Image; });
/* unused harmony export Label */
/* unused harmony export Layer */
/* unused harmony export Letterbox */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Mask; });
/* unused harmony export Masonry */
/* unused harmony export MasonryDefaultLayout */
/* unused harmony export MasonryUniformRowLayout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Modal; });
/* unused harmony export Pog */
/* unused harmony export Pulsar */
/* unused harmony export RadioButton */
/* unused harmony export ScrollFetch */
/* unused harmony export SearchField */
/* unused harmony export SegmentedControl */
/* unused harmony export SelectList */
/* unused harmony export Spinner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Sticky; });
/* unused harmony export Switch */
/* unused harmony export Tabs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Text; });
/* unused harmony export TextArea */
/* unused harmony export TextField */
/* unused harmony export Toast */
/* unused harmony export Tooltip */
/* unused harmony export Touchable */
/* unused harmony export Video */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);





var styles = { "box": "_0 _3r _2u", "xsDisplayNone": "_1", "xsDisplayFlex": "_2", "xsDisplayBlock": "_3", "xsDisplayInlineBlock": "_4", "xsDisplayVisuallyHidden": "_5", "smDisplayNone": "_6", "smDisplayFlex": "_7", "smDisplayBlock": "_8", "smDisplayInlineBlock": "_9", "smDisplayVisuallyHidden": "_a", "mdDisplayNone": "_b", "mdDisplayFlex": "_c", "mdDisplayBlock": "_d", "mdDisplayInlineBlock": "_e", "mdDisplayVisuallyHidden": "_f", "lgDisplayNone": "_g", "lgDisplayFlex": "_h", "lgDisplayBlock": "_i", "lgDisplayInlineBlock": "_j", "lgDisplayVisuallyHidden": "_k", "xsDirectionRow": "_l", "xsDirectionColumn": "_m", "smDirectionRow": "_n", "smDirectionColumn": "_o", "mdDirectionRow": "_p", "mdDirectionColumn": "_q", "lgDirectionRow": "_r", "lgDirectionColumn": "_s", "xsCol0": "_t", "xsCol1": "_u _3u", "xsCol2": "_v _3v", "xsCol3": "_w _3w", "xsCol4": "_x _3x", "xsCol5": "_y _3y", "xsCol6": "_z _3z", "xsCol7": "_10 _40", "xsCol8": "_11 _41", "xsCol9": "_12 _42", "xsCol10": "_13 _43", "xsCol11": "_14 _44", "xsCol12": "_15 _45", "smCol0": "_16", "smCol1": "_17 _46", "smCol2": "_18 _47", "smCol3": "_19 _48", "smCol4": "_1a _49", "smCol5": "_1b _4a", "smCol6": "_1c _4b", "smCol7": "_1d _4c", "smCol8": "_1e _4d", "smCol9": "_1f _4e", "smCol10": "_1g _4f", "smCol11": "_1h _4g", "smCol12": "_1i _4h", "mdCol0": "_1j", "mdCol1": "_1k _4i", "mdCol2": "_1l _4j", "mdCol3": "_1m _4k", "mdCol4": "_1n _4l", "mdCol5": "_1o _4m", "mdCol6": "_1p _4n", "mdCol7": "_1q _4o", "mdCol8": "_1r _4p", "mdCol9": "_1s _4q", "mdCol10": "_1t _4r", "mdCol11": "_1u _4s", "mdCol12": "_1v _4t", "lgCol0": "_1w", "lgCol1": "_1x _4u", "lgCol2": "_1y _4v", "lgCol3": "_1z _4w", "lgCol4": "_20 _4x", "lgCol5": "_21 _4y", "lgCol6": "_22 _4z", "lgCol7": "_23 _50", "lgCol8": "_24 _51", "lgCol9": "_25 _52", "lgCol10": "_26 _53", "lgCol11": "_27 _54", "lgCol12": "_28 _55" };

var borders = { "border": "_56", "borderTop": "_57", "borderRight": "_58", "borderBottom": "_59", "borderLeft": "_5a", "square": "_5b", "circle": "_5c", "pill": "_5d", "rounded": "_5e", "roundedTop": "_5f", "roundedRight": "_5g", "roundedBottom": "_5h", "roundedLeft": "_5i", "noBorder": "_5j" };

var colors = { "red": "_5k", "redBg": "_5l", "white": "_5m", "whiteBg": "_5n", "lightGray": "_5o", "lightGrayBg": "_5p", "gray": "_5q", "grayBg": "_5r", "darkGray": "_5s", "darkGrayBg": "_5t", "green": "_5u", "greenBg": "_5v", "pine": "_5w", "pineBg": "_5x", "olive": "_5y", "oliveBg": "_5z", "blue": "_60", "blueBg": "_61", "navy": "_62", "navyBg": "_63", "midnight": "_64", "midnightBg": "_65", "purple": "_66", "purpleBg": "_67", "orchid": "_68", "orchidBg": "_69", "eggplant": "_6a", "eggplantBg": "_6b", "maroon": "_6c", "maroonBg": "_6d", "watermelon": "_6e", "watermelonBg": "_6f", "orange": "_6g", "orangeBg": "_6h", "transparentBg": "_6i", "lightWashBg": "_6j", "darkWashBg": "_6k" };

var layout = { "block": "_29", "inline": "_2a", "inlineBlock": "_2b", "table": "_2c", "overflowHidden": "_2d", "overflowScroll": "_2e", "overflowScrollX": "_2f", "overflowScrollY": "_2g", "overflowAuto": "_2h", "fit": "_2i", "relative": "_2j", "fixed": "_2k", "absolute": "_2l", "sticky": "_2m", "top0": "_2n", "right0": "_2o", "bottom0": "_2p", "left0": "_2q", "small": "_2r", "medium": "_2s", "large": "_2t", "borderBox": "_2u", "contentBox": "_2v", "-webkit-box-flex": "_2w", "-webkit-flex": "_2w", "-ms-flex": "_2w", "flex": "_2w", "smFlex": "_2x", "mdFlex": "_2y", "lgFlex": "_2z", "flexColumn": "_30", "flexWrap": "_31", "itemsStart": "_32", "itemsEnd": "_33", "itemsCenter": "_34", "itemsBaseline": "_35", "itemsStretch": "_36", "selfStart": "_37", "selfEnd": "_38", "selfCenter": "_39", "selfBaseline": "_3a", "selfStretch": "_3b", "justifyStart": "_3c", "justifyEnd": "_3d", "justifyCenter": "_3e", "justifyBetween": "_3f", "justifyAround": "_3g", "contentStart": "_3h", "contentEnd": "_3i", "contentCenter": "_3j", "contentBetween": "_3k", "contentAround": "_3l", "contentStretch": "_3m", "flexGrow": "_3n", "flexNone": "_3o", "orderFirst": "_3p", "orderLast": "_3q" };

var whitespace = { "marginStart1": "_6l", "marginEnd1": "_6m", "marginStartN1": "_6n", "marginEndN1": "_6o", "marginTop1": "_6p", "marginRight1": "_6q", "marginBottom1": "_6r", "marginLeft1": "_6s", "marginTopN1": "_6t", "marginRightN1": "_6u", "marginBottomN1": "_6v", "marginLeftN1": "_6w", "paddingY1": "_6x", "paddingX1": "_6y", "marginStart2": "_6z", "marginEnd2": "_70", "marginStartN2": "_71", "marginEndN2": "_72", "marginTop2": "_73", "marginRight2": "_74", "marginBottom2": "_75", "marginLeft2": "_76", "marginTopN2": "_77", "marginRightN2": "_78", "marginBottomN2": "_79", "marginLeftN2": "_7a", "paddingY2": "_7b", "paddingX2": "_7c", "marginStart3": "_7d", "marginEnd3": "_7e", "marginStartN3": "_7f", "marginEndN3": "_7g", "marginTop3": "_7h", "marginRight3": "_7i", "marginBottom3": "_7j", "marginLeft3": "_7k", "marginTopN3": "_7l", "marginRightN3": "_7m", "marginBottomN3": "_7n", "marginLeftN3": "_7o", "paddingY3": "_7p", "paddingX3": "_7q", "marginStart4": "_7r", "marginEnd4": "_7s", "marginStartN4": "_7t", "marginEndN4": "_7u", "marginTop4": "_7v", "marginRight4": "_7w", "marginBottom4": "_7x", "marginLeft4": "_7y", "marginTopN4": "_7z", "marginRightN4": "_80", "marginBottomN4": "_81", "marginLeftN4": "_82", "paddingY4": "_83", "paddingX4": "_84", "marginStart5": "_85", "marginEnd5": "_86", "marginStartN5": "_87", "marginEndN5": "_88", "marginTop5": "_89", "marginRight5": "_8a", "marginBottom5": "_8b", "marginLeft5": "_8c", "marginTopN5": "_8d", "marginRightN5": "_8e", "marginBottomN5": "_8f", "marginLeftN5": "_8g", "paddingY5": "_8h", "paddingX5": "_8i", "marginStart6": "_8j", "marginEnd6": "_8k", "marginStartN6": "_8l", "marginEndN6": "_8m", "marginTop6": "_8n", "marginRight6": "_8o", "marginBottom6": "_8p", "marginLeft6": "_8q", "marginTopN6": "_8r", "marginRightN6": "_8s", "marginBottomN6": "_8t", "marginLeftN6": "_8u", "paddingY6": "_8v", "paddingX6": "_8w", "marginStart7": "_8x", "marginEnd7": "_8y", "marginStartN7": "_8z", "marginEndN7": "_90", "marginTop7": "_91", "marginRight7": "_92", "marginBottom7": "_93", "marginLeft7": "_94", "marginTopN7": "_95", "marginRightN7": "_96", "marginBottomN7": "_97", "marginLeftN7": "_98", "paddingY7": "_99", "paddingX7": "_9a", "marginStart8": "_9b", "marginEnd8": "_9c", "marginStartN8": "_9d", "marginEndN8": "_9e", "marginTop8": "_9f", "marginRight8": "_9g", "marginBottom8": "_9h", "marginLeft8": "_9i", "marginTopN8": "_9j", "marginRightN8": "_9k", "marginBottomN8": "_9l", "marginLeftN8": "_9m", "paddingY8": "_9n", "paddingX8": "_9o", "marginStart9": "_9p", "marginEnd9": "_9q", "marginStartN9": "_9r", "marginEndN9": "_9s", "marginTop9": "_9t", "marginRight9": "_9u", "marginBottom9": "_9v", "marginLeft9": "_9w", "marginTopN9": "_9x", "marginRightN9": "_9y", "marginBottomN9": "_9z", "marginLeftN9": "_a0", "paddingY9": "_a1", "paddingX9": "_a2", "marginStart10": "_a3", "marginEnd10": "_a4", "marginStartN10": "_a5", "marginEndN10": "_a6", "marginTop10": "_a7", "marginRight10": "_a8", "marginBottom10": "_a9", "marginLeft10": "_aa", "marginTopN10": "_ab", "marginRightN10": "_ac", "marginBottomN10": "_ad", "marginLeftN10": "_ae", "paddingY10": "_af", "paddingX10": "_ag", "marginStart11": "_ah", "marginEnd11": "_ai", "marginStartN11": "_aj", "marginEndN11": "_ak", "marginTop11": "_al", "marginRight11": "_am", "marginBottom11": "_an", "marginLeft11": "_ao", "marginTopN11": "_ap", "marginRightN11": "_aq", "marginBottomN11": "_ar", "marginLeftN11": "_as", "paddingY11": "_at", "paddingX11": "_au", "marginStart12": "_av", "marginEnd12": "_aw", "marginStartN12": "_ax", "marginEndN12": "_ay", "marginTop12": "_az", "marginRight12": "_b0", "marginBottom12": "_b1", "marginLeft12": "_b2", "marginTopN12": "_b3", "marginRightN12": "_b4", "marginBottomN12": "_b5", "marginLeftN12": "_b6", "paddingY12": "_b7", "paddingX12": "_b8", "smMarginStart1": "_b9", "smMarginEnd1": "_ba", "smMarginStartN1": "_bb", "smMarginEndN1": "_bc", "smMarginTop1": "_bd", "smMarginRight1": "_be", "smMarginBottom1": "_bf", "smMarginLeft1": "_bg", "smMarginTopN1": "_bh", "smMarginRightN1": "_bi", "smMarginBottomN1": "_bj", "smMarginLeftN1": "_bk", "smPaddingY1": "_bl", "smPaddingX1": "_bm", "smMarginStart2": "_bn", "smMarginEnd2": "_bo", "smMarginStartN2": "_bp", "smMarginEndN2": "_bq", "smMarginTop2": "_br", "smMarginRight2": "_bs", "smMarginBottom2": "_bt", "smMarginLeft2": "_bu", "smMarginTopN2": "_bv", "smMarginRightN2": "_bw", "smMarginBottomN2": "_bx", "smMarginLeftN2": "_by", "smPaddingY2": "_bz", "smPaddingX2": "_c0", "smMarginStart3": "_c1", "smMarginEnd3": "_c2", "smMarginStartN3": "_c3", "smMarginEndN3": "_c4", "smMarginTop3": "_c5", "smMarginRight3": "_c6", "smMarginBottom3": "_c7", "smMarginLeft3": "_c8", "smMarginTopN3": "_c9", "smMarginRightN3": "_ca", "smMarginBottomN3": "_cb", "smMarginLeftN3": "_cc", "smPaddingY3": "_cd", "smPaddingX3": "_ce", "smMarginStart4": "_cf", "smMarginEnd4": "_cg", "smMarginStartN4": "_ch", "smMarginEndN4": "_ci", "smMarginTop4": "_cj", "smMarginRight4": "_ck", "smMarginBottom4": "_cl", "smMarginLeft4": "_cm", "smMarginTopN4": "_cn", "smMarginRightN4": "_co", "smMarginBottomN4": "_cp", "smMarginLeftN4": "_cq", "smPaddingY4": "_cr", "smPaddingX4": "_cs", "smMarginStart5": "_ct", "smMarginEnd5": "_cu", "smMarginStartN5": "_cv", "smMarginEndN5": "_cw", "smMarginTop5": "_cx", "smMarginRight5": "_cy", "smMarginBottom5": "_cz", "smMarginLeft5": "_d0", "smMarginTopN5": "_d1", "smMarginRightN5": "_d2", "smMarginBottomN5": "_d3", "smMarginLeftN5": "_d4", "smPaddingY5": "_d5", "smPaddingX5": "_d6", "smMarginStart6": "_d7", "smMarginEnd6": "_d8", "smMarginStartN6": "_d9", "smMarginEndN6": "_da", "smMarginTop6": "_db", "smMarginRight6": "_dc", "smMarginBottom6": "_dd", "smMarginLeft6": "_de", "smMarginTopN6": "_df", "smMarginRightN6": "_dg", "smMarginBottomN6": "_dh", "smMarginLeftN6": "_di", "smPaddingY6": "_dj", "smPaddingX6": "_dk", "smMarginStart7": "_dl", "smMarginEnd7": "_dm", "smMarginStartN7": "_dn", "smMarginEndN7": "_do", "smMarginTop7": "_dp", "smMarginRight7": "_dq", "smMarginBottom7": "_dr", "smMarginLeft7": "_ds", "smMarginTopN7": "_dt", "smMarginRightN7": "_du", "smMarginBottomN7": "_dv", "smMarginLeftN7": "_dw", "smPaddingY7": "_dx", "smPaddingX7": "_dy", "smMarginStart8": "_dz", "smMarginEnd8": "_e0", "smMarginStartN8": "_e1", "smMarginEndN8": "_e2", "smMarginTop8": "_e3", "smMarginRight8": "_e4", "smMarginBottom8": "_e5", "smMarginLeft8": "_e6", "smMarginTopN8": "_e7", "smMarginRightN8": "_e8", "smMarginBottomN8": "_e9", "smMarginLeftN8": "_ea", "smPaddingY8": "_eb", "smPaddingX8": "_ec", "smMarginStart9": "_ed", "smMarginEnd9": "_ee", "smMarginStartN9": "_ef", "smMarginEndN9": "_eg", "smMarginTop9": "_eh", "smMarginRight9": "_ei", "smMarginBottom9": "_ej", "smMarginLeft9": "_ek", "smMarginTopN9": "_el", "smMarginRightN9": "_em", "smMarginBottomN9": "_en", "smMarginLeftN9": "_eo", "smPaddingY9": "_ep", "smPaddingX9": "_eq", "smMarginStart10": "_er", "smMarginEnd10": "_es", "smMarginStartN10": "_et", "smMarginEndN10": "_eu", "smMarginTop10": "_ev", "smMarginRight10": "_ew", "smMarginBottom10": "_ex", "smMarginLeft10": "_ey", "smMarginTopN10": "_ez", "smMarginRightN10": "_f0", "smMarginBottomN10": "_f1", "smMarginLeftN10": "_f2", "smPaddingY10": "_f3", "smPaddingX10": "_f4", "smMarginStart11": "_f5", "smMarginEnd11": "_f6", "smMarginStartN11": "_f7", "smMarginEndN11": "_f8", "smMarginTop11": "_f9", "smMarginRight11": "_fa", "smMarginBottom11": "_fb", "smMarginLeft11": "_fc", "smMarginTopN11": "_fd", "smMarginRightN11": "_fe", "smMarginBottomN11": "_ff", "smMarginLeftN11": "_fg", "smPaddingY11": "_fh", "smPaddingX11": "_fi", "smMarginStart12": "_fj", "smMarginEnd12": "_fk", "smMarginStartN12": "_fl", "smMarginEndN12": "_fm", "smMarginTop12": "_fn", "smMarginRight12": "_fo", "smMarginBottom12": "_fp", "smMarginLeft12": "_fq", "smMarginTopN12": "_fr", "smMarginRightN12": "_fs", "smMarginBottomN12": "_ft", "smMarginLeftN12": "_fu", "smPaddingY12": "_fv", "smPaddingX12": "_fw", "mdMarginStart1": "_fx", "mdMarginEnd1": "_fy", "mdMarginStartN1": "_fz", "mdMarginEndN1": "_g0", "mdMarginTop1": "_g1", "mdMarginRight1": "_g2", "mdMarginBottom1": "_g3", "mdMarginLeft1": "_g4", "mdMarginTopN1": "_g5", "mdMarginRightN1": "_g6", "mdMarginBottomN1": "_g7", "mdMarginLeftN1": "_g8", "mdPaddingY1": "_g9", "mdPaddingX1": "_ga", "mdMarginStart2": "_gb", "mdMarginEnd2": "_gc", "mdMarginStartN2": "_gd", "mdMarginEndN2": "_ge", "mdMarginTop2": "_gf", "mdMarginRight2": "_gg", "mdMarginBottom2": "_gh", "mdMarginLeft2": "_gi", "mdMarginTopN2": "_gj", "mdMarginRightN2": "_gk", "mdMarginBottomN2": "_gl", "mdMarginLeftN2": "_gm", "mdPaddingY2": "_gn", "mdPaddingX2": "_go", "mdMarginStart3": "_gp", "mdMarginEnd3": "_gq", "mdMarginStartN3": "_gr", "mdMarginEndN3": "_gs", "mdMarginTop3": "_gt", "mdMarginRight3": "_gu", "mdMarginBottom3": "_gv", "mdMarginLeft3": "_gw", "mdMarginTopN3": "_gx", "mdMarginRightN3": "_gy", "mdMarginBottomN3": "_gz", "mdMarginLeftN3": "_h0", "mdPaddingY3": "_h1", "mdPaddingX3": "_h2", "mdMarginStart4": "_h3", "mdMarginEnd4": "_h4", "mdMarginStartN4": "_h5", "mdMarginEndN4": "_h6", "mdMarginTop4": "_h7", "mdMarginRight4": "_h8", "mdMarginBottom4": "_h9", "mdMarginLeft4": "_ha", "mdMarginTopN4": "_hb", "mdMarginRightN4": "_hc", "mdMarginBottomN4": "_hd", "mdMarginLeftN4": "_he", "mdPaddingY4": "_hf", "mdPaddingX4": "_hg", "mdMarginStart5": "_hh", "mdMarginEnd5": "_hi", "mdMarginStartN5": "_hj", "mdMarginEndN5": "_hk", "mdMarginTop5": "_hl", "mdMarginRight5": "_hm", "mdMarginBottom5": "_hn", "mdMarginLeft5": "_ho", "mdMarginTopN5": "_hp", "mdMarginRightN5": "_hq", "mdMarginBottomN5": "_hr", "mdMarginLeftN5": "_hs", "mdPaddingY5": "_ht", "mdPaddingX5": "_hu", "mdMarginStart6": "_hv", "mdMarginEnd6": "_hw", "mdMarginStartN6": "_hx", "mdMarginEndN6": "_hy", "mdMarginTop6": "_hz", "mdMarginRight6": "_i0", "mdMarginBottom6": "_i1", "mdMarginLeft6": "_i2", "mdMarginTopN6": "_i3", "mdMarginRightN6": "_i4", "mdMarginBottomN6": "_i5", "mdMarginLeftN6": "_i6", "mdPaddingY6": "_i7", "mdPaddingX6": "_i8", "mdMarginStart7": "_i9", "mdMarginEnd7": "_ia", "mdMarginStartN7": "_ib", "mdMarginEndN7": "_ic", "mdMarginTop7": "_id", "mdMarginRight7": "_ie", "mdMarginBottom7": "_if", "mdMarginLeft7": "_ig", "mdMarginTopN7": "_ih", "mdMarginRightN7": "_ii", "mdMarginBottomN7": "_ij", "mdMarginLeftN7": "_ik", "mdPaddingY7": "_il", "mdPaddingX7": "_im", "mdMarginStart8": "_in", "mdMarginEnd8": "_io", "mdMarginStartN8": "_ip", "mdMarginEndN8": "_iq", "mdMarginTop8": "_ir", "mdMarginRight8": "_is", "mdMarginBottom8": "_it", "mdMarginLeft8": "_iu", "mdMarginTopN8": "_iv", "mdMarginRightN8": "_iw", "mdMarginBottomN8": "_ix", "mdMarginLeftN8": "_iy", "mdPaddingY8": "_iz", "mdPaddingX8": "_j0", "mdMarginStart9": "_j1", "mdMarginEnd9": "_j2", "mdMarginStartN9": "_j3", "mdMarginEndN9": "_j4", "mdMarginTop9": "_j5", "mdMarginRight9": "_j6", "mdMarginBottom9": "_j7", "mdMarginLeft9": "_j8", "mdMarginTopN9": "_j9", "mdMarginRightN9": "_ja", "mdMarginBottomN9": "_jb", "mdMarginLeftN9": "_jc", "mdPaddingY9": "_jd", "mdPaddingX9": "_je", "mdMarginStart10": "_jf", "mdMarginEnd10": "_jg", "mdMarginStartN10": "_jh", "mdMarginEndN10": "_ji", "mdMarginTop10": "_jj", "mdMarginRight10": "_jk", "mdMarginBottom10": "_jl", "mdMarginLeft10": "_jm", "mdMarginTopN10": "_jn", "mdMarginRightN10": "_jo", "mdMarginBottomN10": "_jp", "mdMarginLeftN10": "_jq", "mdPaddingY10": "_jr", "mdPaddingX10": "_js", "mdMarginStart11": "_jt", "mdMarginEnd11": "_ju", "mdMarginStartN11": "_jv", "mdMarginEndN11": "_jw", "mdMarginTop11": "_jx", "mdMarginRight11": "_jy", "mdMarginBottom11": "_jz", "mdMarginLeft11": "_k0", "mdMarginTopN11": "_k1", "mdMarginRightN11": "_k2", "mdMarginBottomN11": "_k3", "mdMarginLeftN11": "_k4", "mdPaddingY11": "_k5", "mdPaddingX11": "_k6", "mdMarginStart12": "_k7", "mdMarginEnd12": "_k8", "mdMarginStartN12": "_k9", "mdMarginEndN12": "_ka", "mdMarginTop12": "_kb", "mdMarginRight12": "_kc", "mdMarginBottom12": "_kd", "mdMarginLeft12": "_ke", "mdMarginTopN12": "_kf", "mdMarginRightN12": "_kg", "mdMarginBottomN12": "_kh", "mdMarginLeftN12": "_ki", "mdPaddingY12": "_kj", "mdPaddingX12": "_kk", "lgMarginStart1": "_kl", "lgMarginEnd1": "_km", "lgMarginStartN1": "_kn", "lgMarginEndN1": "_ko", "lgMarginTop1": "_kp", "lgMarginRight1": "_kq", "lgMarginBottom1": "_kr", "lgMarginLeft1": "_ks", "lgMarginTopN1": "_kt", "lgMarginRightN1": "_ku", "lgMarginBottomN1": "_kv", "lgMarginLeftN1": "_kw", "lgPaddingY1": "_kx", "lgPaddingX1": "_ky", "lgMarginStart2": "_kz", "lgMarginEnd2": "_l0", "lgMarginStartN2": "_l1", "lgMarginEndN2": "_l2", "lgMarginTop2": "_l3", "lgMarginRight2": "_l4", "lgMarginBottom2": "_l5", "lgMarginLeft2": "_l6", "lgMarginTopN2": "_l7", "lgMarginRightN2": "_l8", "lgMarginBottomN2": "_l9", "lgMarginLeftN2": "_la", "lgPaddingY2": "_lb", "lgPaddingX2": "_lc", "lgMarginStart3": "_ld", "lgMarginEnd3": "_le", "lgMarginStartN3": "_lf", "lgMarginEndN3": "_lg", "lgMarginTop3": "_lh", "lgMarginRight3": "_li", "lgMarginBottom3": "_lj", "lgMarginLeft3": "_lk", "lgMarginTopN3": "_ll", "lgMarginRightN3": "_lm", "lgMarginBottomN3": "_ln", "lgMarginLeftN3": "_lo", "lgPaddingY3": "_lp", "lgPaddingX3": "_lq", "lgMarginStart4": "_lr", "lgMarginEnd4": "_ls", "lgMarginStartN4": "_lt", "lgMarginEndN4": "_lu", "lgMarginTop4": "_lv", "lgMarginRight4": "_lw", "lgMarginBottom4": "_lx", "lgMarginLeft4": "_ly", "lgMarginTopN4": "_lz", "lgMarginRightN4": "_m0", "lgMarginBottomN4": "_m1", "lgMarginLeftN4": "_m2", "lgPaddingY4": "_m3", "lgPaddingX4": "_m4", "lgMarginStart5": "_m5", "lgMarginEnd5": "_m6", "lgMarginStartN5": "_m7", "lgMarginEndN5": "_m8", "lgMarginTop5": "_m9", "lgMarginRight5": "_ma", "lgMarginBottom5": "_mb", "lgMarginLeft5": "_mc", "lgMarginTopN5": "_md", "lgMarginRightN5": "_me", "lgMarginBottomN5": "_mf", "lgMarginLeftN5": "_mg", "lgPaddingY5": "_mh", "lgPaddingX5": "_mi", "lgMarginStart6": "_mj", "lgMarginEnd6": "_mk", "lgMarginStartN6": "_ml", "lgMarginEndN6": "_mm", "lgMarginTop6": "_mn", "lgMarginRight6": "_mo", "lgMarginBottom6": "_mp", "lgMarginLeft6": "_mq", "lgMarginTopN6": "_mr", "lgMarginRightN6": "_ms", "lgMarginBottomN6": "_mt", "lgMarginLeftN6": "_mu", "lgPaddingY6": "_mv", "lgPaddingX6": "_mw", "lgMarginStart7": "_mx", "lgMarginEnd7": "_my", "lgMarginStartN7": "_mz", "lgMarginEndN7": "_n0", "lgMarginTop7": "_n1", "lgMarginRight7": "_n2", "lgMarginBottom7": "_n3", "lgMarginLeft7": "_n4", "lgMarginTopN7": "_n5", "lgMarginRightN7": "_n6", "lgMarginBottomN7": "_n7", "lgMarginLeftN7": "_n8", "lgPaddingY7": "_n9", "lgPaddingX7": "_na", "lgMarginStart8": "_nb", "lgMarginEnd8": "_nc", "lgMarginStartN8": "_nd", "lgMarginEndN8": "_ne", "lgMarginTop8": "_nf", "lgMarginRight8": "_ng", "lgMarginBottom8": "_nh", "lgMarginLeft8": "_ni", "lgMarginTopN8": "_nj", "lgMarginRightN8": "_nk", "lgMarginBottomN8": "_nl", "lgMarginLeftN8": "_nm", "lgPaddingY8": "_nn", "lgPaddingX8": "_no", "lgMarginStart9": "_np", "lgMarginEnd9": "_nq", "lgMarginStartN9": "_nr", "lgMarginEndN9": "_ns", "lgMarginTop9": "_nt", "lgMarginRight9": "_nu", "lgMarginBottom9": "_nv", "lgMarginLeft9": "_nw", "lgMarginTopN9": "_nx", "lgMarginRightN9": "_ny", "lgMarginBottomN9": "_nz", "lgMarginLeftN9": "_o0", "lgPaddingY9": "_o1", "lgPaddingX9": "_o2", "lgMarginStart10": "_o3", "lgMarginEnd10": "_o4", "lgMarginStartN10": "_o5", "lgMarginEndN10": "_o6", "lgMarginTop10": "_o7", "lgMarginRight10": "_o8", "lgMarginBottom10": "_o9", "lgMarginLeft10": "_oa", "lgMarginTopN10": "_ob", "lgMarginRightN10": "_oc", "lgMarginBottomN10": "_od", "lgMarginLeftN10": "_oe", "lgPaddingY10": "_of", "lgPaddingX10": "_og", "lgMarginStart11": "_oh", "lgMarginEnd11": "_oi", "lgMarginStartN11": "_oj", "lgMarginEndN11": "_ok", "lgMarginTop11": "_ol", "lgMarginRight11": "_om", "lgMarginBottom11": "_on", "lgMarginLeft11": "_oo", "lgMarginTopN11": "_op", "lgMarginRightN11": "_oq", "lgMarginBottomN11": "_or", "lgMarginLeftN11": "_os", "lgPaddingY11": "_ot", "lgPaddingX11": "_ou", "lgMarginStart12": "_ov", "lgMarginEnd12": "_ow", "lgMarginStartN12": "_ox", "lgMarginEndN12": "_oy", "lgMarginTop12": "_oz", "lgMarginRight12": "_p0", "lgMarginBottom12": "_p1", "lgMarginLeft12": "_p2", "lgMarginTopN12": "_p3", "lgMarginRightN12": "_p4", "lgMarginBottomN12": "_p5", "lgMarginLeftN12": "_p6", "lgPaddingY12": "_p7", "lgPaddingX12": "_p8" };

var whitespaceLegacy = { "mlAuto": "_p9", "mrAuto": "_pa", "m0": "_pb", "mt0": "_pc", "mr0": "_pd", "mb0": "_pe", "ml0": "_pf", "p0": "_pg", "px0": "_ph", "py0": "_pi", "m1": "_pj", "mt1": "_pk", "mr1": "_pl", "mb1": "_pm", "ml1": "_pn", "mn1": "_po", "mtn1": "_pp", "mbn1": "_pq", "mln1": "_pr", "mrn1": "_ps", "mxn1": "_pt", "myn1": "_pu", "p1": "_pv", "px1": "_pw", "py1": "_px", "m2": "_py", "mt2": "_pz", "mr2": "_q0", "mb2": "_q1", "ml2": "_q2", "mn2": "_q3", "mtn2": "_q4", "mbn2": "_q5", "mln2": "_q6", "mrn2": "_q7", "mxn2": "_q8", "myn2": "_q9", "p2": "_qa", "px2": "_qb", "py2": "_qc", "m3": "_qd", "mt3": "_qe", "mr3": "_qf", "mb3": "_qg", "ml3": "_qh", "mn3": "_qi", "mtn3": "_qj", "mbn3": "_qk", "mln3": "_ql", "mrn3": "_qm", "mxn3": "_qn", "myn3": "_qo", "p3": "_qp", "px3": "_qq", "py3": "_qr", "m4": "_qs", "mt4": "_qt", "mr4": "_qu", "mb4": "_qv", "ml4": "_qw", "mn4": "_qx", "mtn4": "_qy", "mbn4": "_qz", "mln4": "_r0", "mrn4": "_r1", "mxn4": "_r2", "myn4": "_r3", "p4": "_r4", "px4": "_r5", "py4": "_r6", "m5": "_r7", "mt5": "_r8", "mr5": "_r9", "mb5": "_ra", "ml5": "_rb", "mn5": "_rc", "mtn5": "_rd", "mbn5": "_re", "mln5": "_rf", "mrn5": "_rg", "mxn5": "_rh", "myn5": "_ri", "p5": "_rj", "px5": "_rk", "py5": "_rl", "m6": "_rm", "mt6": "_rn", "mr6": "_ro", "mb6": "_rp", "ml6": "_rq", "mn6": "_rr", "mtn6": "_rs", "mbn6": "_rt", "mln6": "_ru", "mrn6": "_rv", "mxn6": "_rw", "myn6": "_rx", "p6": "_ry", "px6": "_rz", "py6": "_s0" };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var identity = function identity() {
  return {
    className: new Set(),
    inlineStyle: {}
  };
};

/*

Style is a monoid that capture the "to-be-applied" styles (inline and classes)
for a Box. It's basically set that is closed under an associative binary
operation and has an identity element such that for all HA HA HA. Yes, it's a
monoid, which sounds scary but it's not really and actually super useful. All
that means is that basically you can do two things with it:

    1. concat(concat(a, b), c) === concat(a, concat(b, c));
    2. concat(identity(), a) === concat(a, identity()) === a;

What that means is that it's really easy to compose styles together and the
order in which you do so doesn't really matter.

*/

// TODO: This type should be opaque, however the Babel parser doesn't support
//       the opaque syntax yet.


var fromClassName = function fromClassName() {
  for (var _len = arguments.length, classNames = Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return {
    className: new Set(classNames),
    inlineStyle: {}
  };
};

var fromInlineStyle = function fromInlineStyle(inlineStyle) {
  return {
    className: new Set(),
    inlineStyle: inlineStyle
  };
};

var concat = function concat(styles) {
  return styles.reduce(function (_ref, _ref2) {
    var classNameA = _ref.className,
        inlineStyleA = _ref.inlineStyle;
    var classNameB = _ref2.className,
        inlineStyleB = _ref2.inlineStyle;
    return {
      className: new Set([].concat(toConsumableArray(classNameA), toConsumableArray(classNameB))),
      inlineStyle: _extends({}, inlineStyleA, inlineStyleB)
    };
  }, identity());
};

var mapClassName = function mapClassName(fn) {
  return function (_ref3) {
    var className = _ref3.className,
        inlineStyle = _ref3.inlineStyle;
    return {
      className: new Set(Array.from(className).map(fn)),
      inlineStyle: inlineStyle
    };
  };
};

var toProps = function toProps(_ref4) {
  var className = _ref4.className,
      inlineStyle = _ref4.inlineStyle;

  var props = {};

  if (className.size > 0) {
    // Sorting here ensures that classNames are always stable, reducing diff
    // churn. Box usually has a small number of properties so it's not a perf
    // concern.
    props.className = Array.from(className).sort().join(' ');
  }

  if (Object.keys(inlineStyle).length > 0) {
    props.style = inlineStyle;
  }

  return props;
};

/*

Transforms

These are a collection of a few functors that take values and returns Style's. OMG, I used the word functor - it's really just a fancy word for function.

*/

// Adds a classname when a property is present.
//
//     <Box top />
//
var toggle = function toggle() {
  for (var _len = arguments.length, classNames = Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return function (val) {
    return val ? fromClassName.apply(undefined, classNames) : identity();
  };
};

// Maps string values to classes
//
//     <Box alignItems="center" />
//
var mapping = function mapping(map) {
  return function (val) {
    return Object.prototype.hasOwnProperty.call(map, val) ? fromClassName(map[val]) : identity();
  };
};

// Maps a range of integers to a range of classnames
//
//     <Box padding={1} />
//
var range = function range(scale) {
  return function (n) {
    return fromClassName('' + scale + (n < 0 ? 'N' + Math.abs(n) : n));
  };
};

// Like `range`, maps a range of integers to a range of classnames, excluding
// zero values.
//
//     <Box padding={0} />
var rangeWithoutZero = function rangeWithoutZero(scale) {
  return function (n) {
    return n === 0 ? identity() : range(scale)(n);
  };
};

// Binds a string classname to the value in an object. Useful when interacting
// with ranges that need to come dynamically from a style object. This is
// similar to the NPM package 'classnames/bind'.
var bind = function bind(fn, scope) {
  return function (val) {
    return mapClassName(function (name) {
      return scope[name];
    })(fn(val));
  };
};

// This takes a series of the previously defined functors, runs them all
// against a value and returns the set of their classnames.
var union = function union() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (val) {
    return concat(fns.map(function (fn) {
      return fn(val);
    }));
  };
};

/*

# ProTypes

Box's type definition is exhaustive. With the exception of `dangerouslySetInlineStyle`, values shouldn't be ambigious. That means that we have to type out things like boints, but that's also where Box's magic lies. Also, by putting in extra effort around type definitions here, we can skip extra runtime typechecks in the transformers for performance.

*/

// --

/*

# Transformers

This is where the meat and the bones of Box's transforms are. You can read more about the DSL in `./transforms.js`, but basically they are a small declarative way of specifying how a property (i.e. `marginTop={4}`) gets turned into a CSS class (`marginTop4`).

There's a little preamble here, but it culminates in a big object mapping the actual property names to the transformer values.

*/

var marginStart = bind(rangeWithoutZero('marginStart'), whitespace);
var marginEnd = bind(rangeWithoutZero('marginEnd'), whitespace);
var marginTop = bind(rangeWithoutZero('marginTop'), whitespace);
var marginRight = bind(rangeWithoutZero('marginRight'), whitespace);
var marginBottom = bind(rangeWithoutZero('marginBottom'), whitespace);
var marginLeft = bind(rangeWithoutZero('marginLeft'), whitespace);
var margin = union(marginTop, marginBottom, marginLeft, marginRight);

var smMarginTop = bind(rangeWithoutZero('smMarginTop'), whitespace);
var smMarginRight = bind(rangeWithoutZero('smMarginRight'), whitespace);
var smMarginBottom = bind(rangeWithoutZero('smMarginBottom'), whitespace);
var smMarginLeft = bind(rangeWithoutZero('smMarginLeft'), whitespace);
var smMargin = union(smMarginTop, smMarginBottom, smMarginLeft, smMarginRight);

var mdMarginTop = bind(rangeWithoutZero('mdMarginTop'), whitespace);
var mdMarginRight = bind(rangeWithoutZero('mdMarginRight'), whitespace);
var mdMarginBottom = bind(rangeWithoutZero('mdMarginBottom'), whitespace);
var mdMarginLeft = bind(rangeWithoutZero('mdMarginLeft'), whitespace);
var mdMargin = union(mdMarginTop, mdMarginBottom, mdMarginLeft, mdMarginRight);

var lgMarginTop = bind(rangeWithoutZero('lgMarginTop'), whitespace);
var lgMarginRight = bind(rangeWithoutZero('lgMarginRight'), whitespace);
var lgMarginBottom = bind(rangeWithoutZero('lgMarginBottom'), whitespace);
var lgMarginLeft = bind(rangeWithoutZero('lgMarginLeft'), whitespace);
var lgMargin = union(lgMarginTop, lgMarginBottom, lgMarginLeft, lgMarginRight);

var paddingX = bind(rangeWithoutZero('paddingX'), whitespace);
var paddingY = bind(rangeWithoutZero('paddingY'), whitespace);
var padding = union(paddingX, paddingY);

var smPaddingX = bind(rangeWithoutZero('smPaddingX'), whitespace);
var smPaddingY = bind(rangeWithoutZero('smPaddingY'), whitespace);
var smPadding = union(smPaddingX, smPaddingY);

var mdPaddingX = bind(rangeWithoutZero('mdPaddingX'), whitespace);
var mdPaddingY = bind(rangeWithoutZero('mdPaddingY'), whitespace);
var mdPadding = union(mdPaddingX, mdPaddingY);

var lgPaddingX = bind(rangeWithoutZero('lgPaddingX'), whitespace);
var lgPaddingY = bind(rangeWithoutZero('lgPaddingY'), whitespace);
var lgPadding = union(lgPaddingX, lgPaddingY);

/*

These functions are legacy. I'd like to get rid of most of this file's dependency on importing `./style.js` directly once these are removed.

*/

var prefix = function prefix(pre) {
  return mapClassName(function (name) {
    return '' + pre + name;
  });
};
var display = function display(value) {
  switch (value) {
    case 'flex':
      return fromClassName('DisplayFlex', 'DirectionRow');
    case 'flexColumn':
      return fromClassName('DisplayFlex', 'DirectionColumn');
    case 'inlineBlock':
      return fromClassName('DisplayInlineBlock');
    case 'visuallyHidden':
      return fromClassName('DisplayVisuallyHidden');
    case false:
      return fromClassName('DisplayNone');
    default:
      /* block */
      return fromClassName('DisplayBlock');
  }
};
var column = range('Col');

var formatIntBoint = function formatIntBoint(x) {
  return x < 0 ? 'n' + Math.abs(x) : x.toString();
};

/*

It's preferable to put new properties into that object directly just so it's easier to read.

*/

var propToFn = {
  xs: function xs(value) {
    if (!value) {
      return identity();
    }
    return mapClassName(function (c) {
      return styles[c];
    })(prefix('xs')(concat([value.column ? column(value.column) : identity(), typeof value.display !== 'undefined' ? display(value.display) : identity()])));
  },
  sm: function sm(value) {
    if (!value) {
      return identity();
    }
    return mapClassName(function (c) {
      return styles[c];
    })(prefix('sm')(concat([value.column ? column(value.column) : identity(), typeof value.display !== 'undefined' ? display(value.display) : identity()])));
  },
  md: function md(value) {
    if (!value) {
      return identity();
    }
    return mapClassName(function (c) {
      return styles[c];
    })(prefix('md')(concat([value.column ? column(value.column) : identity(), typeof value.display !== 'undefined' ? display(value.display) : identity()])));
  },
  lg: function lg(value) {
    if (!value) {
      return identity();
    }
    return mapClassName(function (c) {
      return styles[c];
    })(prefix('lg')(concat([value.column ? column(value.column) : identity(), typeof value.display !== 'undefined' ? display(value.display) : identity()])));
  },

  display: mapping({
    none: styles.xsDisplayNone,
    flex: styles.xsDisplayFlex,
    block: styles.xsDisplayBlock,
    inlineBlock: styles.xsDisplayInlineBlock,
    visuallyHidden: styles.xsDisplayVisuallyHidden
  }),
  column: bind(range('xsCol'), styles),
  direction: mapping({
    row: styles.xsDirectionRow,
    column: styles.xsDirectionColumn
  }),

  smDisplay: mapping({
    none: styles.smDisplayNone,
    flex: styles.smDisplayFlex,
    block: styles.smDisplayBlock,
    inlineBlock: styles.smDisplayInlineBlock,
    visuallyHidden: styles.smDisplayVisuallyHidden
  }),
  smColumn: bind(range('smCol'), styles),
  smDirection: mapping({
    row: styles.smDirectionRow,
    column: styles.smDirectionColumn
  }),

  mdDisplay: mapping({
    none: styles.mdDisplayNone,
    flex: styles.mdDisplayFlex,
    block: styles.mdDisplayBlock,
    inlineBlock: styles.mdDisplayInlineBlock,
    visuallyHidden: styles.mdDisplayVisuallyHidden
  }),
  mdColumn: bind(range('mdCol'), styles),
  mdDirection: mapping({
    row: styles.mdDirectionRow,
    column: styles.mdDirectionColumn
  }),

  lgDisplay: mapping({
    none: styles.lgDisplayNone,
    flex: styles.lgDisplayFlex,
    block: styles.lgDisplayBlock,
    inlineBlock: styles.lgDisplayInlineBlock,
    visuallyHidden: styles.lgDisplayVisuallyHidden
  }),
  lgColumn: bind(range('lgCol'), styles),
  lgDirection: mapping({
    row: styles.lgDirectionRow,
    column: styles.lgDirectionColumn
  }),

  alignContent: mapping({
    start: layout.contentStart,
    end: layout.contentEnd,
    center: layout.contentCenter,
    between: layout.contentBetween,
    around: layout.contentAround
    // default: stretch
  }),
  alignItems: mapping({
    start: layout.itemsStart,
    end: layout.itemsEnd,
    center: layout.itemsCenter,
    baseline: layout.itemsBaseline
    // default: stretch
  }),
  alignSelf: mapping({
    start: layout.selfStart,
    end: layout.selfEnd,
    center: layout.selfCenter,
    baseline: layout.selfBaseline,
    stretch: layout.selfStretch
    // default: auto
  }),
  bottom: toggle(layout.bottom0),
  color: mapping({
    blue: colors.blueBg,
    darkGray: colors.darkGrayBg,
    pine: colors.pineBg,
    gray: colors.grayBg,
    red: colors.redBg,
    olive: colors.oliveBg,
    lightGray: colors.lightGrayBg,
    white: colors.whiteBg,
    orange: colors.orangeBg,
    green: colors.greenBg,
    navy: colors.navyBg,
    midnight: colors.midnightBg,
    purple: colors.purpleBg,
    orchid: colors.orchidBg,
    eggplant: colors.eggplantBg,
    maroon: colors.maroonBg,
    watermelon: colors.watermelonBg,
    lightWash: colors.lightWashBg,
    darkWash: colors.darkWashBg
    // default: transparent
  }),
  fit: toggle(layout.fit),
  flex: mapping({
    grow: layout.flexGrow,
    none: layout.flexNone
    // default: shrink
  }),
  height: function (_height) {
    function height(_x) {
      return _height.apply(this, arguments);
    }

    height.toString = function () {
      return _height.toString();
    };

    return height;
  }(function (height) {
    return fromInlineStyle({ height: height });
  }),
  justifyContent: mapping({
    end: layout.justifyEnd,
    center: layout.justifyCenter,
    between: layout.justifyBetween,
    around: layout.justifyAround
    // default: start
  }),
  left: toggle(layout.left0),
  deprecatedMargin: function deprecatedMargin(value) {
    var mt = identity();
    var mb = identity();
    var ml = identity();
    var mr = identity();
    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'number':
        return fromClassName(whitespaceLegacy['m' + formatIntBoint(value)]);
      case 'object':
        if (value.top) {
          mt = fromClassName(whitespaceLegacy['mt' + formatIntBoint(value.top)]);
        }

        if (value.bottom) {
          mb = fromClassName(whitespaceLegacy['mb' + formatIntBoint(value.bottom)]);
        }

        if (value.left) {
          ml = fromClassName(value.left === 'auto' ? whitespaceLegacy.mlAuto : whitespaceLegacy['ml' + formatIntBoint(value.left)]);
        }

        if (value.right) {
          mr = fromClassName(value.right === 'auto' ? whitespaceLegacy.mrAuto : whitespaceLegacy['mr' + formatIntBoint(value.right)]);
        }
        return concat([mt, mb, ml, mr]);
      default:
        return identity();
    }
  },
  marginStart: marginStart,
  marginEnd: marginEnd,
  margin: margin,
  marginTop: marginTop,
  marginRight: marginRight,
  marginBottom: marginBottom,
  marginLeft: marginLeft,
  smMargin: smMargin,
  smMarginTop: smMarginTop,
  smMarginRight: smMarginRight,
  smMarginBottom: smMarginBottom,
  smMarginLeft: smMarginLeft,
  mdMargin: mdMargin,
  mdMarginTop: mdMarginTop,
  mdMarginRight: mdMarginRight,
  mdMarginBottom: mdMarginBottom,
  mdMarginLeft: mdMarginLeft,
  lgMargin: lgMargin,
  lgMarginTop: lgMarginTop,
  lgMarginRight: lgMarginRight,
  lgMarginBottom: lgMarginBottom,
  lgMarginLeft: lgMarginLeft,
  maxHeight: function (_maxHeight) {
    function maxHeight(_x2) {
      return _maxHeight.apply(this, arguments);
    }

    maxHeight.toString = function () {
      return _maxHeight.toString();
    };

    return maxHeight;
  }(function (maxHeight) {
    return fromInlineStyle({ maxHeight: maxHeight });
  }),
  maxWidth: function (_maxWidth) {
    function maxWidth(_x3) {
      return _maxWidth.apply(this, arguments);
    }

    maxWidth.toString = function () {
      return _maxWidth.toString();
    };

    return maxWidth;
  }(function (maxWidth) {
    return fromInlineStyle({ maxWidth: maxWidth });
  }),
  minHeight: function (_minHeight) {
    function minHeight(_x4) {
      return _minHeight.apply(this, arguments);
    }

    minHeight.toString = function () {
      return _minHeight.toString();
    };

    return minHeight;
  }(function (minHeight) {
    return fromInlineStyle({ minHeight: minHeight });
  }),
  minWidth: function (_minWidth) {
    function minWidth(_x5) {
      return _minWidth.apply(this, arguments);
    }

    minWidth.toString = function () {
      return _minWidth.toString();
    };

    return minWidth;
  }(function (minWidth) {
    return fromInlineStyle({ minWidth: minWidth });
  }),
  overflow: mapping({
    hidden: layout.overflowHidden,
    scroll: layout.overflowScroll,
    auto: layout.overflowAuto,
    scrollX: layout.overflowScrollX,
    scrollY: layout.overflowScrollY
    // default: visible
  }),
  deprecatedPadding: function deprecatedPadding(value) {
    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'number':
        return fromClassName(whitespaceLegacy['p' + value]);
      case 'object':
        return concat([value.x ? fromClassName(whitespaceLegacy['px' + value.x]) : identity(), value.y ? fromClassName(whitespaceLegacy['py' + value.y]) : identity()]);
      default:
        return identity();
    }
  },
  padding: padding,
  paddingX: paddingX,
  paddingY: paddingY,
  smPadding: smPadding,
  smPaddingX: smPaddingX,
  smPaddingY: smPaddingY,
  mdPadding: mdPadding,
  mdPaddingX: mdPaddingX,
  mdPaddingY: mdPaddingY,
  lgPadding: lgPadding,
  lgPaddingX: lgPaddingX,
  lgPaddingY: lgPaddingY,
  position: mapping({
    absolute: layout.absolute,
    relative: layout.relative,
    fixed: layout.fixed
    // default: static
  }),
  right: toggle(layout.right0),
  shape: mapping({
    circle: borders.circle,
    pill: borders.pill,
    rounded: borders.rounded,
    roundedBottom: borders.roundedBottom,
    roundedLeft: borders.roundedLeft,
    roundedRight: borders.roundedRight,
    roundedTop: borders.roundedTop
    // default: square
  }),
  top: toggle(layout.top0),
  width: function (_width) {
    function width(_x6) {
      return _width.apply(this, arguments);
    }

    width.toString = function () {
      return _width.toString();
    };

    return width;
  }(function (width) {
    return fromInlineStyle({ width: width });
  }),
  wrap: toggle(layout.flexWrap),
  dangerouslySetInlineStyle: function dangerouslySetInlineStyle(value) {
    return (
      /* eslint-disable-next-line no-underscore-dangle */
      value && value.__style ? fromInlineStyle(value.__style) : identity()
    );
  }
};

/*

# The Component

*/

var contains = function contains(key, arr) {
  return arr.indexOf(key) >= 0;
};
var omit = function omit(keys, obj) {
  return Object.keys(obj).reduce(function (acc, k) {
    if (contains(k, keys)) {
      return acc;
    }
    return _extends({}, acc, defineProperty({}, k, obj[k]));
  }, {});
};

function Box(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties(_ref, ['children']);

  // Flow can't reason about the constant nature of Object.keys so we can't use
  // a functional (reduce) style here.

  // Box is a "pass-through" component, meaning that if you pass properties to
  // it that it doesn't know about (`aria-label` for instance) it passes
  // directly back to the underlying `<div/>`. That's generally useful, but
  // we'd also like to strip out a few naughty properties that break style
  // encapsulation (className, style) or accessibility (onClick).
  var blacklist = ['onClick', 'className', 'style'];

  // All Box's are box-sized by default, so we start off building up the styles
  // to be applied with a Box base class.
  var s = fromClassName(styles.box);

  // This loops through each property and if it exists in the previously
  // defined transform map, concatentes the resulting styles to the base
  // styles. If there's a match, we also don't pass through that property. This
  // means Box's runtime is only dependent on the number of properties passed
  // to it (which is typically small) instead of the total number of possible
  // properties (~30 or so). While it may ~feel~ like Box is innefficient, its
  // biggest performance impact is on startup time because there's so much code
  // here.

  // eslint-disable-next-line no-restricted-syntax
  for (var prop in props) {
    if (Object.prototype.hasOwnProperty.call(propToFn, prop)) {
      var fn = propToFn[prop];
      var value = props[prop];
      blacklist = blacklist.concat(prop);
      s = concat([s, fn(value)]);
    }
  }

  // And... magic!
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    _extends({}, omit(blacklist, props), toProps(s)),
    children
  );
}

/*

# PropTypes

And we're done here :)

*/

var ColumnPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

var MarginPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([-12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

var PaddingPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

Box.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  dangerouslySetInlineStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    __style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),

  xs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['flex', 'flexColumn', 'inlineBlock'])]),
    column: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  sm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['flex', 'flexColumn', 'inlineBlock'])]),
    column: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  md: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['flex', 'flexColumn', 'inlineBlock'])]),
    column: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  lg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['flex', 'flexColumn', 'inlineBlock'])]),
    column: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  deprecatedMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto'])]),
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto'])])
  })]),
  deprecatedPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })]),

  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['none', 'flex', 'block', 'inlineBlock', 'visuallyHidden']),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['row', 'column']),
  column: ColumnPropType,

  smDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['none', 'flex', 'block', 'inlineBlock', 'visuallyHidden']),
  smDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['row', 'column']),
  smColumn: ColumnPropType,

  mdDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['none', 'flex', 'block', 'inlineBlock', 'visuallyHidden']),
  mdDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['row', 'column']),
  mdColumn: ColumnPropType,

  lgDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['none', 'flex', 'block', 'inlineBlock', 'visuallyHidden']),
  lgDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['row', 'column']),
  lgColumn: ColumnPropType,

  alignContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'end', 'center', 'between', 'around', 'stretch']),
  alignItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'end', 'center', 'baseline', 'stretch']),
  alignSelf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'start', 'end', 'center', 'baseline', 'stretch']),
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'darkGray', 'darkWash', 'eggplant', 'gray', 'green', 'lightGray', 'lightWash', 'maroon', 'midnight', 'navy', 'olive', 'orange', 'orchid', 'pine', 'purple', 'red', 'transparent', 'watermelon', 'white']),
  fit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['grow', 'shrink', 'none']),
  grow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  justifyContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'end', 'center', 'between', 'around']),
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  marginStart: MarginPropType,
  marginEnd: MarginPropType,

  margin: MarginPropType,
  marginTop: MarginPropType,
  marginRight: MarginPropType,
  marginBottom: MarginPropType,
  marginLeft: MarginPropType,

  smMargin: MarginPropType,
  smMarginTop: MarginPropType,
  smMarginRight: MarginPropType,
  smMarginBottom: MarginPropType,
  smMarginLeft: MarginPropType,

  mdMargin: MarginPropType,
  mdMarginTop: MarginPropType,
  mdMarginRight: MarginPropType,
  mdMarginBottom: MarginPropType,
  mdMarginLeft: MarginPropType,

  lgMargin: MarginPropType,
  lgMarginTop: MarginPropType,
  lgMarginRight: MarginPropType,
  lgMarginBottom: MarginPropType,
  lgMarginLeft: MarginPropType,

  maxHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  maxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  minHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  minWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  overflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['visible', 'hidden', 'scroll', 'scrollX', 'scrollY', 'auto']),

  padding: PaddingPropType,
  paddingX: PaddingPropType,
  paddingY: PaddingPropType,

  smPadding: PaddingPropType,
  smPaddingX: PaddingPropType,
  smPaddingY: PaddingPropType,

  mdPadding: PaddingPropType,
  mdPaddingX: PaddingPropType,
  mdPaddingY: PaddingPropType,

  lgPadding: PaddingPropType,
  lgPaddingX: PaddingPropType,
  lgPaddingY: PaddingPropType,

  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static', 'absolute', 'relative', 'fixed']),
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shape: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['square', 'rounded', 'pill', 'circle', 'roundedTop', 'roundedBottom', 'roundedLeft', 'roundedRight']),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var styles$1 = { "icon": "_s1", "iconBlock": "_s2 _29" };

var add = 'M22 10h-8V2a2 2 0 0 0-4 0v8H2a2 2 0 0 0 0 4h8v8a2 2 0 0 0 4 0v-8h8a2 2 0 0 0 0-4';

var addCircle = 'M17.75 13.25h-4.5v4.5a1.25 1.25 0 0 1-2.5 0v-4.5h-4.5a1.25 1.25 0 0 1 0-2.5h4.5v-4.5a1.25 1.25 0 0 1 2.5 0v4.5h4.5a1.25 1.25 0 0 1 0 2.5M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0';

var addPin = 'M21.5 8.69c1.49.87 2.5 2.46 2.5 4.31h-4v7.96L19 23l-1-2.04V13h-4c0-1.85 1.01-3.44 2.5-4.31V2.93c-.86-.22-1.5-1-1.5-1.93h8c0 .93-.64 1.71-1.5 1.93v5.76zm-11.25.81a1.25 1.25 0 0 1 0 2.5H7v3.25a1.25 1.25 0 0 1-2.5 0V12H1.25a1.25 1.25 0 0 1 0-2.5H4.5V6.25a1.25 1.25 0 0 1 2.5 0V9.5h3.25z';

var angledPin = 'M13.988,19.153 C15.485,17.656 15.985,15.446 15.481,13.537 L19.740,9.074 L22.662,8.807 L22.645,8.789 C22.739,8.804 22.837,8.780 22.909,8.708 C23.030,8.587 23.031,8.391 22.910,8.271 L15.730,1.090 C15.609,0.970 15.413,0.970 15.292,1.091 C15.220,1.163 15.197,1.262 15.211,1.356 L15.194,1.338 L14.927,4.261 L10.463,8.520 C8.554,8.015 6.344,8.516 4.847,10.012 L8.656,13.821 L3.324,19.153 C2.562,19.915 0.711,22.108 1.039,22.962 C1.892,23.290 4.086,21.438 4.847,20.676 C5.609,19.915 10.179,15.344 10.179,15.344 L13.988,19.153 Z';

var arrowBack = 'M17.28 24c-.57 0-1.14-.22-1.58-.66L4.5 12 15.7.66a2.21 2.21 0 0 1 3.15 0c.87.88.87 2.3 0 3.18L10.79 12l8.06 8.16c.87.88.87 2.3 0 3.18-.44.44-1 .66-1.57.66';

var arrowCircleForward = 'M12.94 16.07c-.49.48-1.28.48-1.77 0a1.25 1.25 0 0 1 0-1.77l1.06-1.07H8.25a1.25 1.25 0 0 1 0-2.5h3.95L11.17 9.7a1.25 1.25 0 0 1 0-1.77c.49-.48 1.28-.48 1.77 0L17 12l-4.06 4.07zM12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0z';

var arrowCircleDown = 'M0 12c0 6.63 5.37 12 12 12s12-5.37 12-12S18.63 0 12 0 0 5.37 0 12zm10.77-3.75a1.25 1.25 0 0 1 2.5 0v3.95l1.03-1.03a1.25 1.25 0 0 1 1.77 0c.48.49.48 1.28 0 1.77L12 17l-4.07-4.06c-.48-.49-.48-1.28 0-1.77a1.25 1.25 0 0 1 1.77 0l1.07 1.06V8.25z';

var arrowDown = 'M12 19.5L.66 8.29c-.88-.86-.88-2.27 0-3.14.88-.87 2.3-.87 3.18 0L12 13.21l8.16-8.06c.88-.87 2.3-.87 3.18 0 .88.87.88 2.28 0 3.14L12 19.5z';

var arrowForward = 'M6.72 24c.57 0 1.14-.22 1.57-.66L19.5 12 8.29.66c-.86-.88-2.27-.88-3.14 0-.87.88-.87 2.3 0 3.18L13.21 12l-8.06 8.16c-.87.88-.87 2.3 0 3.18.43.44 1 .66 1.57.66';

var arrowUp = 'M21.75 19.5c-.58 0-1.15-.22-1.59-.65L12 10.79l-8.16 8.06c-.88.87-2.3.87-3.18 0a2.21 2.21 0 0 1 0-3.15L12 4.5l11.34 11.2c.88.87.88 2.28 0 3.15-.44.43-1.01.65-1.59.65';

var arrowUpRight = 'M4.9283,1 C3.6273,1 2.5713,2.054 2.5713,3.357 C2.5713,4.66 3.6273,5.714 4.9283,5.714 L14.9523,5.714 L1.6893,18.976 C0.7703,19.896 0.7703,21.389 1.6893,22.31 C2.1503,22.771 2.7533,23 3.3573,23 C3.9603,23 4.5633,22.771 5.0243,22.31 L18.2853,9.047 L18.2853,19.071 C18.2853,20.374 19.3413,21.429 20.6433,21.429 C21.9443,21.429 23.0003,20.374 23.0003,19.071 L23.0003,1 L4.9283,1 Z';

var bell = 'M12 24c-1.66 0-3-1.34-3-3h6c0 1.66-1.34 3-3 3zm7-10.83c1.58 1.52 2.67 3.55 3 5.83H2c.33-2.28 1.42-4.31 3-5.83V7c0-3.87 3.13-7 7-7s7 3.13 7 7v6.17z';

var camera = 'M6.36 4.99L8.56 2h6.88l2.2 2.99h3.09c1.8 0 3.27 1.49 3.27 3.33v10.35c0 1.84-1.47 3.33-3.27 3.33H3.27C1.47 22 0 20.51 0 18.67V8.32c0-1.84 1.47-3.33 3.27-3.33h3.09zM12 7.22a5.74 5.74 0 1 0 0 11.48 5.74 5.74 0 0 0 0-11.48m0 2.73c1.66 0 3.01 1.35 3.01 3.01 0 1.66-1.35 3.01-3.01 3.01-1.66 0-3.01-1.35-3.01-3.01 0-1.66 1.35-3.01 3.01-3.01';

var cancel = 'M15.18 12l7.16-7.16c.88-.88.88-2.3 0-3.18-.88-.88-2.3-.88-3.18 0L12 8.82 4.84 1.66c-.88-.88-2.3-.88-3.18 0-.88.88-.88 2.3 0 3.18L8.82 12l-7.16 7.16c-.88.88-.88 2.3 0 3.18.44.44 1.01.66 1.59.66.58 0 1.15-.22 1.59-.66L12 15.18l7.16 7.16c.44.44 1.01.66 1.59.66.58 0 1.15-.22 1.59-.66.88-.88.88-2.3 0-3.18L15.18 12z';

var check = 'M9.17 21.75L.73 12.79c-.97-1.04-.97-2.71 0-3.75a2.403 2.403 0 0 1 3.53 0l4.91 5.22L19.74 3.03c.98-1.04 2.55-1.04 3.53 0 .97 1.03.97 2.71 0 3.74L9.17 21.75z';

var checkCircle = 'M18.88 9.88l-8.66 8.67-5.12-5.13a1.25 1.25 0 0 1 0-1.77c.48-.49 1.28-.49 1.76 0l3.36 3.36 6.9-6.89c.49-.49 1.28-.49 1.76 0 .49.49.49 1.28 0 1.76M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0';

var circleOutline = 'M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22.2C6.45 22.2 1.8 17.7 1.8 12 1.8 6.3 6.3 1.8 12 1.8c5.7 0 10.2 4.5 10.2 10.2 0 5.7-4.65 10.2-10.2 10.2z';

var clear = 'M15.18 16.95L12 13.77l-3.18 3.18c-.49.49-1.28.49-1.77 0a1.25 1.25 0 0 1 0-1.77L10.23 12 7.05 8.82a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0L12 10.23l3.18-3.18a1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.77L13.77 12l3.18 3.18c.49.49.49 1.28 0 1.77s-1.28.49-1.77 0M24 12c0-6.63-5.37-12-12-12S0 5.37 0 12s5.37 12 12 12 12-5.37 12-12';

var clock = 'M17.83 17.83c-.37.36-.85.55-1.33.55-.48 0-.96-.19-1.33-.55l-5.04-5.05V6c0-1.04.83-1.87 1.87-1.87s1.88.83 1.88 1.87v5.22l3.95 3.95c.73.74.73 1.92 0 2.66M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0';

var cog = 'M12 15.95c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zM12 .5L2 6.25v11.5l10 5.75 10-5.75V6.25L12 .5z';

var compass = 'M12.868 12.9A1.25 1.25 0 1 0 11.1 11.13a1.25 1.25 0 0 0 1.77 1.768m2.268 1.134c-.207.517-.62.924-1.139 1.124L5.62 18.38l3.223-8.377c.2-.52.607-.933 1.124-1.139l8.617-3.447-3.447 8.617zm5.348-10.519c-4.686-4.686-12.284-4.686-16.97 0-4.687 4.687-4.687 12.285 0 16.971 4.686 4.686 12.284 4.686 16.97 0 4.686-4.686 4.686-12.284 0-16.97z';

var dash = 'M20 16H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h16c2.2 0 4 1.8 4 4s-1.8 4-4 4';

var edit = 'M13.386 6.018l4.596 4.596L7.097 21.499 1 22.999l1.501-6.096L13.386 6.018zm8.662-4.066a3.248 3.248 0 0 1 0 4.596L19.75 8.848 15.154 4.25l2.298-2.299a3.248 3.248 0 0 1 4.596 0z';

var ellipsis = 'M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3M3 9c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm18 0c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z';

var ellipsisCircleOutline = 'M12 10.5c.9 0 1.5.6 1.5 1.5s-.6 1.5-1.5 1.5-1.5-.6-1.5-1.5.6-1.5 1.5-1.5zm-4.5 0c.9 0 1.5.6 1.5 1.5s-.6 1.5-1.5 1.5S6 12.9 6 12s.6-1.5 1.5-1.5zm9 0c.9 0 1.5.6 1.5 1.5s-.6 1.5-1.5 1.5S15 12.9 15 12s.6-1.5 1.5-1.5zM12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22.2C6.45 22.2 1.8 17.7 1.8 12 1.8 6.3 6.3 1.8 12 1.8c5.7 0 10.2 4.5 10.2 10.2 0 5.7-4.65 10.2-10.2 10.2z';

var envelope = 'M21.53 7.508l-7.586 7.452c-.536.526-1.24.79-1.944.79a2.77 2.77 0 0 1-1.945-.79L2.47 7.508a.728.728 0 0 1 0-1.043.76.76 0 0 1 1.061 0l7.586 7.452c.487.48 1.28.48 1.768 0l7.585-7.452a.76.76 0 0 1 1.061 0 .728.728 0 0 1 0 1.043zM1 19h22V5H1v14z';

var eye = 'M10,12 C10,13.105 10.895,14 12,14 C13.105,14 14,13.105 14,12 C14,10.895 13.105,10 12,10 C10.895,10 10,10.895 10,12 Z M12,17 C9.239,17 7,14.761 7,12 C7,9.239 9.239,7 12,7 C14.761,7 17,9.239 17,12 C17,14.761 14.761,17 12,17 M12,3.5 C6.455,3.5 1.751,7.051 0,12 C1.751,16.949 6.455,20.5 12,20.5 C17.545,20.5 22.249,16.949 24,12 C22.249,7.051 17.545,3.5 12,3.5';

var facebook = 'M17.75 3.984l-2.312.001c-1.811 0-2.163.842-2.163 2.077v2.724h4.323l-.563 4.267h-3.76V24H8.769V13.053H5V8.786h3.769V5.64C8.769 1.988 11.05 0 14.383 0c1.596 0 2.967.116 3.367.168v3.816z';

var faceHappy = 'M12.023 20.713c-2.944 0-5.378-1.96-5.356-4.906.017-2.117 1.728-.536 5.33-.545 3.6-.01 5.322-1.645 5.327.548.007 2.946-2.356 4.903-5.3 4.903m4.439-9.83a1.675 1.675 0 1 1 0-3.351 1.675 1.675 0 0 1 0 3.35M6.093 9.207a1.675 1.675 0 1 1 3.35 0 1.675 1.675 0 0 1-3.35 0m17.906 2.782C23.994 5.367 18.623 0 12 0 5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12C18.624 24 23.995 18.633 24 12.01L24 12l-.001-.01';

var faceSad = 'M17.088 17.841a1.2 1.2 0 0 1-1.593.58 4.517 4.517 0 0 0-.744-.217c-.738-.168-1.653-.27-2.75-.271-1.098 0-2.012.103-2.752.27-.411.094-.657.18-.741.217a1.199 1.199 0 1 1-1.014-2.174c.237-.11.643-.251 1.223-.383.915-.207 2.008-.33 3.284-.33 1.276.001 2.369.123 3.281.33.582.132.988.273 1.226.384.601.279.86.992.58 1.594zm-.624-6.959a1.675 1.675 0 1 1 0-3.35 1.675 1.675 0 0 1 0 3.35zM6.093 9.207a1.675 1.675 0 1 1 3.35 0 1.675 1.675 0 0 1-3.35 0zM24 11.989C23.995 5.367 18.624 0 12.002 0 5.373 0 0 5.373 0 12c0 6.628 5.373 12 12.002 12C18.623 24 23.995 18.633 24 12.01v-.02z';

var faceSmiley = 'M16.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m.449 5.95A6.947 6.947 0 0 1 12 19a6.96 6.96 0 0 1-4.948-2.048.999.999 0 0 1 0-1.414.999.999 0 0 1 1.414-.001A4.968 4.968 0 0 0 12 17c1.336 0 2.592-.52 3.535-1.464a1 1 0 0 1 1.414 1.414M6 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0';

var filter = 'M24 3.5c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2 0 .55.22 1.05.58 1.41L9 13.46v9.04l6-2v-7.05l8.37-8.5c.39-.36.63-.88.63-1.45';

var flag = 'M17 7.5L22 0H2v22c0 1.1.9 2 2 2s2-.9 2-2v-7h16l-5-7.5z';

var flashlight = 'M6 7.08V10H1V7.08A6.086 6.086 0 0 1 7.079 1H10v5H6v1.08zM6 18h4v5H7.079A6.086 6.086 0 0 1 1 16.921V14h5v4zM16.92 1A6.086 6.086 0 0 1 23 7.079V10h-5V6h-4V1h2.92zM18 16.92V14h5v2.92A6.086 6.086 0 0 1 16.921 23H14v-5h4v-1.08z';

var gif = 'M19.5 3h-15C2.02 3 0 5.03 0 7.5v9C0 18.98 2.02 21 4.5 21h15c2.47 0 4.5-2.02 4.5-4.5v-9C24 5.03 21.97 3 19.5 3zm-7.41 12.88v-7.8h1.59v7.8h-1.59zm3.45-7.8h5.58v1.34h-4v1.88h3.39v1.35h-3.39v3.23h-1.58v-7.8zm-11.4 6.83c-.33-.37-.58-.79-.76-1.28-.17-.49-.26-1.03-.26-1.62 0-.66.11-1.26.33-1.8.22-.55.53-1.01.95-1.39.32-.29.68-.51 1.1-.66.41-.15.88-.23 1.4-.23.49 0 .93.06 1.32.19s.72.31 1 .54c.27.23.5.51.67.83.17.32.29.67.35 1.04H8.69a1.67 1.67 0 0 0-.56-.93c-.29-.24-.69-.36-1.19-.36-.37 0-.7.07-.97.21-.27.14-.5.34-.69.59-.18.25-.32.54-.41.88-.09.34-.13.7-.13 1.09 0 .4.05.77.15 1.1.1.34.25.63.43.88.19.24.42.43.69.57.27.14.57.21.9.21.31 0 .59-.05.83-.16.25-.1.46-.23.64-.4.17-.17.31-.36.4-.57.1-.21.14-.42.14-.64v-.04H7.05v-1.22h3.28v4.14H9.14l-.05-1.05h-.03c-.27.45-.58.77-.94.94a2.8 2.8 0 0 1-1.25.27c-.59 0-1.11-.1-1.56-.3-.46-.2-.85-.48-1.17-.83z';

var globe = 'M15.49 20.83c.87-2.01 1.37-4.75 1.48-7.58h4.44a9.53 9.53 0 0 1-5.92 7.58zm-12.9-7.58h4.44c.11 2.83.61 5.57 1.49 7.58-3.15-1.25-5.47-4.12-5.93-7.58zM8.52 3.17c-.88 2.01-1.38 4.75-1.49 7.58H2.59c.46-3.46 2.78-6.33 5.93-7.58zm1.01 7.58C9.76 5.43 11.4 2.54 12 2.5h.01c.67.06 2.24 3.01 2.46 8.25H9.53zm2.48 10.75H12c-.6-.04-2.24-2.93-2.47-8.25h4.94c-.22 5.24-1.79 8.19-2.46 8.25zm9.4-10.75h-4.44c-.11-2.83-.61-5.57-1.48-7.58a9.53 9.53 0 0 1 5.92 7.58zM24 12C24 5.39 18.62.01 12.01 0H12C5.38 0 0 5.38 0 12s5.38 12 12 12h.01C18.62 24 24 18.61 24 12z';

var globeChecked = 'M6.8 9.8H3.1C3.5 7 5.4 4.6 8 3.6c-.7 1.7-1.1 3.9-1.2 6.2m-3.7 2.1h3.7c.1 2.3.5 4.6 1.2 6.2-2.6-1-4.5-3.3-4.9-6.2m7.8-8.8c.5 0 1.8 2.4 2 6.7H8.8c.2-4.3 1.6-6.7 2.1-6.7M9.5 16.3c-.3-1.1-.6-2.6-.7-4.4h2.7c.9-1 2.1-1.7 3.5-2.1-.1-2.3-.5-4.5-1.3-6.2 2.6 1 4.4 3.3 4.9 6.1.7.1 1.5.4 2.1.8-.2-5.3-4.5-9.5-9.8-9.5C5.4 1 1 5.4 1 10.9c0 5.3 4.2 9.6 9.5 9.8-.6-1.1-1-2.3-1-3.7v-.7m10.8-.5L16.2 20l-2.5-2.5c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1 0l1.5 1.5 3.1-3.2c.2-.3.7-.3 1 0 .3.3.3.8 0 1.1M17 11c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6';

var gmail = 'M3.173 4L12 10.194 20.556 4H3.173zM12 13.29L1 5.806V20h22V5.548L12 13.29z';

var googlePlus = 'M7 11v2.4h3.97c-.16 1.029-1.2 3.02-3.97 3.02-2.39 0-4.34-1.979-4.34-4.42 0-2.44 1.95-4.42 4.34-4.42 1.36 0 2.27.58 2.79 1.08l1.9-1.83C10.47 5.69 8.89 5 7 5c-3.87 0-7 3.13-7 7s3.13 7 7 7c4.04 0 6.721-2.84 6.721-6.84 0-.46-.051-.81-.111-1.16H7zm17 0v2h-3v3h-2v-3h-3v-2h3V8h2v3h3z';

var graphBar = 'M1 23V10h5v13H1zm8.5 0V1h5v22h-5zm8.5 0V7h4.999v16H18z';

var knoop = 'M15 10.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m0 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m-6-6c-.83 0-1.5-.67-1.5-1.5S8.17 7.5 9 7.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5m0 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0';

var lightbulb = 'M20 8c0 2.23-.91 4.24-2.39 5.7h.02c-.99.97-1.6 2.31-1.63 3.8V19H8v-1.5c-.03-1.5-.65-2.85-1.64-3.83A7.955 7.955 0 0 1 4 8c0-4.42 3.58-8 8-8s8 3.58 8 8zM8 22.5V21h8v1.5c0 .83-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z';

var handle = 'M3 15h18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-4h18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-4h18a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2z';

var handPointing = 'M17.776,22.390 C13.775,23.978 9.246,22.359 7.219,18.770 C7.040,18.503 6.860,18.218 6.688,17.910 C5.132,15.163 3.028,13.782 2.588,13.581 C2.149,13.378 0.595,12.613 1.100,11.692 C1.381,11.180 2.163,10.801 2.878,10.726 C4.000,10.481 5.897,11.034 7.772,12.222 L4.054,3.419 C3.741,2.677 3.989,1.850 4.609,1.379 C4.612,1.376 4.616,1.373 4.621,1.369 C4.676,1.327 4.734,1.289 4.796,1.253 C4.810,1.247 4.821,1.239 4.835,1.231 C4.901,1.195 4.970,1.160 5.042,1.132 C5.044,1.131 5.044,1.131 5.045,1.131 C5.045,1.131 5.045,1.131 5.047,1.129 C5.119,1.101 5.193,1.079 5.267,1.060 C5.281,1.057 5.295,1.054 5.309,1.049 C5.380,1.035 5.449,1.021 5.518,1.013 C5.525,1.013 5.529,1.011 5.534,1.011 C6.317,0.928 7.093,1.347 7.406,2.088 L9.592,7.261 C9.643,6.623 10.055,6.035 10.709,5.776 C11.633,5.410 12.689,5.839 13.069,6.734 C13.071,6.742 13.074,6.752 13.077,6.759 C13.143,6.136 13.552,5.565 14.191,5.312 C15.117,4.946 16.173,5.373 16.551,6.271 C16.567,6.305 16.578,6.341 16.591,6.379 C16.680,5.784 17.079,5.249 17.695,5.006 C18.619,4.640 19.619,4.970 19.999,5.867 L20.001,5.872 C20.001,5.872 21.115,8.039 22.366,11.651 C22.413,11.791 22.457,11.931 22.495,12.072 C24.027,16.161 21.967,20.728 17.776,22.390';

var heart = 'M11.98 22.25L1.82 11.95C-.28 9.83-.65 6.4 1.18 4.03a5.763 5.763 0 0 1 8.7-.56l2.1 2.14 1.95-1.98c2.1-2.13 5.48-2.5 7.82-.65 2.8 2.23 2.99 6.35.55 8.82L11.98 22.25z';

var heartBroken = 'M11.98 22.25L1.82 11.95C-.28 9.83-.65 6.4 1.18 4.03a5.763 5.763 0 0 1 8.7-.56l2.1 2.14 1.95-1.98c2.1-2.13 5.48-2.5 7.82-.65 2.8 2.23 2.99 6.35.55 8.82L11.98 22.25zM15.3 9.54c.4-.4.4-1.06 0-1.46-.4-.4-1.05-.4-1.45 0L12 9.94l-1.85-1.86c-.4-.4-1.05-.4-1.45 0-.4.4-.4 1.06 0 1.46l1.85 1.86-1.85 1.86c-.4.4-.4 1.05 0 1.45.4.4 1.05.41 1.45 0L12 12.85l1.85 1.86c.4.41 1.05.41 1.45 0 .4-.4.4-1.05 0-1.45l-1.85-1.86 1.85-1.86z';

var link = 'M21 15.05c1.1 0 2 .9 2 2V21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h4a2 2 0 1 1 0 4H5v14h14v-1.95c0-1.1.9-2 2-2zM12 14c-.51 0-1.02-.2-1.41-.59-.79-.78-.79-2.04 0-2.82L16.16 5 14 5.01c-1.1 0-2-.9-2-2 0-1.11.89-2 2-2L20.99 1h2v2l.01 7a2 2 0 1 1-4 0V7.83l-5.59 5.58c-.39.39-.9.59-1.41.59z';

var location = 'M12 4.5c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m7.5 3C19.5 3.36 16.14 0 12 0 7.86 0 4.5 3.36 4.5 7.5c0 1.3.36 2.5.94 3.56H5.4L12 24l6.6-12.94h-.04c.58-1.06.94-2.26.94-3.56';

var lock = 'M8 10V7c0-2.206 1.794-4 4-4s4 1.794 4 4v3H8zm11 .017V7c0-3.86-3.141-7-7-7S5 3.14 5 7v3.017a8.698 8.698 0 0 0-1.75 5.233 8.75 8.75 0 1 0 17.5 0A8.698 8.698 0 0 0 19 10.017z';

var maximize = 'M11 2.25c0 .69-.56 1.25-1.25 1.25H5.268l5.366 5.366a1.25 1.25 0 0 1-1.768 1.768L3.5 5.268V9.75a1.25 1.25 0 0 1-2.5 0V1h8.75c.69 0 1.25.56 1.25 1.25zM21.75 13c.69 0 1.25.56 1.25 1.25V23h-8.75a1.25 1.25 0 0 1 0-2.5h4.482l-5.366-5.366a1.25 1.25 0 0 1 1.768-1.768l5.366 5.366V14.25c0-.69.56-1.25 1.25-1.25z';

var megaphone = 'M14 17.5c0 1.378-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 9 17.5V17h5v.5zm8.947-1.87L18.701 2.712a1.022 1.022 0 0 0-1.566-.521l-15.7 11.24c-.37.264-.525.744-.382 1.179l.551 1.678c.14.425.532.712.974.712H7v.5a4.5 4.5 0 0 0 9 0V17h5.973c.7 0 1.195-.696.974-1.37z';

var menu = 'M21.5 9.5c1.38 0 2.5 1.13 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5h-19C1.13 14.5 0 13.38 0 12c0-1.37 1.13-2.5 2.5-2.5h19zm-19-3C1.13 6.5 0 5.38 0 4c0-1.37 1.13-2.5 2.5-2.5h19C22.88 1.5 24 2.63 24 4a2.5 2.5 0 0 1-2.5 2.5h-19zm19 11c1.38 0 2.5 1.13 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5h-19C1.13 22.5 0 21.38 0 20c0-1.37 1.13-2.5 2.5-2.5h19z';

var minimize = 'M1 9.75c0-.69.56-1.25 1.25-1.25h4.482L1.366 3.134a1.25 1.25 0 0 1 1.768-1.768L8.5 6.732V2.25a1.25 1.25 0 0 1 2.5 0V11H2.25C1.56 11 1 10.44 1 9.75zM14.25 23c-.69 0-1.25-.56-1.25-1.25V13h8.75a1.25 1.25 0 0 1 0 2.5h-4.482l5.366 5.366a1.25 1.25 0 0 1-1.768 1.768L15.5 17.268v4.482c0 .69-.56 1.25-1.25 1.25z';

var move = 'M14.3 18.17a1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.76L12 24l-4.07-4.07c-.48-.48-.48-1.27 0-1.76a1.25 1.25 0 0 1 1.77 0l1.05 1.04v-3.96a1.25 1.25 0 0 1 2.5 0v3.96l1.05-1.04zm-9.51-4.92l1.04 1.05c.49.49.49 1.28 0 1.77-.48.48-1.28.48-1.76 0L0 12l4.07-4.07c.48-.48 1.28-.48 1.76 0 .49.49.49 1.28 0 1.77l-1.04 1.05h3.96a1.25 1.25 0 0 1 0 2.5H4.79zm15.14-5.32L24 12l-4.07 4.07c-.48.48-1.27.48-1.76 0a1.25 1.25 0 0 1 0-1.77l1.04-1.05h-3.96a1.25 1.25 0 0 1 0-2.5h3.96L18.17 9.7a1.25 1.25 0 0 1 0-1.77c.49-.48 1.28-.48 1.76 0zM9.7 5.83c-.49.49-1.28.49-1.77 0-.48-.49-.48-1.28 0-1.76L12 0l4.07 4.07c.49.48.49 1.27 0 1.76s-1.28.49-1.77 0l-1.05-1.04v3.96a1.25 1.25 0 0 1-2.5 0V4.79L9.7 5.83z';

var mute = 'M5.00,7.94 L5.00,7.96 L12.00,1.00 L12.00,23.00 L5.00,16.91 L5.00,16.94 L2.00,16.94 C0.90,16.94 0.00,16.04 0.00,14.94 L0.00,9.94 C0.00,8.83 0.90,7.94 2.00,7.94 L5.00,7.94 Z M23.63,14.12 C24.12,14.60 24.12,15.39 23.63,15.88 C23.15,16.37 22.35,16.37 21.87,15.88 L19.75,13.77 L17.63,15.88 C17.15,16.37 16.35,16.37 15.87,15.88 C15.38,15.39 15.38,14.60 15.87,14.12 L17.98,12.00 L15.87,9.88 C15.38,9.39 15.38,8.60 15.87,8.12 C16.35,7.63 17.15,7.63 17.63,8.12 L19.75,10.23 L21.86,8.12 C22.35,7.63 23.15,7.63 23.63,8.12 C24.12,8.60 24.12,9.40 23.63,9.88 L21.52,12.00 L23.63,14.12 Z';

var pause = 'M7 0c1.65 0 3 1.35 3 3v18c0 1.65-1.35 3-3 3s-3-1.35-3-3V3c0-1.65 1.35-3 3-3zm10 0c1.65 0 3 1.35 3 3v18c0 1.65-1.35 3-3 3s-3-1.35-3-3V3c0-1.65 1.35-3 3-3z';

var people = 'M8 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm10 3c3.314 0 6 2.713 6 6.061V22H0v-1.919C0 15.618 3.582 12 8 12c2.614 0 4.927 1.272 6.387 3.23A5.927 5.927 0 0 1 18 14zm0-1a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5z';

var person = 'M12 12c5.523 0 10 4.477 10 10v2H2v-2c0-5.523 4.477-10 10-10zm0-1a5.5 5.5 0 1 1 0-11 5.5 5.5 0 1 1 0 11z';

var personAdd = 'M16.5 12a7.5 7.5 0 0 1 7.5 7.5V21H9v-1.5a7.5 7.5 0 0 1 7.5-7.5zm0-1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-7.25 1H6.5v2.75a1.25 1.25 0 0 1-2.5 0V12H1.25a1.25 1.25 0 0 1 0-2.5H4V6.75a1.25 1.25 0 0 1 2.5 0V9.5h2.75a1.25 1.25 0 0 1 0 2.5z';

var pin = 'M18 13.5c0-2.22-1.21-4.15-3-5.19V2.45A2.5 2.5 0 0 0 17 0H7a2.5 2.5 0 0 0 2 2.45v5.86c-1.79 1.04-3 2.97-3 5.19h5v8.46L12 24l1-2.04V13.5h5z';

var pinHide = 'M9.13 6.37c.49.48.49 1.27 0 1.76l-2.61 2.62 2.61 2.62c.49.48.49 1.27 0 1.76-.48.49-1.27.49-1.76 0l-2.62-2.61-2.62 2.61c-.48.49-1.28.49-1.76 0-.49-.49-.49-1.28 0-1.76l2.61-2.62L.37 8.13c-.49-.49-.49-1.28 0-1.76.48-.49 1.28-.49 1.76 0l2.62 2.61 2.62-2.61c.49-.49 1.28-.49 1.76 0zM20.5 8.69c1.49.87 2.5 2.46 2.5 4.31h-4v7.96L18 23l-1-2.04V13h-4c0-1.85 1.01-3.44 2.5-4.31V2.93c-.86-.22-1.5-1-1.5-1.93h8c0 .93-.64 1.71-1.5 1.93v5.76z';

var pinterest = 'M0 12c0 5.123 3.211 9.497 7.73 11.218-.11-.937-.227-2.482.025-3.566.217-.932 1.401-5.938 1.401-5.938s-.357-.715-.357-1.774c0-1.66.962-2.9 2.161-2.9 1.02 0 1.512.765 1.512 1.682 0 1.025-.653 2.557-.99 3.978-.281 1.189.597 2.159 1.769 2.159 2.123 0 3.756-2.239 3.756-5.471 0-2.861-2.056-4.86-4.991-4.86-3.398 0-5.393 2.549-5.393 5.184 0 1.027.395 2.127.889 2.726a.36.36 0 0 1 .083.343c-.091.378-.293 1.189-.332 1.355-.053.218-.173.265-.4.159-1.492-.694-2.424-2.875-2.424-4.627 0-3.769 2.737-7.229 7.892-7.229 4.144 0 7.365 2.953 7.365 6.899 0 4.117-2.595 7.431-6.199 7.431-1.211 0-2.348-.63-2.738-1.373 0 0-.599 2.282-.744 2.84-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12';

var play = 'M20.62 9.48L6.63.48C4.63-.8 2 .63 2 3v18c0 2.37 2.63 3.8 4.63 2.52l13.99-9c1.84-1.18 1.84-3.86 0-5.04';

var questionMark = 'M14.34 21.2c0 1.57-1.19 2.8-2.78 2.8-1.58 0-2.77-1.23-2.77-2.8 0-1.57 1.19-2.8 2.77-2.8 1.59 0 2.78 1.23 2.78 2.8m-2.53-10.88c1.41-1.23 3.3-2.05 3.3-3.87 0-1.45-1.24-2.36-2.95-2.36-2.12 0-3.52 1.48-3.55 3.43H3.75C3.88 3.3 6.96 0 12.34 0c4.86 0 7.91 2.52 7.91 6.32 0 2.36-1.09 3.81-2.3 4.78-1.68 1.33-2.84 1.89-3.49 2.61-.5.57-.62 1.04-.65 1.95H9.45c0-2.64.65-3.9 2.36-5.34';

var remove = 'M17.75 13.25H6.25a1.25 1.25 0 0 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0';

var report = 'M7.91 18.89A8.013 8.013 0 0 0 18.89 7.91L7.91 18.89zm-2.82-2.83L16.06 5.09A8.015 8.015 0 0 0 5.09 16.06zM12 24C5.37 24 0 18.63 0 12S5.37 0 12 0s12 5.37 12 12-5.37 12-12 12z';

var search = 'M10 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m13.12 2.88l-4.26-4.26A9.842 9.842 0 0 0 20 10c0-5.52-4.48-10-10-10S0 4.48 0 10s4.48 10 10 10c1.67 0 3.24-.41 4.62-1.14l4.26 4.26a3 3 0 0 0 4.24 0 3 3 0 0 0 0-4.24';

var send = 'M6 6l-6 6 7.67 2.56L21 3 9.44 16.34 12 24l6-6 6-18';

var share = 'M21 14c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2s2 .9 2 2v4h14v-4c0-1.1.9-2 2-2zM8.82 8.84c-.78.78-2.05.79-2.83 0-.78-.78-.79-2.04-.01-2.82L11.99 0l6.02 6.01c.78.78.79 2.05.01 2.83-.78.78-2.05.79-2.83 0l-1.2-1.19v6.18a2 2 0 1 1-4 0V7.66L8.82 8.84z';

var shoppingBag = 'M9.5 5a2.5 2.5 0 0 1 5 0v2h-5V5zM17 7V5c0-2.76-2.24-5-5-5S7 2.24 7 5v2H2v15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7h-5z';

var smiley = 'M12.03 19.29h-.06c-3.48-.03-4.92-2.31-4.98-2.41a.896.896 0 0 1 .27-1.22.82.82 0 0 1 1.17.26c.06.08 1.06 1.58 3.57 1.59 2.51-.01 3.52-1.6 3.56-1.67.25-.41.78-.54 1.18-.28.39.26.52.8.28 1.21-.06.1-1.5 2.49-4.99 2.52zM18 9.43c0 .95-.77 1.71-1.71 1.71-.95 0-1.72-.76-1.72-1.71s.77-1.72 1.72-1.72c.94 0 1.71.77 1.71 1.72zm-12 0c0-.95.77-1.72 1.71-1.72.95 0 1.72.77 1.72 1.72s-.77 1.71-1.72 1.71c-.94 0-1.71-.76-1.71-1.71z';

var smileyOutline = 'M12.03 19.29h-.06c-3.48-.03-4.92-2.31-4.98-2.41a.896.896 0 0 1 .27-1.22.82.82 0 0 1 1.17.26c.06.08 1.06 1.58 3.57 1.59 2.51-.01 3.52-1.6 3.56-1.67.25-.41.78-.54 1.18-.28.39.26.52.8.28 1.21-.06.1-1.5 2.49-4.99 2.52zM18 9.43c0 .95-.77 1.71-1.71 1.71-.95 0-1.72-.76-1.72-1.71s.77-1.72 1.72-1.72c.94 0 1.71.77 1.71 1.72zm-12 0c0-.95.77-1.72 1.71-1.72.95 0 1.72.77 1.72 1.72s-.77 1.71-1.72 1.71c-.94 0-1.71-.76-1.71-1.71zM12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22.2C6.45 22.2 1.8 17.7 1.8 12 1.8 6.3 6.3 1.8 12 1.8c5.7 0 10.2 4.5 10.2 10.2 0 5.7-4.65 10.2-10.2 10.2z';

var sound = 'M20.48 3.51A11.92 11.92 0 0 1 24 12c0 3.2-1.25 6.22-3.51 8.48-.25.25-.57.37-.89.37-.32 0-.64-.12-.88-.37-.49-.48-.49-1.27 0-1.76A9.465 9.465 0 0 0 21.5 12c0-2.54-.99-4.93-2.79-6.72-.48-.49-.48-1.28 0-1.77a1.25 1.25 0 0 1 1.77 0zM5 7.94v.02L12 1v22l-7-6.09v.03H2c-1.1 0-2-.9-2-2v-5a2 2 0 0 1 2-2h3zm11.95-.89A6.96 6.96 0 0 1 19 12c0 1.87-.73 3.63-2.05 4.95-.24.24-.56.36-.88.36-.32 0-.64-.12-.89-.36a1.25 1.25 0 0 1 0-1.77c.85-.85 1.32-1.98 1.32-3.18 0-1.2-.47-2.33-1.32-3.18a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0z';

var speech = 'M12 0C5.85 0 .75 4.94.75 11.08c0 2.7.9 5.24 2.7 7.19L2.1 23.51c-.15.3.3.6.6.45l5.25-2.55c1.35.45 2.7.75 4.05.75 6.15 0 11.25-4.94 11.25-11.08S18.15 0 12 0';

var speechEllipsis = 'M18 12.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18 12.5m-6 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 12.5m-6 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6 12.5M12 0C5.925 0 1 4.925 1 11c0 2.653.94 5.086 2.504 6.986L2 24l5.336-3.049A10.93 10.93 0 0 0 12 22c6.075 0 11-4.925 11-11S18.075 0 12 0';

var tag = 'M6 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m7.36-6.2l8.84 8.84a2.71 2.71 0 0 1 0 3.85l-7.71 7.71a2.71 2.71 0 0 1-3.85 0L1.8 13.36c-.51-.51-.8-1.2-.8-1.92V3.73C1 2.22 2.22 1 3.73 1h7.71c.72 0 1.41.29 1.92.8';

var twitter = 'M7.548 21.5c9.056 0 14.01-7.31 14.01-13.65 0-.208 0-.414-.015-.62A9.88 9.88 0 0 0 24 4.747c-.899.388-1.852.642-2.828.754a4.838 4.838 0 0 0 2.165-2.653c-.967.559-2.024.953-3.127 1.164-1.526-1.58-3.952-1.968-5.916-.944-1.964 1.025-2.98 3.205-2.475 5.32C7.859 8.194 4.17 6.372 1.67 3.375.363 5.567 1.031 8.372 3.195 9.78a4.986 4.986 0 0 1-2.235-.6v.06c0 2.284 1.653 4.25 3.95 4.703a5.042 5.042 0 0 1-2.223.082c.645 1.954 2.494 3.293 4.6 3.332A10.048 10.048 0 0 1 0 19.345a14.21 14.21 0 0 0 7.548 2.151';

var viewTypeDefault = 'M13.5 24V13.5H24V24H13.5zM0 10.5V0h10.5v10.5H0zm13.5 0V0H24v10.5H13.5zM0 24V13.5h10.5V24H0z';

var viewTypeDense = 'M17.999 24H24v-6h-6.001v6zm-9-17.999V0h6v6.001H9zM0 6.001V0h6v6.001H0zm17.999 0V0H24v6.001h-6.001zM0 15.001V9h6v6H0zm9 0V9h6v6H9zm8.999 0V9H24v6h-6.001zM0 24v-6h6v6H0zm9 0v-6h6v6H9z';

var viewTypeList = 'M0 13.502v-3h24v3H0zm0-7.5V3h24v3.002H0zm0 15v-3h24v3H0z';

var icons = {
  add: add,
  'add-circle': addCircle,
  'add-pin': addPin,
  'angled-pin': angledPin,
  'arrow-back': arrowBack,
  'arrow-circle-down': arrowCircleDown,
  'arrow-circle-forward': arrowCircleForward,
  'arrow-down': arrowDown,
  'arrow-forward': arrowForward,
  'arrow-up': arrowUp,
  'arrow-up-right': arrowUpRight,
  bell: bell,
  camera: camera,
  cancel: cancel,
  check: check,
  'check-circle': checkCircle,
  'circle-outline': circleOutline,
  clear: clear,
  clock: clock,
  cog: cog,
  compass: compass,
  dash: dash,
  edit: edit,
  ellipsis: ellipsis,
  'ellipsis-circle-outline': ellipsisCircleOutline,
  envelope: envelope,
  eye: eye,
  facebook: facebook,
  'face-happy': faceHappy,
  'face-sad': faceSad,
  'face-smiley': faceSmiley,
  filter: filter,
  flag: flag,
  flashlight: flashlight,
  gif: gif,
  globe: globe,
  'globe-checked': globeChecked,
  gmail: gmail,
  'google-plus': googlePlus,
  'graph-bar': graphBar,
  handle: handle,
  'hand-pointing': handPointing,
  heart: heart,
  'heart-broken': heartBroken,
  knoop: knoop,
  lightbulb: lightbulb,
  link: link,
  location: location,
  lock: lock,
  maximize: maximize,
  megaphone: megaphone,
  menu: menu,
  minimize: minimize,
  move: move,
  mute: mute,
  pause: pause,
  people: people,
  person: person,
  'person-add': personAdd,
  pin: pin,
  'pin-hide': pinHide,
  pinterest: pinterest,
  play: play,
  'question-mark': questionMark,
  remove: remove,
  report: report,
  search: search,
  'shopping-bag': shoppingBag,
  smiley: smiley,
  'smiley-outline': smileyOutline,
  send: send,
  share: share,
  sound: sound,
  speech: speech,
  'speech-ellipsis': speechEllipsis,
  tag: tag,
  twitter: twitter,
  'view-type-default': viewTypeDefault,
  'view-type-dense': viewTypeDense,
  'view-type-list': viewTypeList
};

var IconNames = Object.keys(icons);

function Icon(props) {
  var accessibilityLabel = props.accessibilityLabel,
      _props$color = props.color,
      color = _props$color === undefined ? 'gray' : _props$color,
      icon = props.icon,
      inline = props.inline,
      _props$size = props.size,
      size = _props$size === undefined ? 16 : _props$size,
      dangerouslySetSvgPath = props.dangerouslySetSvgPath;


  var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$1.icon, colors[color], defineProperty({}, styles$1.iconBlock, !inline));

  var path = icon && icons[icon] ||
  /* eslint-disable-next-line no-underscore-dangle */
  dangerouslySetSvgPath && dangerouslySetSvgPath.__path || undefined;

  var ariaHidden = accessibilityLabel === '' ? true : null;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'svg',
    {
      className: cs,
      height: size,
      width: size,
      viewBox: '0 0 24 24',
      'aria-hidden': ariaHidden,
      'aria-label': accessibilityLabel,
      role: 'img'
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'title',
      null,
      accessibilityLabel
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('path', { d: path })
  );
}

Icon.icons = IconNames;

Icon.propTypes = {
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'darkGray', 'eggplant', 'gray', 'green', 'lightGray', 'maroon', 'midnight', 'navy', 'olive', 'orange', 'orchid', 'pine', 'purple', 'red', 'watermelon', 'white']),
  dangerouslySetSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    __path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(IconNames),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var styles$2 = { "img": "_s3 _29 _45 _2l", "scaled-img": "_s4 _2j", "contain": "_s5 _s4 _2j", "cover": "_s6 _s4 _2j" };

var shouldScaleImage = function shouldScaleImage(fit) {
  return fit === 'cover' || fit === 'contain';
};

var Image = function (_React$PureComponent) {
  inherits(Image, _React$PureComponent);

  function Image() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Image);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Image.__proto__ || Object.getPrototypeOf(Image)).call.apply(_ref, [this].concat(args))), _this), _this.handleLoad = function () {
      if (_this.props.onLoad) {
        _this.props.onLoad();
      }
    }, _this.handleError = function () {
      if (_this.props.onError) {
        _this.props.onError();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Image, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (shouldScaleImage(this.props.fit)) {
        this.loadImage();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          fit = _props.fit,
          src = _props.src;

      if (shouldScaleImage(fit) && prevProps.src !== src) {
        this.loadImage();
      }
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      if (typeof window !== 'undefined') {
        var image = new window.Image();
        image.onload = this.handleLoad;
        image.onerror = this.handleError;
        image.src = this.props.src;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          alt = _props2.alt,
          color = _props2.color,
          children = _props2.children,
          fit = _props2.fit,
          naturalHeight = _props2.naturalHeight,
          naturalWidth = _props2.naturalWidth,
          sizes = _props2.sizes,
          src = _props2.src,
          srcSet = _props2.srcSet;


      var isScaledImage = shouldScaleImage(fit);
      var childContent = children ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        { position: 'absolute', top: true, left: true, bottom: true, right: true, overflow: 'hidden' },
        children
      ) : null;

      return isScaledImage ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          'aria-label': alt,
          className: styles$2[fit],
          style: {
            backgroundColor: color,
            backgroundImage: 'url(\'' + src + '\')'
          },
          role: 'img'
        },
        childContent
      ) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          position: 'relative',
          dangerouslySetInlineStyle: {
            __style: {
              backgroundColor: color,
              paddingBottom: naturalHeight / naturalWidth * 100 + '%'
            }
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('img', {
          alt: alt,
          className: styles$2.img,
          onError: this.handleError,
          onLoad: this.handleLoad,
          sizes: sizes,
          src: src,
          srcSet: srcSet
        }),
        childContent
      );
    }
  }]);
  return Image;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Image.propTypes = {
  alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['contain', 'cover', 'none']),
  naturalHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  naturalWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sizes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  srcSet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Image.defaultProps = {
  color: 'transparent',
  fit: 'none'
};

var styles$3 = { "Mask": "_s7 _2d _2j", "square": "_s8 _5b", "rounded": "_s9 _5e", "circle": "_sa _5c", "wash": "_sb _2l _2p _2q _2o _2n" };

function Mask(props) {
  var children = props.children,
      _props$shape = props.shape,
      shape = _props$shape === undefined ? 'square' : _props$shape,
      width = props.width,
      height = props.height,
      _props$wash = props.wash,
      wash = _props$wash === undefined ? false : _props$wash;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$3.Mask, styles$3[shape]), style: { width: width, height: height } },
    children,
    wash && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: styles$3.wash })
  );
}

Mask.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  shape: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'rounded', 'square']),
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var typography = { "antialiased": "_sc", "sansSerif": "_sd", "letterSpacing": "_se", "leadingShort": "_sf", "leadingTall": "_sg", "fontWeightNormal": "_sh", "fontWeightBold": "_si", "fontStyleRegular": "_sj", "fontStyleItalic": "_sk", "underline": "_sl", "noUnderline": "_sm", "breakWord": "_sn", "truncate": "_so", "alignLeft": "_sp", "alignRight": "_sq", "alignCenter": "_sr", "textJustify": "_ss" };

var Square = function Square(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    _extends({}, props, { position: 'relative' }),
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Box, {
      dangerouslySetInlineStyle: { __style: { paddingBottom: '100%' } },
      position: 'relative'
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { position: 'absolute', top: true, left: true, bottom: true, right: true },
      props.children
    )
  );
};

var DefaultAvatar = function DefaultAvatar(_ref) {
  var name = _ref.name;

  var firstInitial = name ? [].concat(toConsumableArray(name))[0].toUpperCase() : '';
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Square,
    { color: 'gray', shape: 'circle' },
    firstInitial && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'svg',
      {
        width: '100%',
        viewBox: '-50 -50 100 100',
        version: '1.1',
        preserveAspectRatio: 'xMidYMid meet',
        xmlns: 'http://www.w3.org/2000/svg'
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'title',
        null,
        name
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'text',
        {
          fontSize: '50px',
          fill: '#fff',
          dominantBaseline: 'central',
          textAnchor: 'middle',
          className: [typography.antialiased, typography.sansSerif, typography.leadingSmall, typography.fontWeightBold].join(' ')
        },
        firstInitial
      )
    )
  );
};

var sizes = {
  sm: 24,
  md: 40,
  lg: 72
};

var Avatar = function (_React$PureComponent) {
  inherits(Avatar, _React$PureComponent);

  function Avatar() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      isImageLoaded: true
    }, _this.handleImageError = function () {
      return _this.setState({ isImageLoaded: false });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          outline = _props.outline,
          size = _props.size,
          src = _props.src,
          verified = _props.verified;
      var isImageLoaded = this.state.isImageLoaded;

      var width = size ? sizes[size] : '100%';
      var height = size ? sizes[size] : '';
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        _extends({
          color: 'white'
        }, outline ? {
          dangerouslySetInlineStyle: {
            __style: {
              boxShadow: '0 0 0 2px #fff'
            }
          }
        } : {}, {
          width: width,
          height: height,
          position: 'relative',
          shape: 'circle'
        }),
        src && isImageLoaded ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Mask,
          { shape: 'circle', wash: true },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Image, {
            alt: name,
            color: '#EFEFEF',
            naturalHeight: 1,
            naturalWidth: 1,
            src: src,
            onError: this.handleImageError
          })
        ) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DefaultAvatar, { name: name }),
        verified && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          {
            position: 'absolute',
            width: '20%',
            height: '20%',
            minWidth: 8,
            minHeight: 8,
            dangerouslySetInlineStyle: {
              __style: {
                bottom: '4%',
                right: '4%'
              }
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            {
              color: 'white',
              width: '100%',
              height: '100%',
              shape: 'circle',
              dangerouslySetInlineStyle: {
                __style: {
                  boxShadow: '0 0 0 2px #fff'
                }
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
              color: 'red',
              icon: 'check-circle',
              accessibilityLabel: '',
              size: '100%'
            })
          )
        )
      );
    }
  }]);
  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Avatar.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md', 'lg']),
  verified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var styles$4 = { "button": "_st _2u", "solid": "_su _5j", "enabled": "_sv _3r _t7", "sm": "_sw _2r", "md": "_sx _2s", "lg": "_sy _2t", "block": "_sz _45 _29", "inline": "_t0 _2b", "disabled": "_t1 _5p", "gray": "_t2 _5p", "red": "_t3 _5l", "blue": "_t4 _61", "transparent": "_t5 _6i", "white": "_t6 _5n" };

var styles$5 = { "Text": "_tf _sc _sd _se", "fontSize1": "_tg", "fontSize2": "_th", "fontSize3": "_ti", "fontSize4": "_tj", "fontSize5": "_tk", "smFontSize1": "_tl", "smFontSize2": "_tm", "smFontSize3": "_tn", "smFontSize4": "_to", "smFontSize5": "_tp", "mdFontSize1": "_tq", "mdFontSize2": "_tr", "mdFontSize3": "_ts", "mdFontSize4": "_tt", "mdFontSize5": "_tu", "lgFontSize1": "_tv", "lgFontSize2": "_tw", "lgFontSize3": "_tx", "lgFontSize4": "_ty", "lgFontSize5": "_tz" };

var SIZE_SCALE = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};

function Text(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'left' : _ref$align,
      _ref$bold = _ref.bold,
      bold = _ref$bold === undefined ? false : _ref$bold,
      children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'darkGray' : _ref$color,
      _ref$inline = _ref.inline,
      inline = _ref$inline === undefined ? false : _ref$inline,
      _ref$italic = _ref.italic,
      italic = _ref$italic === undefined ? false : _ref$italic,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === undefined ? 'breakWord' : _ref$overflow,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'md' : _ref$size,
      smSize = _ref.smSize,
      mdSize = _ref.mdSize,
      lgSize = _ref.lgSize,
      _ref$leading = _ref.leading,
      leading = _ref$leading === undefined ? 'short' : _ref$leading,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === undefined ? false : _ref$truncate,
      _ref$__dangerouslyInc = _ref.__dangerouslyIncreaseLineHeight,
      __dangerouslyIncreaseLineHeight = _ref$__dangerouslyInc === undefined ? false : _ref$__dangerouslyInc;

  var scale = SIZE_SCALE[size];
  var smScale = SIZE_SCALE[smSize];
  var mdScale = SIZE_SCALE[mdSize];
  var lgScale = SIZE_SCALE[lgSize];

  var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$5.Text, styles$5['fontSize' + scale], lgSize && styles$5['lgFontSize' + lgScale], mdSize && styles$5['mdFontSize' + mdScale], smSize && styles$5['smFontSize' + smScale], color === 'blue' && colors.blue, color === 'darkGray' && colors.darkGray, color === 'eggplant' && colors.eggplant, color === 'gray' && colors.gray, color === 'green' && colors.green, color === 'lightGray' && colors.lightGray, color === 'maroon' && colors.maroon, color === 'midnight' && colors.midnight, color === 'navy' && colors.navy, color === 'olive' && colors.olive, color === 'orange' && colors.orange, color === 'orchid' && colors.orchid, color === 'pine' && colors.pine, color === 'purple' && colors.purple, color === 'red' && colors.red, color === 'watermelon' && colors.watermelon, color === 'white' && colors.white, leading === 'short' && typography.leadingShort, (leading === 'tall' || __dangerouslyIncreaseLineHeight) && typography.leadingTall, align === 'center' && typography.alignCenter, align === 'justify' && typography.alignJustify, align === 'left' && typography.alignLeft, align === 'right' && typography.alignRight, overflow === 'breakWord' && typography.breakWord, italic && typography.fontStyleItalic, !italic && typography.fontStyleNormal, bold && typography.fontWeightBold, !bold && typography.fontWeightNormal, truncate && typography.truncate);
  var Tag = inline ? 'span' : 'div';

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Tag,
    _extends({
      className: cs
    }, truncate && typeof children === 'string' ? { title: children } : null),
    children
  );
}

Text.propTypes = {
  __dangerouslyIncreaseLineHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right', 'center', 'justify']),
  bold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['green', 'pine', 'olive', 'blue', 'navy', 'midnight', 'purple', 'orchid', 'eggplant', 'maroon', 'watermelon', 'orange', 'darkGray', 'gray', 'lightGray', 'red', 'white']),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  italic: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  leading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['tall', 'short']),
  lgSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  mdSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  overflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['normal', 'breakWord']),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  smSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  truncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function Button(props) {
  var _classnames;

  var accessibilityExpanded = props.accessibilityExpanded,
      accessibilityHaspopup = props.accessibilityHaspopup,
      accessibilityLabel = props.accessibilityLabel,
      _props$color = props.color,
      color = _props$color === undefined ? 'gray' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === undefined ? false : _props$disabled,
      _props$inline = props.inline,
      inline = _props$inline === undefined ? false : _props$inline,
      name = props.name,
      onClick = props.onClick,
      _props$size = props.size,
      size = _props$size === undefined ? 'md' : _props$size,
      text = props.text,
      _props$type = props.type,
      type = _props$type === undefined ? 'button' : _props$type;


  var textColor = {
    blue: 'white',
    gray: 'darkGray',
    red: 'white',
    transparent: 'white',
    white: 'darkGray'
  };

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$4.button, (_classnames = {}, defineProperty(_classnames, styles$4.sm, size === 'sm'), defineProperty(_classnames, styles$4.md, size === 'md'), defineProperty(_classnames, styles$4.lg, size === 'lg'), defineProperty(_classnames, styles$4.solid, color !== 'transparent'), defineProperty(_classnames, styles$4[color], !disabled), defineProperty(_classnames, styles$4.disabled, disabled), defineProperty(_classnames, styles$4.enabled, !disabled), defineProperty(_classnames, styles$4.inline, inline), defineProperty(_classnames, styles$4.block, !inline), _classnames));

  /* eslint-disable react/button-has-type */
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'button',
    {
      'aria-expanded': accessibilityExpanded,
      'aria-haspopup': accessibilityHaspopup,
      'aria-label': accessibilityLabel,
      className: classes,
      disabled: disabled,
      name: name,
      onClick: function (_onClick) {
        function onClick(_x) {
          return _onClick.apply(this, arguments);
        }

        onClick.toString = function () {
          return _onClick.toString();
        };

        return onClick;
      }(function (event) {
        return onClick && onClick({ event: event });
      }),
      type: type
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Text,
      {
        align: 'center',
        bold: true,
        color: disabled ? 'gray' : textColor[color],
        overflow: 'normal',
        size: size
      },
      text
    )
  );
  /* eslint-enable react/button-has-type */
}

Button.propTypes = {
  accessibilityExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accessibilityHaspopup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'gray', 'red', 'transparent', 'white']),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md', 'lg']),
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['button', 'submit'])
};

var styles$6 = { "card": "_u0 _2l _5e _2n _2o _2p _2q _2v", "hover": "_u1", "animateIn": "_u2" };

var Card = function (_React$Component) {
  inherits(Card, _React$Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseEnter = function (event) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({ hovered: true }, onMouseEnter && function () {
        return onMouseEnter({ event: event });
      });
    }, _this.handleMouseLeave = function (event) {
      var onMouseLeave = _this.props.onMouseLeave;

      _this.setState({ hovered: false }, onMouseLeave && function () {
        return onMouseLeave({ event: event });
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          image = _props.image;
      var hovered = this.state.hovered;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$6.card, defineProperty({}, styles$6.hover, active || active == null && hovered));

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          position: 'relative'
        },
        image && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { marginBottom: 1 },
          image
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          null,
          children
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: classes })
      );
    }
  }]);
  return Card;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Card.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var styles$7 = { "check": "_u3 _29 _2u _2w _34 _3e", "checkEnabled": "_u4 _t7", "checkDarkGray": "_u5 _5t", "checkGray": "_u6 _5r", "checkLightGray": "_u7 _5p", "checkWhite": "_u8 _5n", "checkFocused": "_u9 _3s", "checkSm": "_ua", "checkMd": "_ub", "input": "_uc _2l _pb", "inputEnabled": "_ud _t7", "inputSm": "_ue", "inputMd": "_uf" };

var Checkbox = function (_React$Component) {
  inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleChange = function (event) {
      var checked = event.target.checked;

      _this.props.onChange({ event: event, checked: checked });
    }, _this.handleBlur = function () {
      return _this.setState({ focused: false });
    }, _this.handleFocus = function () {
      return _this.setState({ focused: true });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.indeterminate) {
        this.setIndeterminate(!!this.props.indeterminate);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(previousProps) {
      if (previousProps.indeterminate !== this.props.indeterminate) {
        this.setIndeterminate(!!this.props.indeterminate);
      }
    }
  }, {
    key: 'setIndeterminate',
    value: function setIndeterminate(indeterminate) {
      if (this.input) {
        this.input.indeterminate = indeterminate;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this,
          _classnames2;

      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          id = _props.id,
          indeterminate = _props.indeterminate,
          name = _props.name,
          size = _props.size;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        { position: 'relative' },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('input', {
          checked: checked,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$7.input, (_classnames = {}, defineProperty(_classnames, styles$7.inputEnabled, !disabled), defineProperty(_classnames, styles$7.indeterminate, indeterminate), defineProperty(_classnames, styles$7.inputSm, size === 'sm'), defineProperty(_classnames, styles$7.inputMd, size === 'md'), _classnames)),
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          ref: function ref(el) {
            _this2.input = el;
          },
          type: 'checkbox'
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$7.check,
            // eslint-disable-next-line no-nested-ternary
            disabled ? checked || indeterminate ? styles$7.checkGray : styles$7.checkLightGray : checked || indeterminate ? styles$7.checkDarkGray : styles$7.checkWhite, (_classnames2 = {}, defineProperty(_classnames2, styles$7.checkEnabled, !disabled), defineProperty(_classnames2, styles$7.checkFocused, this.state.focused), defineProperty(_classnames2, styles$7.checkMd, size === 'md'), defineProperty(_classnames2, styles$7.checkSm, size === 'sm'), _classnames2))
          },
          (checked || indeterminate) && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
            accessibilityLabel: '',
            color: 'white',
            icon: indeterminate ? 'dash' : 'check',
            size: size === 'sm' ? 8 : 12
          })
        )
      );
    }
  }]);
  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Checkbox.propTypes = {
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  indeterminate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md'])
};
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false,
  size: 'md'
};

var Collection = function (_React$PureComponent) {
  inherits(Collection, _React$PureComponent);

  function Collection() {
    classCallCheck(this, Collection);
    return possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).apply(this, arguments));
  }

  createClass(Collection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Item = _props.Item,
          layout$$1 = _props.layout,
          _props$viewportTop = _props.viewportTop,
          viewportTop = _props$viewportTop === undefined ? 0 : _props$viewportTop,
          _props$viewportLeft = _props.viewportLeft,
          viewportLeft = _props$viewportLeft === undefined ? 0 : _props$viewportLeft;

      // Calculate the full dimensions of the item layer

      var width = Math.max.apply(Math, toConsumableArray(layout$$1.map(function (item) {
        return item.left + item.width;
      })));
      var height = Math.max.apply(Math, toConsumableArray(layout$$1.map(function (item) {
        return item.top + item.height;
      })));

      // Default the viewport to being the full width of the content layer
      var _props2 = this.props,
          _props2$viewportWidth = _props2.viewportWidth,
          viewportWidth = _props2$viewportWidth === undefined ? width : _props2$viewportWidth,
          _props2$viewportHeigh = _props2.viewportHeight,
          viewportHeight = _props2$viewportHeigh === undefined ? height : _props2$viewportHeigh;

      // Calculates which items from the item layer to render in the viewport
      // layer.

      var items = layout$$1.reduce(function (acc, position, idx) {
        if (position.top + position.height > viewportTop && position.top < viewportHeight + viewportTop && position.left < viewportWidth + viewportLeft && position.left + position.width > viewportLeft) {
          acc.push(_extends({ idx: idx }, position));
        }
        return acc;
      }, []);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        { className: layout.relative, style: { width: width, height: height } },
        items.map(function (_ref) {
          var idx = _ref.idx,
              style = objectWithoutProperties(_ref, ['idx']);
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            { key: idx, className: layout.absolute, style: style },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Item, { idx: idx })
          );
        })
      );
    }
  }]);
  return Collection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Collection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  Item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired),
  viewportHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  viewportLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  viewportTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  viewportWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Collection.defaultProps = {
  layout: [],
  viewportLeft: 0,
  viewportTop: 0
};

var styles$8 = { "deprecatedColumn": "_ug", "xsCol0": "_uh", "xsCol1": "_ui _3u", "xsCol2": "_uj _3v", "xsCol3": "_uk _3w", "xsCol4": "_ul _3x", "xsCol5": "_um _3y", "xsCol6": "_un _3z", "xsCol7": "_uo _40", "xsCol8": "_up _41", "xsCol9": "_uq _42", "xsCol10": "_ur _43", "xsCol11": "_us _44", "xsCol12": "_ut _45", "smCol0": "_uu", "smCol1": "_uv _46", "smCol2": "_uw _47", "smCol3": "_ux _48", "smCol4": "_uy _49", "smCol5": "_uz _4a", "smCol6": "_v0 _4b", "smCol7": "_v1 _4c", "smCol8": "_v2 _4d", "smCol9": "_v3 _4e", "smCol10": "_v4 _4f", "smCol11": "_v5 _4g", "smCol12": "_v6 _4h", "mdCol0": "_v7", "mdCol1": "_v8 _4i", "mdCol2": "_v9 _4j", "mdCol3": "_va _4k", "mdCol4": "_vb _4l", "mdCol5": "_vc _4m", "mdCol6": "_vd _4n", "mdCol7": "_ve _4o", "mdCol8": "_vf _4p", "mdCol9": "_vg _4q", "mdCol10": "_vh _4r", "mdCol11": "_vi _4s", "mdCol12": "_vj _4t", "lgCol0": "_vk", "lgCol1": "_vl _4u", "lgCol2": "_vm _4v", "lgCol3": "_vn _4w", "lgCol4": "_vo _4x", "lgCol5": "_vp _4y", "lgCol6": "_vq _4z", "lgCol7": "_vr _50", "lgCol8": "_vs _51", "lgCol9": "_vt _52", "lgCol10": "_vu _53", "lgCol11": "_vv _54", "lgCol12": "_vw _55" };

function Column(props) {
  var children = props.children;

  var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((props.xs || props.sm || props.md || props.lg) && styles$8.deprecatedColumn, props.xs && styles$8['xsCol' + props.xs], props.sm && styles$8['smCol' + props.sm], props.md && styles$8['mdCol' + props.md], props.lg && styles$8['lgCol' + props.lg], props.span != null && styles$8['xsCol' + props.span], props.smSpan != null && styles$8['smCol' + props.smSpan], props.mdSpan != null && styles$8['mdCol' + props.mdSpan], props.lgSpan != null && styles$8['lgCol' + props.lgSpan]);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    { className: cs },
    children
  );
}

Column.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  xs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  sm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  md: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  span: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  smSpan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mdSpan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lgSpan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

function Container(props) {
  var children = props.children;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    { justifyContent: 'center', display: 'flex' },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { maxWidth: 800, width: '100%' },
      children
    )
  );
}

Container.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var styles$9 = { "divider": "_vx _29 _57 _pb" };

function Divider() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('hr', { className: styles$9.divider });
}

function Caret(props) {
  var direction = props.direction;

  var path = void 0;
  switch (direction) {
    case 'up':
      path = 'M0 0 L12 12 L24 0';
      break;
    case 'right':
      path = 'M24 0 L12 12 L24 24';
      break;
    case 'down':
      path = 'M0 24 L12 12 L24 24';
      break;
    case 'left':
      path = 'M0 0 L12 12 L0 24';
      break;
    default:
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'svg',
    { width: '24', height: '24' },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('path', { d: path })
  );
}

Caret.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'right', 'down', 'left'])
};

var styles$10 = { "container": "_vy _2l", "contents": "_vz _2l _29 _2u _5e", "dimensions": "_w0", "innerContents": "_w1 _2w _2h _5e", "caret": "_w2 _2l" };

/* Needed until this Flow issue is fixed: https://github.com/facebook/flow/issues/380 */
/* eslint quote-props: 0 */
var SPACES_INDEX_MAP = {
  '0': 'up',
  '1': 'right',
  '2': 'down',
  '3': 'left'
};

var DIR_INDEX_MAP = {
  up: 0,
  right: 1,
  down: 2,
  left: 3
};

var MARGIN = 24;
var CARET_HEIGHT = 24;
var CARET_OFFSET_FROM_SIDE = 24;
var BORDER_RADIUS = 8;

/**
 * Determines the main direction the flyout opens
 */
function getMainDir(flyoutSize, idealDirection, triggerRect, windowSize) {
  // Calculates the available space if we were to place the flyout in the 4 main directions
  // to determine which 'quadrant' to position the flyout inside of
  var up = triggerRect.top - flyoutSize.height - CARET_HEIGHT;
  var right = windowSize.width - flyoutSize.width - CARET_HEIGHT - triggerRect.right;
  var down = windowSize.height - flyoutSize.height - CARET_HEIGHT - triggerRect.bottom;
  var left = triggerRect.left - flyoutSize.width - CARET_HEIGHT;

  // overrides available space when the trigger is close to the edge of the screen
  // trigger is too close to top/bottom of screen for left & right flyouts
  if (triggerRect.top < BORDER_RADIUS || windowSize.height - triggerRect.bottom < BORDER_RADIUS) {
    left = 0;
    right = 0;
  }

  // trigger is too close to the left/right of screen for up & down flyouts
  if (triggerRect.left < BORDER_RADIUS || windowSize.width - triggerRect.right < BORDER_RADIUS) {
    up = 0;
    down = 0;
  }

  var spaces = [up, right, down, left];

  // Identify best direction of available spaces
  var max = Math.max.apply(Math, spaces);

  // Chose the main direction for the flyout based on available spaces & user preference
  var mainDir = void 0;
  if (idealDirection && spaces[DIR_INDEX_MAP[idealDirection]] > 0) {
    // user pref
    mainDir = idealDirection;
  } else {
    // If no direction pref, chose the direction in which there is the most space available
    mainDir = SPACES_INDEX_MAP[spaces.indexOf(max)];
  }
  return mainDir;
}

/**
 * Determines the sub direction of how the flyout is positioned within the main dir
 */
function getSubDir(flyoutSize, mainDir, triggerRect, windowSize) {
  // Now that we have the main direction, chose from 3 caret placements for that direction
  var offset = void 0;
  var triggerMid = void 0;
  var windowSpaceAvailable = void 0;

  if (mainDir === 'right' || mainDir === 'left') {
    offset = flyoutSize.height / 2;
    triggerMid = triggerRect.top + (triggerRect.bottom - triggerRect.top) / 2;
    windowSpaceAvailable = windowSize.height;
  } else {
    // (mainDir === 'up' || mainDir === 'down')
    offset = flyoutSize.width / 2;
    triggerMid = triggerRect.left + (triggerRect.right - triggerRect.left) / 2;
    windowSpaceAvailable = windowSize.width;
  }

  var aboveOrLeft = triggerMid - offset - MARGIN;
  var belowOrRight = windowSpaceAvailable - triggerMid - offset - MARGIN;
  var subDir = void 0;
  if (aboveOrLeft > 0 && belowOrRight > 0) {
    // caret should go in middle b/c it can
    subDir = 'middle';
  } else if (belowOrRight > 0) {
    // caret should go at top for left/right and left for up/down
    subDir = mainDir === 'left' || mainDir === 'right' ? 'up' : 'left';
  } else {
    // caret should go at bottom for left/right and right for up/down
    subDir = mainDir === 'left' || mainDir === 'right' ? 'down' : 'right';
  }
  return subDir;
}

/**
 * Calculates the amount the flyout & caret need to shift over to align with designs
 */
function calcEdgeShifts(subDir, triggerRect, windowSize) {
  // Target values for flyout and caret shifts
  var flyoutVerticalShift = CARET_OFFSET_FROM_SIDE - (triggerRect.height - CARET_HEIGHT) / 2;
  var flyoutHorizontalShift = CARET_OFFSET_FROM_SIDE - (triggerRect.width - CARET_HEIGHT) / 2;
  var caretVerticalShift = CARET_HEIGHT;
  var caretHorizontalShift = CARET_HEIGHT;

  // Covers edge case where trigger is in a corner and we need to adjust the offset of the caret
  // to something smaller than normal in order
  var isCloseVertically = triggerRect.top - flyoutVerticalShift < 0 || triggerRect.bottom + flyoutVerticalShift > windowSize.height;
  var isCloseHorizontally = triggerRect.left - flyoutHorizontalShift < 0 || triggerRect.right + flyoutHorizontalShift > windowSize.width;
  if (isCloseVertically) {
    flyoutVerticalShift = BORDER_RADIUS - (triggerRect.height - CARET_HEIGHT) / 2;
    caretVerticalShift = BORDER_RADIUS;
  }
  if (isCloseHorizontally) {
    flyoutHorizontalShift = BORDER_RADIUS - (triggerRect.width - CARET_HEIGHT) / 2;
    caretHorizontalShift = BORDER_RADIUS;
  }

  return {
    flyout: {
      x: flyoutHorizontalShift,
      y: flyoutVerticalShift
    },
    caret: {
      x: caretHorizontalShift,
      y: caretVerticalShift
    }
  };
}

/**
 * Calculates flyout and caret offsets for styling
 */
function adjustOffsets(base, edgeShift, flyoutSize, mainDir, subDir, triggerRect) {
  var flyoutLeft = base.left;
  var flyoutTop = base.top;

  var caretTop = mainDir === 'down' ? -CARET_HEIGHT : null;
  var caretRight = mainDir === 'left' ? -CARET_HEIGHT : null;
  var caretBottom = null;
  var caretLeft = mainDir === 'right' ? -CARET_HEIGHT : null;

  if (subDir === 'up') {
    flyoutTop = base.top - edgeShift.flyout.y;
    caretTop = edgeShift.caret.y;
  } else if (subDir === 'down') {
    flyoutTop = base.top - flyoutSize.height + triggerRect.height + edgeShift.flyout.y;
    caretBottom = edgeShift.caret.y;
  } else if (subDir === 'left') {
    flyoutLeft = base.left - edgeShift.flyout.x;
    caretLeft = edgeShift.caret.x;
  } else if (subDir === 'right') {
    flyoutLeft = base.left - flyoutSize.width + triggerRect.width + edgeShift.flyout.x;
    caretRight = edgeShift.caret.x;
  } else if (subDir === 'middle') {
    if (mainDir === 'left' || mainDir === 'right') {
      var triggerMid = flyoutTop + triggerRect.height / 2;
      flyoutTop = triggerMid - flyoutSize.height / 2;
      caretTop = (flyoutSize.height - CARET_HEIGHT) / 2;
    }
    if (mainDir === 'up' || mainDir === 'down') {
      var _triggerMid = flyoutLeft + triggerRect.width / 2;
      flyoutLeft = _triggerMid - flyoutSize.width / 2;
      caretLeft = (flyoutSize.width - CARET_HEIGHT) / 2;
    }
  }

  return {
    flyoutOffset: {
      top: flyoutTop,
      left: flyoutLeft
    },
    caretOffset: {
      top: caretTop,
      right: caretRight,
      bottom: caretBottom,
      left: caretLeft
    }
  };
}

/* Calculates baseline top and left offset for flyout */
function baseOffsets(relativeOffset, flyoutSize, mainDir, triggerRect, windowSize) {
  var HALF_CARET = CARET_HEIGHT / 2;
  // TOP OFFSET
  var top = void 0;
  if (mainDir === 'down') {
    top = windowSize.scrollY + triggerRect.bottom + HALF_CARET;
  } else if (mainDir === 'up') {
    top = windowSize.scrollY + (triggerRect.top - flyoutSize.height - HALF_CARET);
  } else {
    // left and right
    top = windowSize.scrollY + triggerRect.top;
  }

  // LEFT OFFSET
  var left = void 0;
  if (mainDir === 'left') {
    left = windowSize.scrollX + (triggerRect.left - flyoutSize.width - HALF_CARET);
  } else if (mainDir === 'right') {
    left = windowSize.scrollX + triggerRect.right + HALF_CARET;
  } else {
    // down and up
    left = windowSize.scrollX + triggerRect.left;
  }

  // Adjusts for the relative parent container
  top -= relativeOffset.y;
  left -= relativeOffset.x;
  return { top: top, left: left };
}

var Contents = function (_React$Component) {
  inherits(Contents, _React$Component);

  function Contents() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Contents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Contents.__proto__ || Object.getPrototypeOf(Contents)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      flyoutOffset: {
        top: undefined,
        right: undefined,
        bottom: undefined,
        left: undefined
      },
      caretOffset: {
        top: undefined,
        right: undefined,
        bottom: undefined,
        left: undefined
      },
      mainDir: null
    }, _this.setFlyoutPosition = function (props) {
      var relativeOffset = props.relativeOffset,
          idealDirection = props.idealDirection,
          positionRelativeToAnchor = props.positionRelativeToAnchor,
          triggerRect = props.triggerRect,
          width = props.width;

      // Scroll not needed for relative elements
      // We can't use window.scrollX / window.scrollY since it's not supported by IE11

      var scrollX = positionRelativeToAnchor ? 0 : window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || 0;
      var scrollY = positionRelativeToAnchor ? 0 : window.pageYOffset || document.documentElement && document.documentElement.scrollTop || 0;

      var windowSize = {
        height: window.innerHeight,
        width: window.innerWidth,
        scrollX: scrollX,
        scrollY: scrollY
      };

      var flyoutSize = {
        height: _this.flyout ? _this.flyout.clientHeight : 0,
        width: width
      };

      // First choose one of 4 main direction
      var mainDir = getMainDir(flyoutSize, idealDirection, triggerRect, windowSize);

      // Now that we have the main direction, chose from 3 caret placements for that direction
      var subDir = getSubDir(flyoutSize, mainDir, triggerRect, windowSize);

      // Gets the base offset that positions the flyout based on the main direction only
      var base = baseOffsets(relativeOffset, flyoutSize, mainDir, triggerRect, windowSize);

      // Gets the edge shifts for the flyout
      var edgeShifts = calcEdgeShifts(subDir, triggerRect, windowSize);

      // Adjusts for the subdirection of the caret

      var _adjustOffsets = adjustOffsets(base, edgeShifts, flyoutSize, mainDir, subDir, triggerRect),
          flyoutOffset = _adjustOffsets.flyoutOffset,
          caretOffset = _adjustOffsets.caretOffset;

      _this.setState({
        caretOffset: caretOffset,
        flyoutOffset: flyoutOffset,
        mainDir: mainDir
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Contents, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setFlyoutPosition(this.props);
      setTimeout(function () {
        if (_this2.props.shouldFocus && _this2.flyout) {
          _this2.flyout.focus();
        }
      });
      window.addEventListener('resize', this.props.onResize);
      window.addEventListener('keydown', this.props.onKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setFlyoutPosition(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.props.onResize);
      window.removeEventListener('keydown', this.props.onKeyDown);
    }

    /**
     * Determines the main direciton, sub direction, and corresponding offsets needed
     * to correctly position the offset
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          bgColor = _props.bgColor,
          children = _props.children,
          width = _props.width;

      // Needed to prevent UI thrashing

      var visibility = this.state.mainDir === null ? 'hidden' : 'visible';
      var background = bgColor + 'Bg';
      var stroke = bgColor === 'white' ? '#efefef' : null;
      var borderColor = bgColor === 'white' ? 'lightGray' : bgColor;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          className: styles$10.container,
          style: _extends({ stroke: stroke, visibility: visibility }, this.state.flyoutOffset)
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(colors[background], colors[borderColor], styles$10.dimensions, styles$10.contents),
            ref: function ref(c) {
              _this3.flyout = c;
            },
            tabIndex: -1
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$10.dimensions, styles$10.innerContents),
              style: { width: width }
            },
            children
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(colors[bgColor], styles$10.caret),
              style: _extends({}, this.state.caretOffset)
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Caret, { direction: this.state.mainDir })
          )
        )
      );
    }
  }]);
  return Contents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Contents.propTypes = {
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'darkGray', 'orange', 'white']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  idealDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'right', 'down', 'left']),
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onResize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relativeOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({ x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }),
  positionRelativeToAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shouldFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  triggerRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var OutsideEventBehavior = function (_React$Component) {
  inherits(OutsideEventBehavior, _React$Component);

  function OutsideEventBehavior() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, OutsideEventBehavior);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = OutsideEventBehavior.__proto__ || Object.getPrototypeOf(OutsideEventBehavior)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickEvent = function (event) {
      // eslint-disable-next-line react/no-find-dom-node
      var el = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(_this);
      if (!_this.props.onClick || !el || event.target instanceof Node && el.contains(event.target)) {
        return;
      }
      _this.props.onClick(event);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(OutsideEventBehavior, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickEvent, {
        capture: true
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickEvent, {
        capture: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return OutsideEventBehavior;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SIZE_WIDTH_MAP = {
  xs: 185,
  sm: 230,
  md: 284,
  lg: 320,
  xl: 375
};

var ESCAPE_KEY_CODE = 27;

var Controller = function (_React$Component) {
  inherits(Controller, _React$Component);

  function Controller() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Controller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Controller.__proto__ || Object.getPrototypeOf(Controller)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      relativeOffset: {
        x: 0,
        y: 0
      },
      triggerBoundingRect: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0
      }
    }, _this.handleKeyDown = function (event) {
      if (event.keyCode === ESCAPE_KEY_CODE) {
        _this.props.onDismiss();
      }
    }, _this.handlePageClick = function (event) {
      if (event.target instanceof Node && _this.props.anchor && !_this.props.anchor.contains(event.target)) {
        _this.props.onDismiss();
      }
    }, _this.handleResize = function () {
      _this.updateTriggerRect(_this.props);
    }, _this.updateTriggerRect = function (props) {
      var anchor = props.anchor,
          positionRelativeToAnchor = props.positionRelativeToAnchor;

      var triggerBoundingRect = void 0;
      var relativeOffset = void 0;
      if (anchor) {
        triggerBoundingRect = anchor.getBoundingClientRect();

        // Needed for correct positioning within Contents.js
        relativeOffset = {
          x: positionRelativeToAnchor ? triggerBoundingRect.left - anchor.offsetLeft : 0,
          y: positionRelativeToAnchor ? triggerBoundingRect.top - anchor.offsetTop : 0
        };
      }

      _this.setState({ relativeOffset: relativeOffset, triggerBoundingRect: triggerBoundingRect });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Controller, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateTriggerRect(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateTriggerRect(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          anchor = _props.anchor,
          bgColor = _props.bgColor,
          children = _props.children,
          idealDirection = _props.idealDirection,
          positionRelativeToAnchor = _props.positionRelativeToAnchor,
          shouldFocus = _props.shouldFocus;

      if (!anchor) {
        return null;
      }
      var size = this.props.size ? this.props.size : 'sm';
      var width = typeof size === 'string' ? SIZE_WIDTH_MAP[size] : size;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        OutsideEventBehavior,
        { onClick: this.handlePageClick },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Contents,
          {
            bgColor: bgColor,
            idealDirection: idealDirection,
            onKeyDown: this.handleKeyDown,
            onResize: this.handleResize,
            positionRelativeToAnchor: positionRelativeToAnchor,
            relativeOffset: this.state.relativeOffset,
            shouldFocus: shouldFocus,
            triggerRect: this.state.triggerBoundingRect,
            width: width
          },
          children
        )
      );
    }
  }]);
  return Controller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Controller.propTypes = {
  anchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    contains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'darkGray', 'orange', 'white']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  idealDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'right', 'down', 'left']),
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  positionRelativeToAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shouldFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])] // default: sm
  )
};

function Flyout(props) {
  var anchor = props.anchor,
      children = props.children,
      idealDirection = props.idealDirection,
      onDismiss = props.onDismiss,
      _props$positionRelati = props.positionRelativeToAnchor,
      positionRelativeToAnchor = _props$positionRelati === undefined ? true : _props$positionRelati,
      _props$color = props.color,
      color = _props$color === undefined ? 'white' : _props$color,
      size = props.size;


  if (!anchor) {
    return null;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Controller,
    {
      anchor: anchor,
      bgColor: color,
      idealDirection: idealDirection,
      onDismiss: onDismiss,
      positionRelativeToAnchor: positionRelativeToAnchor,
      shouldFocus: color !== 'orange',
      size: size
    },
    children
  );
}

Flyout.propTypes = {
  anchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    contains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  idealDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'right', 'down', 'left']),
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  positionRelativeToAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'orange', 'white']),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])] // default: sm
  )
};

var styles$11 = { "wash": "_w3 _2l _2n _2q _2o _2p" };

function zip(a, b) {
  return a.map(function (item, idx) {
    return [item, b[idx]];
  });
}

var BORDER_WIDTH = 2;

var AVATAR_SIZES = {
  sm: 24,
  md: 40,
  lg: 72
};

var avatarLayout = function avatarLayout(n, size) {
  switch (n) {
    case 0:
    case 1:
      return [{ top: 0, left: 0, width: size, height: size, textLayout: 'center' }];
    case 2:
      return [{
        top: 0,
        left: 0,
        width: 'calc(50% - ' + BORDER_WIDTH / 2 + 'px)',
        height: size,
        textLayout: 'center'
      }, {
        top: 0,
        left: 'calc(50% + ' + BORDER_WIDTH / 2 + 'px)',
        width: 'calc(50% - ' + BORDER_WIDTH / 2 + 'px)',
        height: size,
        textLayout: 'center'
      }];
    default:
      return [{
        top: 0,
        left: 0,
        width: 'calc(50% - ' + BORDER_WIDTH / 2 + 'px)',
        height: size,
        textLayout: 'center'
      }, {
        top: 0,
        left: 'calc(50% + ' + BORDER_WIDTH / 2 + 'px)',
        width: 'calc(50%)',
        height: 'calc(50% - ' + BORDER_WIDTH / 2 + 'px)',
        textLayout: 'topLeft'
      }, {
        top: 'calc(50% + ' + BORDER_WIDTH / 2 + 'px)',
        left: 'calc(50% + ' + BORDER_WIDTH / 2 + 'px)',
        width: 'calc(50%)',
        height: 'calc(50% - ' + BORDER_WIDTH / 2 + 'px)',
        textLayout: 'bottomLeft'
      }];
  }
};

var degToRad = function degToRad(deg) {
  return deg * (Math.PI / 180);
};

var DefaultAvatar$1 = function DefaultAvatar(props) {
  var size = props.size,
      name = props.name,
      textLayout = props.textLayout;


  var quarterPadding = 'calc(' + Math.sin(degToRad(45)) + ' * (' + size + ') / 2)';

  var initial = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'svg',
    {
      width: '100%',
      viewBox: '-50 -50 100 100',
      version: '1.1',
      preserveAspectRatio: 'xMidYMid meet',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'title',
      null,
      name
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'text',
      {
        fontSize: '50px',
        fill: '#fff',
        dominantBaseline: 'central',
        textAnchor: 'middle',
        className: [typography.antialiased, typography.sansSerif, typography.leadingSmall, typography.fontWeightBold].join(' ')
      },
      name ? [].concat(toConsumableArray(name))[0].toUpperCase() : ''
    )
  );
  switch (textLayout) {
    case 'bottomLeft':
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          'aria-label': name,
          color: 'gray',
          height: '100%',
          display: 'flex',
          alignItems: 'end',
          dangerouslySetInlineStyle: {
            __style: {
              paddingBottom: quarterPadding,
              paddingRight: quarterPadding
            }
          }
        },
        initial
      );
    case 'topLeft':
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          'aria-label': name,
          color: 'gray',
          height: '100%',
          display: 'flex',
          alignItems: 'start',
          dangerouslySetInlineStyle: {
            __style: {
              paddingTop: quarterPadding,
              paddingRight: quarterPadding
            }
          }
        },
        initial
      );
    default:
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          'aria-label': name,
          color: 'gray',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        initial
      );
  }
};

function GroupAvatar(props) {
  var collaborators = props.collaborators,
      outline = props.outline,
      size = props.size;

  var avatarWidth = size ? AVATAR_SIZES[size] : '100%';
  var avatarHeight = size ? AVATAR_SIZES[size] : '';
  var positions = avatarLayout(collaborators.length, avatarWidth);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    {
      color: 'white',
      overflow: 'hidden',
      shape: 'circle',
      width: avatarWidth,
      height: avatarHeight,
      position: 'relative',
      dangerouslySetInlineStyle: {
        __style: _extends({}, outline ? { boxShadow: '0 0 0 2px #fff' } : {}, {
          // willChange: transform fixes a strange behavior where the border of the children
          // are not properly trimmed even though overflow: hidden is set
          willChange: 'transform'
        })
      }
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Box, { dangerouslySetInlineStyle: { __style: { paddingBottom: '100%' } } }),
    zip(positions, collaborators).map(function (_ref, idx) {
      var _ref2 = slicedToArray(_ref, 2),
          position = _ref2[0],
          _ref2$ = _ref2[1],
          collaborator = _ref2$ === undefined ? { name: '', src: undefined } : _ref2$;

      var width = position.width,
          height = position.height,
          top = position.top,
          left = position.left,
          textLayout = position.textLayout;
      var name = collaborator.name,
          src = collaborator.src;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          key: idx,
          position: 'absolute',
          width: width,
          height: height,
          dangerouslySetInlineStyle: { __style: { top: top, left: left } }
        },
        src ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Image, {
          alt: name,
          color: '#EFEFEF',
          src: src,
          naturalWidth: 1,
          naturalHeight: 1,
          fit: 'cover'
        }) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DefaultAvatar$1, {
          name: name,
          textLayout: textLayout,
          size: height
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: styles$11.wash })
      );
    })
  );
}

GroupAvatar.propTypes = {
  collaborators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md', 'lg'])
};

var styles$12 = { "Heading": "_w4 _sc _sd _se _sf", "fontSize1": "_w5", "fontSize2": "_w6", "fontSize3": "_w7", "fontSize4": "_w8", "fontSize5": "_w9", "smFontSize1": "_wa", "smFontSize2": "_wb", "smFontSize3": "_wc", "smFontSize4": "_wd", "smFontSize5": "_we", "mdFontSize1": "_wf", "mdFontSize2": "_wg", "mdFontSize3": "_wh", "mdFontSize4": "_wi", "mdFontSize5": "_wj", "lgFontSize1": "_wk", "lgFontSize2": "_wl", "lgFontSize3": "_wm", "lgFontSize4": "_wn", "lgFontSize5": "_wo" };

var defaultHeadingLevels = {
  xs: 5,
  sm: 4,
  md: 3,
  lg: 2,
  xl: 1
};

var SIZE_SCALE$1 = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};

function Heading(props) {
  var accessibilityLevel = props.accessibilityLevel,
      children = props.children,
      _props$color = props.color,
      color = _props$color === undefined ? 'darkGray' : _props$color,
      _props$id = props.id,
      id = _props$id === undefined ? null : _props$id,
      lgSize = props.lgSize,
      mdSize = props.mdSize,
      _props$overflow = props.overflow,
      overflow = _props$overflow === undefined ? 'breakWord' : _props$overflow,
      _props$size = props.size,
      size = _props$size === undefined ? 'md' : _props$size,
      smSize = props.smSize,
      _props$truncate = props.truncate,
      truncate = _props$truncate === undefined ? false : _props$truncate;


  var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$12.Heading, styles$12['fontSize' + SIZE_SCALE$1[size]], smSize && styles$12['smFontSize' + SIZE_SCALE$1[smSize]], mdSize && styles$12['mdFontSize' + SIZE_SCALE$1[mdSize]], lgSize && styles$12['lgFontSize' + SIZE_SCALE$1[lgSize]], colors[color], overflow === 'breakWord' && typography.breakWord, truncate && typography.truncate);

  var headingLevel = accessibilityLevel || defaultHeadingLevels[size];
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('h' + headingLevel, _extends({
    className: cs,
    id: id
  }, truncate && typeof children === 'string' ? { title: children } : null), children);
}

Heading.propTypes = {
  accessibilityLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([1, 2, 3, 4, 5, 6]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['blue', 'darkGray', 'eggplant', 'gray', 'green', 'lightGray', 'maroon', 'midnight', 'navy', 'olive', 'orange', 'orchid', 'pine', 'purple', 'red', 'watermelon', 'white']),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  overflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['normal', 'breakWord']),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  smSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  mdSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  lgSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  truncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var styles$13 = { "button": "_wp _29 _5j _pg _t7" };

var styles$14 = { "pog": "_wq _5c _2w _34 _3e", "focused": "_wr _3s", "transparent": "_ws _6i", "hovered": "_wt", "white": "_wu _5n", "active": "_wv", "lightGray": "_ww _5p" };

var SIZE_NAME_TO_PIXEL = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 56
};

var defaultIconButtonIconColors = {
  transparent: 'gray',
  lightGray: 'gray',
  white: 'gray'
};

function Pog(props) {
  var _classnames;

  var _props$active = props.active,
      active = _props$active === undefined ? false : _props$active,
      _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === undefined ? 'transparent' : _props$bgColor,
      _props$focused = props.focused,
      focused = _props$focused === undefined ? false : _props$focused,
      _props$hovered = props.hovered,
      hovered = _props$hovered === undefined ? false : _props$hovered,
      _props$iconColor = props.iconColor,
      iconColor = _props$iconColor === undefined ? defaultIconButtonIconColors[bgColor] : _props$iconColor,
      icon = props.icon,
      _props$size = props.size,
      size = _props$size === undefined ? 'md' : _props$size;


  var iconSize = SIZE_NAME_TO_PIXEL[size] / 2;

  var inlineStyle = {
    height: SIZE_NAME_TO_PIXEL[size],
    width: SIZE_NAME_TO_PIXEL[size]
  };

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$14.pog, styles$14[bgColor], (_classnames = {}, defineProperty(_classnames, styles$14.active, active), defineProperty(_classnames, styles$14.focused, focused), defineProperty(_classnames, styles$14.hovered, hovered && !focused && !active), _classnames));

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    { className: classes, style: inlineStyle },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { shape: 'circle' },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
        color: iconColor,
        icon: icon,
        size: iconSize,
        accessibilityLabel: ''
      })
    )
  );
}

Pog.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['transparent', 'lightGray', 'white']),
  focused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hovered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  iconColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['gray', 'darkGray', 'red', 'blue', 'white']),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(icons)).isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(SIZE_NAME_TO_PIXEL))
};

var IconButton = function (_React$Component) {
  inherits(IconButton, _React$Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: false,
      focused: false,
      hovered: false
    }, _this.handleBlur = function () {
      return _this.setState({ focused: false });
    }, _this.handleFocus = function () {
      _this.setState({ focused: true });
    }, _this.handleMouseDown = function () {
      _this.setState({ active: true });
    }, _this.handleMouseEnter = function () {
      _this.setState({ hovered: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({
        active: false,
        hovered: false
      });
    }, _this.handleMouseUp = function () {
      _this.setState({ active: false });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(IconButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          accessibilityExpanded = _props.accessibilityExpanded,
          accessibilityHaspopup = _props.accessibilityHaspopup,
          accessibilityLabel = _props.accessibilityLabel,
          bgColor = _props.bgColor,
          iconColor = _props.iconColor,
          icon = _props.icon,
          size = _props.size,
          onClick = _props.onClick;
      var _state = this.state,
          active = _state.active,
          focused = _state.focused,
          hovered = _state.hovered;


      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'button',
        {
          'aria-expanded': accessibilityExpanded,
          'aria-haspopup': accessibilityHaspopup,
          'aria-label': accessibilityLabel,
          className: styles$13.button,
          onBlur: this.handleBlur,
          onClick: function (_onClick) {
            function onClick(_x) {
              return _onClick.apply(this, arguments);
            }

            onClick.toString = function () {
              return _onClick.toString();
            };

            return onClick;
          }(function (event) {
            return onClick && onClick({ event: event });
          }),
          onFocus: this.handleFocus,
          onMouseDown: this.handleMouseDown,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          type: 'button'
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Pog, {
          active: active,
          bgColor: bgColor,
          focused: focused,
          hovered: hovered,
          iconColor: iconColor,
          icon: icon,
          size: size
        })
      );
    }
  }]);
  return IconButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IconButton.propTypes = {
  accessibilityExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accessibilityHaspopup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['transparent', 'lightGray', 'white']),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(icons)).isRequired,
  iconColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['gray', 'darkGray', 'red', 'blue', 'white']),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

var styles$15 = { "label": "_wx _29 _t7" };

function Label(props) {
  var children = props.children,
      htmlFor = props.htmlFor;


  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'label',
    { className: styles$15.label, htmlFor: htmlFor },
    children
  );
}

Label.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  htmlFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var Layer = function (_React$Component) {
  inherits(Layer, _React$Component);

  function Layer(props) {
    classCallCheck(this, Layer);

    var _this = possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  createClass(Layer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (document.body) {
        document.body.appendChild(this.el);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document.body) {
        document.body.removeChild(this.el);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(children, this.el);
    }
  }]);
  return Layer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*
  Much of the math and understanding about this component comes from @vjeaux's
  excellent blog post on image resizing.

  http://blog.vjeux.com/2013/image/css-container-and-cover.html

  I highly recommend you read that first before continuing on reading.
*/

var aspectRatio = function aspectRatio(width, height) {
  return width / height;
};

function Letterbox(_ref) {
  var children = _ref.children,
      contentAspectRatio = _ref.contentAspectRatio,
      height = _ref.height,
      width = _ref.width;

  var viewportAspectRatio = aspectRatio(width, height);

  var contentHeight = void 0;
  var contentWidth = void 0;

  if (contentAspectRatio < viewportAspectRatio) {
    contentWidth = width;
    contentHeight = width / contentAspectRatio;
  } else {
    contentWidth = height * contentAspectRatio;
    contentHeight = height;
  }

  var offsetTop = (contentHeight - height) / -2;
  var offsetLeft = (contentWidth - width) / -2;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Mask,
    { width: width, height: height },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'div',
      { style: { marginTop: offsetTop, marginLeft: offsetLeft } },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Mask,
        { width: contentWidth, height: contentHeight },
        children
      )
    )
  );
}

Letterbox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  contentAspectRatio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var styles$16 = { "link": "_wy _sm", "accessibleFocusStyle": "_wz _3r", "block": "_x0 _29" };

var TAB_KEY_CODE = 9;

var Link = function (_React$Component) {
  inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      enableFocusStyles: true
    }, _this.handleClick = function (event) {
      var _this$props = _this.props,
          href = _this$props.href,
          onClick = _this$props.onClick;

      if (onClick && href) {
        onClick({ event: event });
      }
    }, _this.handleMouseDown = function () {
      var _this$props2 = _this.props,
          href = _this$props2.href,
          target = _this$props2.target;

      if (target === 'blank' && href) {
        _this.setState({ enableFocusStyles: false });
      }
    }, _this.handleKeyUp = function (event) {
      var _this$props3 = _this.props,
          href = _this$props3.href,
          target = _this$props3.target;

      if (target === 'blank' && event.keyCode === TAB_KEY_CODE && href) {
        _this.setState({ enableFocusStyles: true });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          _props$inline = _props.inline,
          inline = _props$inline === undefined ? false : _props$inline,
          _props$target = _props.target,
          target = _props$target === undefined ? null : _props$target,
          href = _props.href;

      var rel = target === 'blank' ? 'noopener noreferrer' : null;
      var linkTarget = target ? '_' + target : null;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'a',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$16.link, this.state.enableFocusStyles ? styles$16.accessibleFocusStyle : '', inline ? '' : styles$16.block),
          href: href,
          onMouseDown: this.handleMouseDown,
          onKeyUp: this.handleKeyUp,
          onClick: this.handleClick,
          rel: rel,
          target: linkTarget
        },
        children
      );
    }
  }]);
  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Link.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([null, 'self', 'blank'])
};

/**
 * debounce prevents a particular function from being called until after a given
 * cooldown period (default 100ms). Every time the function is called, it resets
 * the cooldown.
 */

function debounce(fn) {
  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var deferTimer = null;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (deferTimer) {
      clearTimeout(deferTimer);
    }

    deferTimer = setTimeout(function () {
      deferTimer = null;
      fn.apply(undefined, toConsumableArray(args));
    }, threshhold);
  };

  debounced.clearTimeout = function () {
    if (deferTimer) {
      clearTimeout(deferTimer);
    }
  };

  return debounced;
}

/**
 * FetchItems is a logic component that renders no content itself. Its job
 * is to manage when the given fetchMore method should be called based on
 * the given scroll/size props.
 *
 * While no element is actually passed to FetchItems, it is intended to be used
 * in conjunction with a large scroll container that uses async fetching to
 * load and render additional data. Based on the height of this container and
 * its current scroll position, FetchItems is responsible for triggering future
 * fetch calls.
 */

var FetchItems = function (_React$PureComponent) {
  inherits(FetchItems, _React$PureComponent);

  function FetchItems() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FetchItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FetchItems.__proto__ || Object.getPrototypeOf(FetchItems)).call.apply(_ref, [this].concat(args))), _this), _this.check = function () {
      var _this$props = _this.props,
          containerHeight = _this$props.containerHeight,
          isAtEnd = _this$props.isAtEnd,
          isFetching = _this$props.isFetching,
          fetchMore = _this$props.fetchMore,
          scrollHeight = _this$props.scrollHeight,
          scrollTop = _this$props.scrollTop;


      if (isAtEnd || isFetching || !fetchMore) {
        return;
      }
      var scrollBuffer = containerHeight * 3;

      if (scrollTop + scrollBuffer > scrollHeight) {
        fetchMore();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(FetchItems, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.check);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.check();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return FetchItems;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

FetchItems.propTypes = {
  containerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  isAtEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isFetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fetchMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  scrollHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  scrollTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var styles$17 = { "Masonry": "_x1 _2j", "Masonry__Item": "_x2 _2l", "Masonry__Item__Mounted": "_x3" };

/**
 * ScrollContainer is a pass-through component that simply sets up an onScroll
 * handler on the given scrollContainer element (or the element that is
 * returned as result of calling the scrollContainer method). This allows for
 * the event listener subscription of the scrollContainer to be managed inside
 * the React lifecycle without adding bloat to Masonry or other onScroll
 * subscribers.
 *
 * Note that this Component renders its children without creating any
 * additional content. Also note that, while the component is built to manage
 * onScroll inside of the React lifecycle, it doesn't change onScroll events
 * or the API at all, so it could easily be adapted to other event types.
 */

function getScrollContainer(scrollContainer) {
  return typeof scrollContainer === 'function' ? scrollContainer() : scrollContainer;
}

var ScrollContainer = function (_React$Component) {
  inherits(ScrollContainer, _React$Component);

  function ScrollContainer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call.apply(_ref, [this].concat(args))), _this), _this.getScrollContainerRef = function () {
      return _this.scrollContainer;
    }, _this.handleScroll = function (event) {
      _this.props.onScroll(event);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollContainer = getScrollContainer(this.props.scrollContainer);
      if (scrollContainer) {
        this.updateScrollContainer(scrollContainer);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var nextScrollContainer = getScrollContainer(this.props.scrollContainer);
      if (nextScrollContainer && nextScrollContainer !== this.scrollContainer) {
        this.updateScrollContainer(nextScrollContainer);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: 'updateScrollContainer',
    value: function updateScrollContainer(scrollContainer) {
      if (this.scrollContainer) {
        // cleanup existing scroll container if it exists
        this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
      this.scrollContainer = scrollContainer;
      this.scrollContainer.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    }
  }]);
  return ScrollContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollContainer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  onScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired
};

/**
 * throttle limits the number of times a function can be called to a
 * given threshhold (100ms by default). The function is always called
 * on the leading and trailing edge.
 */

function throttle(fn) {
  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var last = void 0;
  var deferTimer = void 0;
  var throttled = function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = Date.now();
    if (last && now - last < threshhold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(undefined, toConsumableArray(args));
      }, threshhold - (now - last));
    } else {
      last = now;
      fn.apply(undefined, toConsumableArray(args));
    }
  };

  throttled.clearTimeout = function () {
    if (deferTimer) {
      clearTimeout(deferTimer);
    }
  };

  return throttled;
}

var MeasurementStore = function () {
  function MeasurementStore() {
    classCallCheck(this, MeasurementStore);
    this.map = new WeakMap();
  }

  createClass(MeasurementStore, [{
    key: 'get',
    value: function get$$1(key) {
      return this.map.get(key);
    }
  }, {
    key: 'has',
    value: function has(key) {
      return this.map.has(key);
    }
  }, {
    key: 'set',
    value: function set$$1(key, value) {
      this.map.set(key, value);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.map = new WeakMap();
    }
  }]);
  return MeasurementStore;
}();

/**
 * Measuring scroll positions, element heights, etc is different between
 * different browsers and the window object vs other DOM nodes. These
 * utils abstract away these differences.
 */

function getElementHeight(element) {
  return element === window ? window.innerHeight : element.clientHeight;
}

function getWindowScrollPos() {
  if (window.scrollY !== undefined) {
    // Modern browser
    return window.scrollY;
  }
  if (document.documentElement && document.documentElement.scrollTop !== undefined) {
    // IE support.
    return document.documentElement.scrollTop;
  }
  return 0;
}

function getRelativeScrollTop(element) {
  return element === window ? getWindowScrollPos() : element.scrollTop - element.getBoundingClientRect().top;
}

function getScrollHeight(element) {
  return element === window && document.documentElement ? document.documentElement.scrollHeight : element.scrollHeight;
}

function getScrollPos(element) {
  return element === window ? getWindowScrollPos() : element.scrollTop;
}

var DefaultLayoutSymbol = Symbol('default');
var UniformRowLayoutSymbol = Symbol('uniformRow');

var mindex = function mindex(arr) {
  var idx = 0;
  for (var i = 0; i < arr.length; i += 1) {
    if (arr[i] < arr[idx]) {
      idx = i;
    }
  }
  return idx;
};

var offscreen = function offscreen(width) {
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  return {
    top: -9999,
    left: -9999,
    width: width,
    height: height
  };
};

var defaultLayout = (function (_ref) {
  var cache = _ref.cache,
      _ref$columnWidth = _ref.columnWidth,
      columnWidth = _ref$columnWidth === undefined ? 236 : _ref$columnWidth,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === undefined ? 14 : _ref$gutter,
      _ref$minCols = _ref.minCols,
      minCols = _ref$minCols === undefined ? 2 : _ref$minCols,
      width = _ref.width;
  return function (items) {
    if (width == null) {
      return items.map(function () {
        return offscreen(columnWidth);
      });
    }

    var columnWidthAndGutter = columnWidth + gutter;
    var columnCount = Math.max(Math.floor((width + gutter) / columnWidthAndGutter), minCols);
    // the total height of each column
    var heights = new Array(columnCount).fill(0);
    var centerOffset = Math.max(Math.floor((width - columnWidthAndGutter * columnCount + gutter) / 2), 0);

    return items.reduce(function (acc, item) {
      var positions = acc;
      // $FlowFixMe
      var height = cache.get(item);
      var position = void 0;

      if (height == null) {
        position = offscreen(columnWidth);
      } else {
        var heightAndGutter = height + gutter;
        var col = mindex(heights);
        var _top = heights[col];
        var _left = col * columnWidthAndGutter + centerOffset;

        heights[col] += heightAndGutter;
        position = { top: _top, left: _left, width: columnWidth, height: height };
      }
      positions.push(position);
      return positions;
    }, []);
  };
});

var offscreen$1 = function offscreen(width) {
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  return {
    top: -9999,
    left: -9999,
    width: width,
    height: height
  };
};

var uniformRowLayout = (function (_ref) {
  var cache = _ref.cache,
      _ref$columnWidth = _ref.columnWidth,
      columnWidth = _ref$columnWidth === undefined ? 236 : _ref$columnWidth,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === undefined ? 14 : _ref$gutter,
      width = _ref.width,
      _ref$minCols = _ref.minCols,
      minCols = _ref$minCols === undefined ? 3 : _ref$minCols;
  return function (items) {
    if (width == null) {
      return items.map(function () {
        return offscreen$1(columnWidth);
      });
    }

    var columnWidthAndGutter = columnWidth + gutter;
    var columnCount = Math.max(Math.floor((width + gutter) / columnWidthAndGutter), minCols);

    var positions = [];
    var heights = [];

    for (var i = 0; i < items.length; i += 1) {
      var position = void 0;
      var _height = cache.get(items[i]);

      if (_height == null) {
        position = offscreen$1(columnWidth);
      } else {
        var column = i % columnCount;
        var row = Math.floor(i / columnCount);

        if (column === 0 || _height > heights[row]) {
          heights[row] = _height;
        }

        var _top = row > 0 ? heights.slice(0, row).reduce(function (sum, y) {
          return sum + y + gutter;
        }, 0) : 0;

        position = {
          top: _top,
          left: column * columnWidthAndGutter,
          width: columnWidth,
          height: _height
        };
      }
      positions.push(position);
    }
    return positions;
  };
});

var mindex$1 = function mindex(arr) {
  var idx = 0;
  for (var i = 0; i < arr.length; i += 1) {
    if (arr[i] < arr[idx]) {
      idx = i;
    }
  }
  return idx;
};

var fullWidthLayout = (function (_ref) {
  var _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === undefined ? 0 : _ref$gutter,
      cache = _ref.cache,
      _ref$minCols = _ref.minCols,
      minCols = _ref$minCols === undefined ? 2 : _ref$minCols,
      _ref$idealColumnWidth = _ref.idealColumnWidth,
      idealColumnWidth = _ref$idealColumnWidth === undefined ? 240 : _ref$idealColumnWidth,
      width = _ref.width;

  if (width == null) {
    return function (items) {
      return items.map(function () {
        return {
          top: Infinity,
          left: Infinity,
          width: Infinity,
          height: Infinity
        };
      });
    };
  }

  // "This is kind of crazy!" - you
  // Yes, indeed. The "guessing" here is meant to replicate the pass that the
  // original implementation takes with CSS.
  var colguess = Math.floor(width / idealColumnWidth);
  var columnCount = Math.max(Math.floor((width - colguess * gutter) / idealColumnWidth), minCols);
  var columnWidth = Math.floor(width / columnCount);

  return function (items) {
    // the total height of each column
    var heights = new Array(columnCount).fill(0);

    return items.reduce(function (acc, item) {
      var positions = acc;
      var height = cache.get(item);
      var position = void 0;

      if (height == null) {
        position = {
          top: Infinity,
          left: Infinity,
          width: columnWidth,
          height: Infinity
        };
      } else {
        var col = mindex$1(heights);
        var _top = heights[col];
        var _left = col * columnWidth + gutter / 2;

        heights[col] += height;
        position = {
          top: _top,
          left: _left,
          width: columnWidth - gutter,
          height: height
        };
      }

      positions.push(position);
      return positions;
    }, []);
  };
});

var MasonryLayout = function MasonryLayout() {
  classCallCheck(this, MasonryLayout);
};

var UniformRowLayout = function UniformRowLayout() {
  classCallCheck(this, UniformRowLayout);
};

var RESIZE_DEBOUNCE = 300;
// Multiplied against container height.
// The amount of extra buffer space for populating visible items.
var VIRTUAL_BUFFER_FACTOR = 0.7;

var layoutNumberToCssDimension = function layoutNumberToCssDimension(n) {
  return n !== Infinity ? n : undefined;
};

var Masonry = function (_React$Component) {
  inherits(Masonry, _React$Component);
  createClass(Masonry, null, [{
    key: 'createMeasurementStore',
    value: function createMeasurementStore() {
      return new MeasurementStore();
    }

    /**
     * Delays resize handling in case the scroll container is still being resized.
     */

  }]);

  function Masonry(props) {
    classCallCheck(this, Masonry);

    var _this = possibleConstructorReturn(this, (Masonry.__proto__ || Object.getPrototypeOf(Masonry)).call(this, props));

    _this.handleResize = debounce(function () {
      if (_this.gridWrapper) {
        _this.setState({ width: _this.gridWrapper.clientWidth });
      }
    }, RESIZE_DEBOUNCE);
    _this.updateScrollPosition = throttle(function () {
      if (!_this.scrollContainer) {
        return;
      }
      var scrollContainer = _this.scrollContainer.getScrollContainerRef();

      if (!scrollContainer) {
        return;
      }

      _this.setState({
        scrollTop: getScrollPos(scrollContainer)
      });
    });
    _this.measureContainerAsync = debounce(function () {
      _this.measureContainer();
    }, 0);

    _this.setGridWrapperRef = function (ref) {
      _this.gridWrapper = ref;
    };

    _this.setScrollContainerRef = function (ref) {
      _this.scrollContainer = ref;
    };

    _this.fetchMore = function () {
      var loadItems = _this.props.loadItems;

      if (loadItems && typeof loadItems === 'function') {
        _this.setState({
          isFetching: true
        }, function () {
          return loadItems({ from: _this.props.items.length });
        });
      }
    };

    _this.renderMasonryComponent = function (itemData, idx, position) {
      var _this$props = _this.props,
          Component$$1 = _this$props.comp,
          virtualize = _this$props.virtualize;
      var top = position.top,
          left = position.left,
          width = position.width,
          height = position.height;


      var isVisible = void 0;
      if (_this.props.scrollContainer) {
        var virtualBuffer = _this.containerHeight * VIRTUAL_BUFFER_FACTOR;
        var offsetScrollPos = _this.state.scrollTop - _this.containerOffset;
        var viewportTop = offsetScrollPos - virtualBuffer;
        var viewportBottom = offsetScrollPos + _this.containerHeight + virtualBuffer;

        isVisible = !(position.top + position.height < viewportTop || position.top > viewportBottom);
      } else {
        // if no scroll container is passed in, items should always be visible
        isVisible = true;
      }

      var itemComponent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          key: 'item-' + idx,
          className: [styles$17.Masonry__Item, styles$17.Masonry__Item__Mounted].join(' '),
          'data-grid-item': true,
          style: {
            top: 0,
            left: 0,
            transform: 'translateX(' + left + 'px) translateY(' + top + 'px)',
            WebkitTransform: 'translateX(' + left + 'px) translateY(' + top + 'px)',
            width: layoutNumberToCssDimension(width),
            height: layoutNumberToCssDimension(height)
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$$1, { data: itemData, itemIdx: idx, isMeasuring: false })
      );

      return virtualize ? isVisible && itemComponent || null : itemComponent;
    };

    _this.containerHeight = 0;
    _this.containerOffset = 0;

    _this.state = {
      hasPendingMeasurements: props.items.some(function (item) {
        return !!item && !props.measurementStore.has(item);
      }),
      isFetching: false,
      // eslint-disable-next-line react/no-unused-state
      items: props.items,
      scrollTop: 0,
      width: undefined
    };
    return _this;
  }

  /**
   * Adds hooks after the component mounts.
   */


  createClass(Masonry, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.handleResize);

      this.measureContainer();

      var scrollTop = this.state.scrollTop;

      if (this.scrollContainer != null) {
        var _scrollContainer = this.scrollContainer.getScrollContainerRef();
        if (_scrollContainer) {
          scrollTop = getScrollPos(_scrollContainer);
        }
      }

      this.setState(function (prevState) {
        return {
          scrollTop: scrollTop,
          width: _this2.gridWrapper ? _this2.gridWrapper.clientWidth : prevState.width
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      var _props = this.props,
          items = _props.items,
          measurementStore = _props.measurementStore;


      this.measureContainerAsync();

      if (prevState.width != null && this.state.width !== prevState.width) {
        measurementStore.reset();
      }
      // calculate whether we still have pending measurements
      var hasPendingMeasurements = items.some(function (item) {
        return !!item && !measurementStore.has(item);
      });
      if (hasPendingMeasurements || hasPendingMeasurements !== this.state.hasPendingMeasurements || prevState.width == null) {
        this.insertAnimationFrame = requestAnimationFrame(function () {
          _this3.setState({
            hasPendingMeasurements: hasPendingMeasurements
          });
        });
      }
    }

    /**
     * Remove listeners when unmounting.
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.insertAnimationFrame) {
        cancelAnimationFrame(this.insertAnimationFrame);
      }

      // Make sure async methods are cancelled.
      this.measureContainerAsync.clearTimeout();
      this.handleResize.clearTimeout();
      this.updateScrollPosition.clearTimeout();

      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'measureContainer',
    value: function measureContainer() {
      if (this.scrollContainer != null) {
        var _scrollContainer2 = this.scrollContainer;

        var scrollContainerRef = _scrollContainer2.getScrollContainerRef();
        if (scrollContainerRef) {
          this.containerHeight = getElementHeight(scrollContainerRef);
          var el = this.gridWrapper;
          if (el instanceof HTMLElement) {
            var relativeScrollTop = getRelativeScrollTop(scrollContainerRef);
            this.containerOffset = el.getBoundingClientRect().top + relativeScrollTop;
          }
        }
      }
    }

    /**
     * Clear measurements/positions and force a reflow of the entire grid.
     * Only use this if absolutely necessary - ex: We need to reflow items if the
     * number of columns we would display should change after a resize.
     */

  }, {
    key: 'reflow',
    value: function reflow() {
      this.props.measurementStore.reset();
      this.measureContainer();
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          columnWidth = _props2.columnWidth,
          Component$$1 = _props2.comp,
          flexible = _props2.flexible,
          gutter = _props2.gutterWidth,
          measurementStore = _props2.measurementStore,
          items = _props2.items,
          minCols = _props2.minCols;
      var _state = this.state,
          hasPendingMeasurements = _state.hasPendingMeasurements,
          width = _state.width;


      var layout = void 0;
      if (flexible && width !== null) {
        layout = fullWidthLayout({
          gutter: gutter,
          cache: measurementStore,
          minCols: minCols,
          idealColumnWidth: columnWidth,
          width: width
        });
      } else if (this.props.layout === UniformRowLayoutSymbol || this.props.layout instanceof UniformRowLayout) {
        layout = uniformRowLayout({
          cache: measurementStore,
          columnWidth: columnWidth,
          gutter: gutter,
          minCols: minCols,
          width: width
        });
      } else {
        layout = defaultLayout({
          cache: measurementStore,
          columnWidth: columnWidth,
          gutter: gutter,
          minCols: minCols,
          width: width
        });
      }

      var gridBody = void 0;
      if (width == null && hasPendingMeasurements) {
        // When hyrdating from a server render, we don't have the width of the grid
        // and the measurement store is empty
        gridBody = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'div',
          {
            className: styles$17.Masonry,
            style: { height: 0, width: '100%' },
            ref: this.setGridWrapperRef
          },
          items.filter(function (item) {
            return item;
          }).map(function (item, i) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              'div',
              { // keep this in sync with renderMasonryComponent
                className: 'static',
                'data-grid-item': true,
                key: i,
                style: {
                  top: 0,
                  left: 0,
                  transform: 'translateX(0px) translateY(0px)',
                  WebkitTransform: 'translateX(0px) translateY(0px)',
                  width: flexible ? undefined : layoutNumberToCssDimension(columnWidth) // we can't set a width for server rendered flexible items
                },
                ref: function ref(el) {
                  if (el && !flexible) {
                    // only measure flexible items on client
                    measurementStore.set(item, el.clientHeight);
                  }
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$$1, { data: item, itemIdx: i, isMeasuring: false })
            );
          })
        );
      } else if (width == null) {
        // When the width is empty (usually after a re-mount) render an empty
        // div to collect the width for layout
        gridBody = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { style: { width: '100%' }, ref: this.setGridWrapperRef });
      } else {
        // Full layout is possible
        var itemsToRender = items.filter(function (item) {
          return item && measurementStore.has(item);
        });
        var itemsToMeasure = items.filter(function (item) {
          return item && !measurementStore.has(item);
        }).slice(0, minCols);

        // $FlowIssue: despite the polymorphic typing of item to T, Flow is having trouble
        var positions = layout(itemsToRender);
        var measuringPositions = layout(itemsToMeasure);
        // Math.max() === -Infinity when there are no positions
        var height = positions.length ? Math.max.apply(Math, toConsumableArray(positions.map(function (pos) {
          return pos.top + pos.height;
        }))) : 0;
        gridBody = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'div',
          { style: { width: '100%' }, ref: this.setGridWrapperRef },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            { className: styles$17.Masonry, style: { height: height, width: width } },
            itemsToRender.map(function (item, i) {
              return _this4.renderMasonryComponent(item, i, positions[i]);
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            { className: styles$17.Masonry, style: { width: width } },
            itemsToMeasure.map(function (data, i) {
              // itemsToMeasure is always the length of minCols, so i will always be 0..minCols.length
              // we normalize the index here relative to the item list as a whole so that itemIdx is correct
              // and so that React doesnt reuse the measurement nodes
              var measurementIndex = itemsToRender.length + i;
              var position = measuringPositions[i];
              return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                'div',
                {
                  key: 'measuring-' + measurementIndex,
                  style: {
                    visibility: 'hidden',
                    position: 'absolute',
                    top: layoutNumberToCssDimension(position.top),
                    left: layoutNumberToCssDimension(position.left),
                    width: layoutNumberToCssDimension(position.width),
                    height: layoutNumberToCssDimension(position.height)
                  },
                  ref: function ref(el) {
                    if (el) {
                      measurementStore.set(data, el.clientHeight);
                    }
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$$1, {
                  data: data,
                  itemIdx: measurementIndex,
                  isMeasuring: true
                })
              );
            })
          ),
          this.scrollContainer && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FetchItems, {
            containerHeight: this.containerHeight,
            fetchMore: this.fetchMore,
            isFetching: this.state.isFetching || this.state.hasPendingMeasurements,
            scrollHeight: height,
            scrollTop: this.state.scrollTop
          })
        );
      }

      return this.props.scrollContainer ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        ScrollContainer,
        {
          ref: this.setScrollContainerRef,
          onScroll: this.updateScrollPosition,
          scrollContainer: this.props.scrollContainer
        },
        gridBody
      ) : gridBody;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var items = props.items,
          measurementStore = props.measurementStore;
      // whenever we're receiving new props, determine whether any items need to be measured
      // TODO - we should treat items as immutable

      var hasPendingMeasurements = items.some(function (item) {
        return !measurementStore.has(item);
      });

      // Shallow compare all items, if any change reflow the grid.
      for (var i = 0; i < items.length; i += 1) {
        // We've reached the end of our current props and everything matches.
        // If we hit this case it means we need to insert new items.
        if (state.items[i] === undefined) {
          return {
            hasPendingMeasurements: hasPendingMeasurements,
            items: items,
            isFetching: false
          };
        }

        // Reset grid items when:
        if (
        // An item object ref does not match.
        items[i] !== state.items[i] ||
        // Or less items than we currently have are passed in.
        items.length < state.items.length) {
          return {
            hasPendingMeasurements: hasPendingMeasurements,
            items: items,
            isFetching: false
          };
        }
      }

      // Reset items if new items array is empty.
      if (items.length === 0 && state.items.length > 0) {
        return {
          hasPendingMeasurements: hasPendingMeasurements,
          items: items,
          isFetching: false
        };
      }
      if (hasPendingMeasurements !== state.hasPendingMeasurements) {
        // make sure we always update hasPendingMeasurements
        return {
          hasPendingMeasurements: hasPendingMeasurements,
          items: items
        };
      }

      // Return null to indicate no change to state.
      return null;
    }
  }]);
  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Masonry.propTypes = {
  /**
   * The preferred/target item width. If `flexible` is set, the item width will
   * grow to fill column space, and shrink to fit if below min columns.
   */
  columnWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * The component to render.
   */
  /* eslint react/no-unused-prop-types: 0 */
  comp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * The preferred/target item width. Item width will grow to fill
   * column space, and shrink to fit if below min columns.
   */
  flexible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The amount of space between each item.
   */
  gutterWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * An array of all objects to display in the grid.
   */
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,

  /**
   * Measurement Store
   */
  measurementStore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(MeasurementStore),

  /**
   * Layout system to use for items
   */
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(MasonryLayout), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(UniformRowLayout), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol]),

  /**
   * A callback which the grid calls when we need to load more items as the user scrolls.
   * The callback should update the state of the items, and pass those in as props
   * to this component.
   */
  loadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Minimum number of columns to display.
   */
  minCols: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Function that the grid calls to get the scroll container.
   * This is required if the grid is expected to be scrollable.
   */
  scrollContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Whether or not to use actual virtualization
   */
  virtualize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Masonry.defaultProps = {
  columnWidth: 236,
  measurementStore: new MeasurementStore(),
  minCols: 3,
  layout: DefaultLayoutSymbol,
  loadItems: function loadItems() {},
  virtualize: false
};

var NoScrollBehavior = function (_React$Component) {
  inherits(NoScrollBehavior, _React$Component);

  function NoScrollBehavior(props) {
    classCallCheck(this, NoScrollBehavior);

    var _this = possibleConstructorReturn(this, (NoScrollBehavior.__proto__ || Object.getPrototypeOf(NoScrollBehavior)).call(this, props));

    _this.prevOverflow = null;
    return _this;
  }

  createClass(NoScrollBehavior, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        this.prevOverflow = window.document.body.style.overflow;
        window.document.body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.document.body.style.overflow = this.prevOverflow;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NoScrollBehavior;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function queryFocusableAll(el) {
  var selector = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[tabindex="-1"]', '[tabindex="0"]', '[contenteditable]', 'audio[controls]', 'video[controls]', 'summary'].join(',');
  return el.querySelectorAll(selector);
}

var focusElement = function focusElement(el) {
  if (typeof el.focus === 'function') {
    el.focus();
  }
};

var TrapFocusBehavior = function (_React$Component) {
  inherits(TrapFocusBehavior, _React$Component);

  function TrapFocusBehavior() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TrapFocusBehavior);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TrapFocusBehavior.__proto__ || Object.getPrototypeOf(TrapFocusBehavior)).call.apply(_ref, [this].concat(args))), _this), _this.setElRef = function (el) {
      if (el) {
        _this.el = el;
      }
    }, _this.handleFocus = function (event) {
      if (!_this.el || event.target instanceof Node && _this.el.contains(event.target)) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();
      _this.focusFirstChild();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TrapFocusBehavior, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.previouslyFocusedEl = document.activeElement;
      this.focusFirstChild();
      document.addEventListener('focus', this.handleFocus, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('focus', this.handleFocus, true);
      if (this.previouslyFocusedEl) {
        focusElement(this.previouslyFocusedEl);
      }
    }
  }, {
    key: 'focusFirstChild',
    value: function focusFirstChild() {
      var el = this.el;

      if (el) {
        focusElement(queryFocusableAll(el)[0]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        { ref: this.setElRef },
        this.props.children
      );
    }
  }]);
  return TrapFocusBehavior;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles$18 = { "Backdrop": "_x4 _2l _2q _2n _2o _2p _t9 _5t", "container": "_x5 _2k _2u _2w _3e _2q _2n _34 _45", "wrapper": "_x6 _2j _2d _2w _5n _5e _7y _7w" };

var SIZE_WIDTH_MAP$1 = {
  sm: 414,
  md: 544,
  lg: 804
};

var ESCAPE_KEY_CODE$1 = 27;

var Backdrop = function Backdrop(_ref) {
  var children = _ref.children;
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: styles$18.Backdrop }),
    children
  );
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOutsideClick = function () {
      _this.props.onDismiss();
    }, _this.handleCloseClick = function () {
      _this.props.onDismiss();
    }, _this.handleKeyUp = function (event) {
      if (event.keyCode === ESCAPE_KEY_CODE$1) {
        _this.props.onDismiss();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          accessibilityCloseLabel = _props.accessibilityCloseLabel,
          accessibilityModalLabel = _props.accessibilityModalLabel,
          children = _props.children,
          footer = _props.footer,
          heading = _props.heading,
          _props$role = _props.role,
          role = _props$role === undefined ? 'dialog' : _props$role,
          _props$size = _props.size,
          size = _props$size === undefined ? 'sm' : _props$size;

      var width = SIZE_WIDTH_MAP$1[size];

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        NoScrollBehavior,
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          TrapFocusBehavior,
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'div',
            {
              'aria-label': accessibilityModalLabel,
              className: styles$18.container,
              role: role
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              Backdrop,
              null,
              Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                OutsideEventBehavior,
                { onClick: this.handleOutsideClick },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                  'div',
                  { className: styles$18.wrapper, tabIndex: -1, style: { width: width } },
                  Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                    Box,
                    {
                      flex: 'grow',
                      position: 'relative',
                      display: 'flex',
                      direction: 'column'
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                      Box,
                      { fit: true },
                      role === 'dialog' ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                        Box,
                        {
                          dangerouslySetInlineStyle: {
                            __style: { paddingLeft: 50, paddingRight: 50 }
                          },
                          display: 'flex',
                          justifyContent: 'center',
                          paddingY: 5
                        },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                          Heading,
                          { size: 'xs', accessibilityLevel: 1 },
                          heading
                        )
                      ) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                        Box,
                        { display: 'flex', padding: 4 },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                          Heading,
                          { size: 'sm', accessibilityLevel: 1 },
                          heading
                        )
                      ),
                      role === 'dialog' && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                        Box,
                        { padding: 2, position: 'absolute', top: true, right: true },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(IconButton, {
                          accessibilityLabel: accessibilityCloseLabel,
                          icon: 'cancel',
                          onClick: this.handleCloseClick
                        })
                      ),
                      role === 'dialog' && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Divider, null)
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                      Box,
                      { flex: 'grow', overflow: 'auto', position: 'relative' },
                      children
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                      Box,
                      { fit: true },
                      footer && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                        Box,
                        null,
                        role === 'dialog' && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Divider, null),
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                          Box,
                          { padding: 4 },
                          footer
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  accessibilityCloseLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityModalLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['alertdialog', 'dialog']),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md', 'lg'])
};

var styles$19 = { "innerCircle": "_x7 _2u", "PulseAnimation": "_x8", "outerCircle": "_x9", "AppearAnimation": "_xa" };

function Pulsar(props) {
  var paused = props.paused,
      _props$size = props.size,
      size = _props$size === undefined ? 135 : _props$size;


  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    {
      dangerouslySetInlineStyle: {
        __style: {
          animationIterationCount: paused ? 0 : 'infinite',
          outline: 'none',
          boxShadow: 'none'
        }
      },
      display: paused ? 'none' : 'block',
      height: size,
      position: 'relative',
      width: size
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'div',
      { className: styles$19.innerCircle },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: styles$19.outerCircle })
    )
  );
}

Pulsar.propTypes = {
  paused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var styles$20 = { "RadioButton": "_xb _29 _2u _5c _2w _34 _3e", "RadioButtonSm": "_xc", "RadioButtonMd": "_xd", "RadioButtonIsFocused": "_xe _3s", "RadioButtonWhiteBg": "_xf _5n", "RadioButtonLightGrayBg": "_xg _5p", "Input": "_xh _2l _pb", "InputEnabled": "_xi _t7", "InputSm": "_xj", "InputMd": "_xk", "Check": "_xl _5c", "CheckEnabled": "_xm _5t", "CheckDisabled": "_xn _5r" };

var RadioButton = function (_React$Component) {
  inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, RadioButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleChange = function (event) {
      var checked = event.target.checked;

      _this.props.onChange({ checked: checked, event: event });
    }, _this.handleBlur = function () {
      return _this.setState({ focused: false });
    }, _this.handleFocus = function () {
      _this.setState({ focused: true });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(RadioButton, [{
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3;

      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          id = _props.id,
          name = _props.name,
          size = _props.size,
          value = _props.value;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$20.RadioButton, (_classnames = {}, defineProperty(_classnames, styles$20.RadioButtonIsFocused, this.state.focused), defineProperty(_classnames, styles$20.RadioButtonSm, size === 'sm'), defineProperty(_classnames, styles$20.RadioButtonMd, size === 'md'), defineProperty(_classnames, styles$20.RadioButtonWhiteBg, !disabled || checked), defineProperty(_classnames, styles$20.RadioButtonLightGrayBg, disabled && !checked), _classnames))
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('input', {
          checked: checked,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$20.Input, (_classnames2 = {}, defineProperty(_classnames2, styles$20.InputEnabled, !disabled), defineProperty(_classnames2, styles$20.InputSm, size === 'sm'), defineProperty(_classnames2, styles$20.InputMd, size === 'md'), _classnames2)),
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          type: 'radio',
          value: value
        }),
        checked && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$20.Check, (_classnames3 = {}, defineProperty(_classnames3, styles$20.CheckSm, size === 'sm'), defineProperty(_classnames3, styles$20.CheckMd, size === 'md'), defineProperty(_classnames3, styles$20.CheckEnabled, !disabled), defineProperty(_classnames3, styles$20.CheckDisabled, disabled), _classnames3))
        })
      );
    }
  }]);
  return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RadioButton.propTypes = {
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['sm', 'md'])
};
RadioButton.defaultProps = {
  checked: false,
  disabled: false,
  size: 'md'
};

var ScrollFetch = function (_React$PureComponent) {
  inherits(ScrollFetch, _React$PureComponent);

  function ScrollFetch() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollFetch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollFetch.__proto__ || Object.getPrototypeOf(ScrollFetch)).call.apply(_ref, [this].concat(args))), _this), _this.updatePosition = throttle(function () {
      _this.setState(_this.getScrollState());
    }), _this.state = {
      containerHeight: 0,
      scrollHeight: 0,
      scrollTop: 0
    }, _this.getScrollHeight = function () {
      var container = _this.props.container;

      if (!container) {
        return 0;
      }
      return getScrollHeight(container);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  /**
   * Fetches additional items if needed.
   */


  createClass(ScrollFetch, [{
    key: 'componentDidMount',


    /**
     * Adds scroll listener after the component mounts.
     */
    value: function componentDidMount() {
      var _this2 = this;

      var container = this.props.container;

      if (!container) {
        return;
      }
      setTimeout(function () {
        _this2.setState(_extends({
          containerHeight: getElementHeight(container)
        }, _this2.getScrollState()));
      });
    }

    /**
     * Update scroll buffer and check after the component updates.
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // setTimeout so the parent component can calculate renderHeight().
      this.updatePosition();
    }

    /**
     * Returns the scrollable content height.
     */

  }, {
    key: 'getScrollState',
    value: function getScrollState() {
      var _props = this.props,
          container = _props.container,
          renderHeight = _props.renderHeight;

      if (!container) {
        return null;
      }
      var scrollHeight = renderHeight || this.getScrollHeight;

      return {
        scrollHeight: scrollHeight(),
        scrollTop: getScrollPos(container)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          containerHeight = _state.containerHeight,
          scrollHeight = _state.scrollHeight,
          scrollTop = _state.scrollTop;
      var _props2 = this.props,
          container = _props2.container,
          fetchMore = _props2.fetchMore,
          isAtEnd = _props2.isAtEnd,
          isFetching = _props2.isFetching;


      var props = {
        containerHeight: containerHeight,
        fetchMore: fetchMore,
        isAtEnd: isAtEnd,
        isFetching: isFetching,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      };

      if (!container || isAtEnd) {
        return null;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        ScrollContainer,
        {
          onScroll: this.updatePosition,
          scrollContainer: container
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FetchItems, props)
      );
    }
  }]);
  return ScrollFetch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);


ScrollFetch.propTypes = {
  /**
   * The scroll container to use. Defaults to window.
   */
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  renderHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isAtEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isFetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fetchMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ScrollFetch.defaultProps = {
  container: typeof window !== 'undefined' ? window : null
};

var styles$21 = { "input": "_xo _3r _56 _2u _2s _5s _tf _sc _sd _se _ti _si _5p _45", "clear": "_xp _5j _t7 _7q _7p _2j" };

var SearchField = function (_React$Component) {
  inherits(SearchField, _React$Component);

  function SearchField() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, SearchField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = SearchField.__proto__ || Object.getPrototypeOf(SearchField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      hovered: false
    }, _this.handleChange = function (event) {
      _this.props.onChange({
        value: event.currentTarget.value,
        syntheticEvent: event
      });
    }, _this.handleClear = function (event) {
      _this.props.onChange({
        value: '',
        syntheticEvent: event
      });
    }, _this.handleMouseEnter = function () {
      return _this.setState({ hovered: true });
    }, _this.handleMouseLeave = function () {
      return _this.setState({ hovered: false });
    }, _this.handleFocus = function (event) {
      _this.setState({ focused: true });

      if (_this.props.onFocus) {
        _this.props.onFocus({
          value: event.currentTarget.value,
          syntheticEvent: event
        });
      }
    }, _this.handleBlur = function (event) {
      _this.setState({ focused: false });

      if (_this.props.onBlur) {
        _this.props.onBlur({ event: event });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(SearchField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          accessibilityLabel = _props.accessibilityLabel,
          id = _props.id,
          placeholder = _props.placeholder,
          value = _props.value;

      // This mirrors the built in browser behavior. If there's a value, show the
      // clear button if you're hovering or if you've focused on the field

      var showClear = (this.state.focused || this.state.hovered) && value && value.length > 0;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          display: 'flex',
          position: 'relative',
          alignItems: 'center',
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          color: 'white'
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          {
            dangerouslySetInlineStyle: {
              __style: {
                pointerEvents: 'none',
                // Added the following lines for Safari support
                top: '50%',
                transform: 'translateY(-50%)'
              }
            },
            position: 'absolute',
            left: true,
            paddingX: 4
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, { icon: 'search', accessibilityLabel: '' })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('input', {
          'aria-label': accessibilityLabel,
          className: styles$21.input,
          id: id,
          onChange: this.handleChange,
          placeholder: placeholder,
          role: 'searchbox',
          type: 'search',
          value: value
        }),
        showClear && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { position: 'absolute', right: true, top: true },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'button',
            {
              className: styles$21.clear,
              onClick: this.handleClear,
              tabIndex: -1,
              type: 'button'
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, { icon: 'clear', accessibilityLabel: '' })
          )
        )
      );
    }
  }]);
  return SearchField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchField.propTypes = {
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var styles$22 = { "SegmentedControl": "_xq _2u _5p _2w _3f", "md": "_xr _2s", "lg": "_xs _2t", "item": "_xt _3r _3n _pb _5j _t7", "itemIsNotSelected": "_xu", "itemIsSelected": "_xv _5n" };

function SegmentedControl(props) {
  var _classnames;

  var items = props.items,
      onChange = props.onChange,
      selectedItemIndex = props.selectedItemIndex,
      _props$size = props.size,
      size = _props$size === undefined ? 'md' : _props$size;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$22.SegmentedControl, (_classnames = {}, defineProperty(_classnames, styles$22.md, size === 'md'), defineProperty(_classnames, styles$22.lg, size === 'lg'), _classnames)),
      role: 'tablist'
    },
    items.map(function (item, i) {
      var _classnames2;

      var isSelected = i === selectedItemIndex;
      var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$22.item, (_classnames2 = {}, defineProperty(_classnames2, styles$22.itemIsNotSelected, !isSelected), defineProperty(_classnames2, styles$22.itemIsSelected, isSelected), _classnames2));
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'button',
        {
          'aria-selected': isSelected,
          className: cs,
          key: i,
          onClick: function onClick(e) {
            return onChange({ event: e, activeIndex: i });
          },
          role: 'tab',
          type: 'button'
        },
        typeof item === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Text,
          {
            bold: true,
            color: isSelected ? 'darkGray' : 'gray',
            align: 'center',
            size: size
          },
          item
        ) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { display: 'flex', justifyContent: 'center' },
          item
        )
      );
    })
  );
}

SegmentedControl.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node).isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedItemIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var styles$23 = { "select": "_xw _3r _tf _sc _sd _se _ti _5s _t7 _2j _2s _6i _45", "normal": "_xx", "errored": "_xy", "enabled": "_xz _5s _5n", "disabled": "_y0 _5q _5p" };

var SelectList = function (_React$Component) {
  inherits(SelectList, _React$Component);

  function SelectList() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, SelectList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = SelectList.__proto__ || Object.getPrototypeOf(SelectList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      errorIsOpen: false
    }, _this.handleOnChange = function (event) {
      if (event.target instanceof HTMLSelectElement && _this.props.value !== event.target.value) {
        _this.props.onChange({ event: event, value: event.target.value });

        if (_this.props.errorMessage) {
          _this.setState({ errorIsOpen: false });
        }
      }
    }, _this.handleBlur = function () {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: false });
      }
    }, _this.handleFocus = function () {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: true });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(SelectList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          errorMessage = _props.errorMessage,
          id = _props.id,
          idealErrorDirection = _props.idealErrorDirection,
          name = _props.name,
          options = _props.options,
          placeholder = _props.placeholder,
          value = _props.value;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$23.select, disabled ? styles$23.disabled : styles$23.enabled, errorMessage ? styles$23.errored : styles$23.normal);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          color: disabled ? 'lightGray' : 'white',
          dangerouslySetInlineStyle: { __style: { borderRadius: 4 } },
          display: 'flex',
          position: 'relative',
          width: '100%'
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          {
            alignItems: 'center',
            bottom: true,
            dangerouslySetInlineStyle: {
              __style: { paddingRight: 14, paddingTop: 2 }
            },
            display: 'flex',
            position: 'absolute',
            right: true,
            top: true
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
            icon: 'arrow-down',
            size: 12,
            color: disabled ? 'gray' : 'darkGray',
            accessibilityLabel: ''
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'select',
          {
            'aria-describedby': errorMessage && this.state.focused ? id + '-gestalt-error' : null,
            'aria-invalid': errorMessage ? 'true' : 'false',
            className: classes,
            disabled: disabled,
            id: id,
            name: name,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onChange: this.handleOnChange,
            ref: function ref(c) {
              _this2.select = c;
            },
            value: value
          },
          placeholder && !value && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'option',
            { selected: true, disabled: true, value: true, hidden: true },
            placeholder
          ),
          options.map(function (option) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              'option',
              { key: option.value, value: option.value },
              option.label
            );
          })
        ),
        errorMessage && this.state.errorIsOpen && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Flyout,
          {
            anchor: this.select,
            color: 'orange',
            idealDirection: idealErrorDirection,
            onDismiss: function onDismiss() {
              return _this2.setState({ errorIsOpen: false });
            },
            size: 'sm'
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            { padding: 3 },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              Text,
              { bold: true, color: 'white' },
              Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                'span',
                { id: id + '-gestalt-error' },
                errorMessage
              )
            )
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.errorMessage !== state.errorMessage) {
        return {
          errorIsOpen: !!props.errorMessage,
          errorMessage: props.errorMessage
        };
      }

      return null;
    }
  }]);
  return SelectList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SelectList.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  idealErrorDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
SelectList.defaultProps = {
  disabled: false,
  idealErrorDirection: 'right',
  options: []
};

var styles$24 = { "icon": "_y1 _29", "spin": "_y2" };

var SIZE = 40;

function Spinner(_ref) {
  var accessibilityLabel = _ref.accessibilityLabel,
      show = _ref.show;

  return show ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    { xs: { display: 'flex' }, justifyContent: 'around', overflow: 'hidden' },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      'div',
      { className: styles$24.icon },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
        icon: 'knoop',
        accessibilityLabel: accessibilityLabel,
        size: SIZE
      })
    )
  ) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', null);
}

Spinner.propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

function Sticky(props) {
  var _props$dangerouslySet = props.dangerouslySetZIndex,
      dangerouslySetZIndex = _props$dangerouslySet === undefined ? { __zIndex: 1 } : _props$dangerouslySet,
      children = props.children;

  var style = {
    top: props.top != null ? props.top : undefined,
    left: props.left != null ? props.left : undefined,
    right: props.right != null ? props.right : undefined,
    bottom: props.bottom != null ? props.bottom : undefined,
    // eslint-disable-next-line no-underscore-dangle
    zIndex: dangerouslySetZIndex.__zIndex
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    { className: layout.sticky, style: style },
    children
  );
}

Sticky.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  dangerouslySetZIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    __zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var styles$25 = { "switch": "_y3 _29 _2u _2j", "focused": "_y4 _3s", "switchDarkGray": "_y5 _5t", "switchGray": "_y6 _5r", "switchLightGray": "_y7 _5p", "switchWhite": "_y8 _5n", "slider": "_y9 _2u _2l _5n _5c", "sliderRight": "_ya", "sliderLeft": "_yb", "sliderDark": "_yc", "sliderLight": "_yd", "checkbox": "_ye _2l _45 _pb _5j _pg", "checkboxEnabled": "_yf _t7" };

var Switch = function (_React$Component) {
  inherits(Switch, _React$Component);

  function Switch() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Switch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleBlur = function () {
      return _this.setState({ focused: false });
    }, _this.handleChange = function (event) {
      var checked = event.target.checked;

      _this.props.onChange({
        event: event,
        value: checked
      });
    }, _this.handleFocus = function () {
      _this.setState({ focused: true });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Switch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          id = _props.id,
          name = _props.name,
          switched = _props.switched;


      var switchStyles = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$25.switch, defineProperty({}, styles$25.focused, this.state.focused),
      // eslint-disable-next-line no-nested-ternary
      disabled ? switched ? styles$25.switchGray : styles$25.switchLightGray : switched ? styles$25.switchDarkGray : styles$25.switchWhite);

      var sliderStyles = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$25.slider, switched ? styles$25.sliderRight : styles$25.sliderLeft, switched && !disabled ? styles$25.sliderDark : styles$25.sliderLight);

      var inputStyles = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$25.checkbox, defineProperty({}, styles$25.checkboxEnabled, !disabled));

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        { className: switchStyles },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('input', {
          checked: switched,
          className: inputStyles,
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          type: 'checkbox'
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', { className: sliderStyles })
      );
    }
  }]);
  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Switch.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  switched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Switch.defaultProps = {
  disabled: false,
  switched: false
};

var styles$26 = { "Tabs": "_yg _2w", "tab": "_yh _3r _2u _2s _2w _30 undefined _3e _5j _5d _pb _t7", "tabIsNotActive": "_yi _6i _5q", "tabIsActive": "_yj _5p _5s" };

var Tabs = function (_React$Component) {
  inherits(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focusedTabIndex: undefined,
      hoveredTabIndex: undefined
    }, _this.handleTabClick = function (i, e) {
      var onChange = _this.props.onChange;

      onChange({ activeTabIndex: i, event: e });
    }, _this.handleTabFocus = function (i) {
      return _this.setState({ focusedTabIndex: i });
    }, _this.handleTabBlur = function () {
      return _this.setState({ focusedTabIndex: undefined });
    }, _this.handleTabMouseEnter = function (i) {
      return _this.setState({ hoveredTabIndex: i });
    }, _this.handleTabMouseLeave = function () {
      return _this.setState({ hoveredTabIndex: undefined });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          tabs = _props.tabs,
          activeTabIndex = _props.activeTabIndex;
      var _state = this.state,
          focusedTabIndex = _state.focusedTabIndex,
          hoveredTabIndex = _state.hoveredTabIndex;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        { className: styles$26.Tabs, role: 'tablist' },
        tabs.map(function (_ref2, i) {
          var _classnames;

          var text = _ref2.text,
              href = _ref2.href;

          var isActive = i === activeTabIndex;
          var isHovered = i === hoveredTabIndex;
          var isFocused = i === focusedTabIndex;
          var cs = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$26.tab, (_classnames = {}, defineProperty(_classnames, styles$26.tabIsNotActive, !isActive), defineProperty(_classnames, styles$26.tabIsActive, isActive), _classnames));
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            'a',
            {
              'aria-selected': isActive,
              className: cs,
              href: href,
              key: i,
              onClick: function onClick(e) {
                return _this2.handleTabClick(i, e);
              },
              onFocus: function onFocus() {
                return _this2.handleTabFocus(i);
              },
              onBlur: _this2.handleTabBlur,
              onMouseEnter: function onMouseEnter() {
                return _this2.handleTabMouseEnter(i);
              },
              onMouseLeave: _this2.handleTabMouseLeave,
              role: 'tab'
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              Text,
              {
                bold: true,
                color: isActive || isHovered || isFocused ? 'darkGray' : 'gray',
                size: 'md'
              },
              text
            )
          );
        })
      );
    }
  }]);
  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tabs.propTypes = {
  activeTabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.exact({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var styles$27 = { "textArea": "_yk _3r _2u _tf _sc _sd _se _ti _sg _45", "normal": "_yl", "errored": "_ym", "enabled": "_yn _5s _5n", "disabled": "_yo _5q _5p" };

var TextArea = function (_React$Component) {
  inherits(TextArea, _React$Component);

  function TextArea() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      errorIsOpen: false
    }, _this.handleChange = function (event) {
      if (event.target instanceof HTMLTextAreaElement) {
        _this.props.onChange({
          event: event,
          value: event.target.value
        });

        if (_this.props.errorMessage) {
          _this.setState({ errorIsOpen: true });
        }
      }
    }, _this.handleBlur = function (event) {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: false });
      }
      if (event.target instanceof HTMLTextAreaElement && _this.props.onBlur) {
        _this.props.onBlur({
          event: event,
          value: event.target.value
        });
      }
    }, _this.handleFocus = function (event) {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: true });
      }
      if (event.target instanceof HTMLTextAreaElement && _this.props.onFocus) {
        _this.props.onFocus({
          event: event,
          value: event.target.value
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TextArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          errorMessage = _props.errorMessage,
          hasError = _props.hasError,
          id = _props.id,
          idealErrorDirection = _props.idealErrorDirection,
          name = _props.name,
          placeholder = _props.placeholder,
          rows = _props.rows,
          value = _props.value;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$27.textArea, disabled ? styles$27.disabled : styles$27.enabled, hasError || errorMessage ? styles$27.errored : styles$27.normal);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('textarea', {
          'aria-describedby': errorMessage && this.state.focused ? id + '-gestalt-error' : null,
          'aria-invalid': errorMessage || hasError ? 'true' : 'false',
          className: classes,
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          placeholder: placeholder,
          ref: function ref(c) {
            _this2.textarea = c;
          },
          rows: rows,
          value: value
        }),
        errorMessage && this.state.errorIsOpen ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Flyout,
          {
            anchor: this.textarea,
            color: 'orange',
            idealDirection: idealErrorDirection,
            onDismiss: function onDismiss() {
              return _this2.setState({ errorIsOpen: false });
            },
            size: 'sm'
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            { padding: 3 },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              Text,
              { bold: true, color: 'white' },
              Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                'span',
                { id: id + '-gestalt-error' },
                errorMessage
              )
            )
          )
        ) : null
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.errorMessage !== state.errorMessage) {
        return {
          errorIsOpen: !!props.errorMessage,
          errorMessage: props.errorMessage
        };
      }

      return null;
    }
  }]);
  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextArea.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hasError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  idealErrorDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
TextArea.defaultProps = {
  disabled: false,
  hasError: false,
  idealErrorDirection: 'right',
  rows: 3
};

var styles$28 = { "textField": "_yp _3r _2u _2s _tf _sc _sd _se _ti _45", "normal": "_yq", "errored": "_yr", "enabled": "_ys _5s _5n", "disabled": "_yt _5q _5p" };

var TextField = function (_React$Component) {
  inherits(TextField, _React$Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TextField.__proto__ || Object.getPrototypeOf(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      errorIsOpen: false
    }, _this.handleChange = function (event) {
      if (event.target instanceof HTMLInputElement) {
        _this.props.onChange({
          event: event,
          value: event.target.value
        });
      }
    }, _this.handleBlur = function (event) {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: false });
      }
      if (event.target instanceof HTMLInputElement && _this.props.onBlur) {
        _this.props.onBlur({
          event: event,
          value: event.target.value
        });
      }
    }, _this.handleFocus = function (event) {
      if (_this.props.errorMessage) {
        _this.setState({ errorIsOpen: true });
      }
      if (event.target instanceof HTMLInputElement && _this.props.onFocus) {
        _this.props.onFocus({
          event: event,
          value: event.target.value
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TextField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          disabled = _props.disabled,
          errorMessage = _props.errorMessage,
          hasError = _props.hasError,
          id = _props.id,
          idealErrorDirection = _props.idealErrorDirection,
          name = _props.name,
          placeholder = _props.placeholder,
          type = _props.type,
          value = _props.value;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$28.textField, disabled ? styles$28.disabled : styles$28.enabled, hasError || errorMessage ? styles$28.errored : styles$28.normal);

      // type='number' doesn't work on ios safari without a pattern
      // https://stackoverflow.com/questions/14447668/input-type-number-is-not-showing-a-number-keypad-on-ios
      var pattern = type === 'number' ? '\\d*' : undefined;

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('input', {
          'aria-describedby': errorMessage && this.state.focused ? id + '-gestalt-error' : null,
          'aria-invalid': errorMessage || hasError ? 'true' : 'false',
          autoComplete: autoComplete,
          className: classes,
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          pattern: pattern,
          placeholder: placeholder,
          ref: function ref(c) {
            _this2.textfield = c;
          },
          type: type,
          value: value
        }),
        errorMessage && this.state.errorIsOpen && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Flyout,
          {
            anchor: this.textfield,
            color: 'orange',
            idealDirection: idealErrorDirection,
            onDismiss: function onDismiss() {
              return _this2.setState({ errorIsOpen: false });
            },
            size: 'sm'
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            { padding: 3 },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
              Text,
              { bold: true, color: 'white' },
              Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
                'span',
                { id: id + '-gestalt-error' },
                errorMessage
              )
            )
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.errorMessage !== state.errorMessage) {
        return {
          errorIsOpen: !!props.errorMessage,
          errorMessage: props.errorMessage
        };
      }

      return null;
    }
  }]);
  return TextField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextField.propTypes = {
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['current-password', 'on', 'off', 'username']),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  errorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hasError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  idealErrorDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['date', 'email', 'number', 'password', 'text', 'url']),
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
TextField.defaultProps = {
  disabled: false,
  hasError: false,
  idealErrorDirection: 'right',
  type: 'text'
};

function Toast(props) {
  var _props$color = props.color,
      color = _props$color === undefined ? 'darkGray' : _props$color,
      icon = props.icon,
      thumbnail = props.thumbnail,
      text = props.text;


  var contents = void 0;
  // Confirmation Toasts
  if (text instanceof Array && text.length > 1) {
    contents = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { xs: { display: 'flex' } },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        { xs: { display: 'flexColumn' }, flex: 'none', justifyContent: 'center' },
        thumbnail ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Mask,
          { shape: 'rounded', height: 48, width: 48 },
          thumbnail
        ) : null
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          xs: { display: 'flexColumn' },
          justifyContent: 'center',
          dangerouslySetInlineStyle: { __style: { paddingLeft: 10 } }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          {
            dangerouslySetInlineStyle: { __style: { fontWeight: 'normal' } }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Text,
            { color: 'white', size: 'lg' },
            text[0]
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Text,
          { bold: true, color: 'white', size: 'lg' },
          text[1]
        )
      )
    );
  } else {
    // Toasts as Guides
    contents = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      {
        xs: { display: 'flex' },
        justifyContent: 'between',
        alignItems: 'center'
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Text,
        { bold: true, color: 'white', size: 'lg' },
        text
      ),
      icon && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        { dangerouslySetInlineStyle: { __style: { paddingLeft: 24 } } },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, { accessibilityLabel: '', color: 'white', icon: icon, size: 36 })
      )
    );
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Box,
    { marginBottom: 3, paddingX: 4, maxWidth: 376, width: '100vw' },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { color: color, fit: true, paddingX: 8, paddingY: 5, shape: 'pill' },
      contents
    )
  );
}

Toast.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['darkGray', 'orange']),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['arrow-circle-forward']), // leaving open to additional icons in the future
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]).isRequired,
  thumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

function Tooltip(props) {
  var anchor = props.anchor,
      children = props.children,
      idealDirection = props.idealDirection,
      onDismiss = props.onDismiss,
      _props$positionRelati = props.positionRelativeToAnchor,
      positionRelativeToAnchor = _props$positionRelati === undefined ? true : _props$positionRelati,
      _props$size = props.size,
      size = _props$size === undefined ? 'md' : _props$size;


  if (!anchor) {
    return null;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    Controller,
    {
      anchor: anchor,
      bgColor: 'darkGray',
      idealDirection: idealDirection,
      positionRelativeToAnchor: positionRelativeToAnchor,
      onDismiss: onDismiss,
      size: size
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
      Box,
      { column: 12, padding: 3 },
      children
    )
  );
}

Tooltip.propTypes = {
  anchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    contains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  idealDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'right', 'down', 'left']),
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  positionRelativeToAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

var styles$29 = { "touchable": "_yu _3r", "fullHeight": "_yv", "fullWidth": "_yw _45", "square": "_yx _5b", "circle": "_yy _5c", "rounded": "_yz _5e", "roundedTop": "_z0 _5f", "roundedRight": "_z1 _5g", "roundedBottom": "_z2 _5h", "roundedLeft": "_z3 _5i", "pill": "_z4 _5d", "pointer": "_z5 _t7", "zoomIn": "_z6 _t8", "zoomOut": "_z7 _t9", "copy": "_z8 _ta", "move": "_z9 _tb", "noDrop": "_za _tc", "grab": "_zb _td", "grabbing": "_zc _te" };

var SPACE_CHAR_CODE = 32;
var ENTER_CHAR_CODE = 13;

var Touchable = function (_React$Component) {
  inherits(Touchable, _React$Component);

  function Touchable() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Touchable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Touchable.__proto__ || Object.getPrototypeOf(Touchable)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyPress = function (event) {
      var onTouch = _this.props.onTouch;
      // Check to see if space or enter were pressed

      if (onTouch && (event.charCode === SPACE_CHAR_CODE || event.charCode === ENTER_CHAR_CODE)) {
        // Prevent the default action to stop scrolling when space is pressed
        event.preventDefault();
        onTouch({ event: event });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Touchable, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          children = _props.children,
          _props$fullWidth = _props.fullWidth,
          fullWidth = _props$fullWidth === undefined ? true : _props$fullWidth,
          fullHeight = _props.fullHeight,
          _props$mouseCursor = _props.mouseCursor,
          mouseCursor = _props$mouseCursor === undefined ? 'pointer' : _props$mouseCursor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onTouch = _props.onTouch,
          _props$shape = _props.shape,
          shape = _props$shape === undefined ? 'square' : _props$shape;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles$29.touchable, styles$29[mouseCursor], styles$29[shape], (_classnames = {}, defineProperty(_classnames, styles$29.fullHeight, fullHeight), defineProperty(_classnames, styles$29.fullWidth, fullWidth), _classnames));

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          className: classes,
          onClick: function onClick(event) {
            return onTouch && onTouch({ event: event });
          },
          onMouseEnter: function (_onMouseEnter) {
            function onMouseEnter(_x) {
              return _onMouseEnter.apply(this, arguments);
            }

            onMouseEnter.toString = function () {
              return _onMouseEnter.toString();
            };

            return onMouseEnter;
          }(function (event) {
            return onMouseEnter && onMouseEnter({ event: event });
          }),
          onMouseLeave: function (_onMouseLeave) {
            function onMouseLeave(_x2) {
              return _onMouseLeave.apply(this, arguments);
            }

            onMouseLeave.toString = function () {
              return _onMouseLeave.toString();
            };

            return onMouseLeave;
          }(function (event) {
            return onMouseLeave && onMouseLeave({ event: event });
          }),
          onKeyPress: this.handleKeyPress,
          role: 'button',
          tabIndex: '0'
        },
        children
      );
    }
  }]);
  return Touchable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Touchable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fullHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  mouseCursor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['copy', 'grab', 'grabbing', 'move', 'noDrop', 'pointer', 'zoomIn', 'zoomOut']),
  onTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  shape: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['square', 'rounded', 'pill', 'circle', 'roundedTop', 'roundedBottom', 'roundedLeft', 'roundedRight'])
};

var styles$30 = { "video": "_zd _29 _2l _45", "player": "_ze _2j _45", "playhead": "_zf _2w _34 _45 _t7", "controls": "_zg _2l _2w _34 _2p _2q _2o _7c _7b" };

var VideoPlayhead = function (_React$PureComponent) {
  inherits(VideoPlayhead, _React$PureComponent);

  function VideoPlayhead() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, VideoPlayhead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = VideoPlayhead.__proto__ || Object.getPrototypeOf(VideoPlayhead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      seeking: false
    }, _this.setPlayheadRef = function (ref) {
      _this.playhead = ref;
    }, _this.seek = function (clientX) {
      if (_this.playhead) {
        var _this$props = _this.props,
            _duration = _this$props.duration,
            _seek = _this$props.seek;

        var _this$playhead$getBou = _this.playhead.getBoundingClientRect(),
            left = _this$playhead$getBou.left,
            width = _this$playhead$getBou.width;

        var percent = Math.max(0, Math.min((clientX - left) / width, 1));
        var newTime = percent * _duration;
        _seek(newTime);
      }
    }, _this.stopClick = function (event) {
      return event.stopPropagation();
    }, _this.handleMouseDown = function (event) {
      _this.setState({ seeking: true });
      _this.seek(event.clientX);
    }, _this.handleMouseMove = function (event) {
      var seeking = _this.state.seeking;

      if (seeking) {
        _this.seek(event.clientX);
      }
    }, _this.handleMouseUp = function () {
      _this.setState({ seeking: false });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(VideoPlayhead, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentTime = _props.currentTime,
          duration = _props.duration;

      var width = Math.floor(currentTime * 10000 / duration) / 100 + '%';
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        Box,
        {
          position: 'relative',
          display: 'flex',
          flex: 'grow',
          alignItems: 'center',
          height: 16
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'div',
          {
            'aria-valuemax': duration,
            'aria-valuemin': '0',
            'aria-valuenow': currentTime,
            className: styles$30.playhead,
            onClick: this.stopClick,
            onKeyPress: this.stopClick,
            onMouseDown: this.handleMouseDown,
            onMouseMove: this.handleMouseMove,
            onMouseUp: this.handleMouseUp,
            ref: this.setPlayheadRef,
            role: 'progressbar',
            tabIndex: '-1'
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            {
              left: true,
              right: true,
              position: 'absolute',
              color: 'lightGray',
              shape: 'rounded',
              height: 4
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Box, { color: 'white', shape: 'rounded', height: '100%', width: width })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Box,
            {
              position: 'absolute',
              shape: 'rounded',
              height: 4,
              dangerouslySetInlineStyle: { __style: { left: width } }
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Box, {
              shape: 'circle',
              width: 16,
              height: 16,
              color: 'white',
              marginLeft: -2,
              dangerouslySetInlineStyle: { __style: { marginTop: -6 } }
            })
          )
        )
      );
    }
  }]);
  return VideoPlayhead;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

VideoPlayhead.propTypes = {
  currentTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  seek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var fullscreenEnabled = function fullscreenEnabled() {
  return (
    // $FlowIssue - vendor prefix missing from Flow
    document.fullscreenEnabled ||
    // $FlowIssue - vendor prefix missing from Flow
    document.webkitFullscreenEnabled ||
    // $FlowIssue - vendor prefix missing from Flow
    document.mozFullScreenEnabled ||
    // $FlowIssue - vendor prefix missing from Flow
    document.msFullscreenEnabled
  );
};

var timeToString = function timeToString(time) {
  var rounded = Math.floor(time || 0);
  var minutes = Math.floor(rounded / 60);
  var seconds = rounded - minutes * 60;
  var minutesStr = minutes < 10 ? '0' + minutes : minutes;
  var secondsStr = seconds < 10 ? '0' + seconds : seconds;
  return minutesStr + ':' + secondsStr;
};

var VideoControls = function (_React$Component) {
  inherits(VideoControls, _React$Component);

  function VideoControls() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, VideoControls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = VideoControls.__proto__ || Object.getPrototypeOf(VideoControls)).call.apply(_ref, [this].concat(args))), _this), _this.handleFullscreenChange = function (_ref2) {
      var event = _ref2.event;
      var onFullscreenChange = _this.props.onFullscreenChange;

      event.stopPropagation();
      onFullscreenChange();
    }, _this.handlePlayingChange = function (_ref3) {
      var event = _ref3.event;
      var _this$props = _this.props,
          playing = _this$props.playing,
          onPause = _this$props.onPause,
          onPlay = _this$props.onPlay;

      if (playing) {
        onPause(event);
      } else {
        onPlay(event);
      }
    }, _this.handleVolumeChange = function (_ref4) {
      var event = _ref4.event;
      var onVolumeChange = _this.props.onVolumeChange;

      onVolumeChange(event);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(VideoControls, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          accessibilityMaximizeLabel = _props.accessibilityMaximizeLabel,
          accessibilityMinimizeLabel = _props.accessibilityMinimizeLabel,
          accessibilityMuteLabel = _props.accessibilityMuteLabel,
          accessibilityPauseLabel = _props.accessibilityPauseLabel,
          accessibilityPlayLabel = _props.accessibilityPlayLabel,
          accessibilityUnmuteLabel = _props.accessibilityUnmuteLabel,
          currentTime = _props.currentTime,
          duration = _props.duration,
          fullscreen = _props.fullscreen,
          playing = _props.playing,
          seek = _props.seek,
          volume = _props.volume;

      var muted = volume === 0;
      var showFullscreenButton = typeof document !== 'undefined' && !!fullscreenEnabled();
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        { className: styles$30.controls },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { padding: 2 },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Touchable,
            { onTouch: this.handlePlayingChange, fullWidth: false },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
              accessibilityLabel: playing ? accessibilityPauseLabel : accessibilityPlayLabel,
              color: 'white',
              icon: playing ? 'pause' : 'play',
              size: 20
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { width: 50, padding: 2 },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Text,
            { color: 'white', align: 'right', size: 'xs' },
            timeToString(currentTime)
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { padding: 2, flex: 'grow' },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(VideoPlayhead, {
            currentTime: currentTime,
            duration: duration,
            seek: seek
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { width: 50, padding: 2 },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Text,
            { color: 'white', align: 'right', size: 'xs' },
            timeToString(duration)
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { padding: 2 },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Touchable,
            { onTouch: this.handleVolumeChange, fullWidth: false },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
              accessibilityLabel: muted ? accessibilityUnmuteLabel : accessibilityMuteLabel,
              color: 'white',
              icon: muted ? 'mute' : 'sound',
              size: 20
            })
          )
        ),
        showFullscreenButton && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          Box,
          { padding: 2 },
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Touchable,
            { onTouch: this.handleFullscreenChange, fullWidth: false },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Icon, {
              accessibilityLabel: fullscreen ? accessibilityMinimizeLabel : accessibilityMaximizeLabel,
              color: 'white',
              icon: fullscreen ? 'minimize' : 'maximize',
              size: 20
            })
          )
        )
      );
    }
  }]);
  return VideoControls;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VideoControls.propTypes = {
  accessibilityMaximizeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityMinimizeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityMuteLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityPauseLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityPlayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  accessibilityUnmuteLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  currentTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  fullscreen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onFullscreenChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onPause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onVolumeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  seek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  volume: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

// For more information on fullscreen and vendor prefixes see
// https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API

var requestFullscreen = function requestFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (element.webkitRequestFullscreen) {
    // $FlowIssue - vendor prefix missing from Flow
    element.webkitRequestFullscreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (element.mozRequestFullScreen) {
    // $FlowIssue - vendor prefix missing from Flow
    element.mozRequestFullScreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (element.msRequestFullscreen) {
    // $FlowIssue - vendor prefix missing from Flow
    element.msRequestFullscreen();
  }
};

var exitFullscreen = function exitFullscreen() {
  // $FlowIssue - vendor prefix missing from Flow
  if (document.exitFullscreen) {
    // $FlowIssue - vendor prefix missing from Flow
    document.exitFullscreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (document.webkitExitFullscreen) {
    // $FlowIssue - vendor prefix missing from Flow
    document.webkitExitFullscreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (document.mozCancelFullScreen) {
    // $FlowIssue - vendor prefix missing from Flow
    document.mozCancelFullScreen();
    // $FlowIssue - vendor prefix missing from Flow
  } else if (document.msExitFullscreen) {
    // $FlowIssue - vendor prefix missing from Flow
    document.msExitFullscreen();
  }
};

// Normally document.fullscreen suffices here as a flag, but IE11 does not
// have a vendor specific version so we must instead use the actual element
var isFullscreen = function isFullscreen() {
  return (
    // $FlowIssue - vendor prefix missing from Flow
    document.fullscreenElement ||
    // $FlowIssue - vendor prefix missing from Flow
    document.webkitFullscreenElement ||
    // $FlowIssue - vendor prefix missing from Flow
    document.mozFullScreenElement ||
    // $FlowIssue - vendor prefix missing from Flow
    document.msFullscreenElement
  );
};

var addFullscreenEventListener = function addFullscreenEventListener(handler) {
  document.addEventListener('fullscreenchange', handler);
  document.addEventListener('webkitfullscreenchange', handler);
  document.addEventListener('mozfullscreenchange', handler);
  document.addEventListener('MSFullscreenChange', handler);
};

var removeFullscreenEventListener = function removeFullscreenEventListener(handler) {
  document.removeEventListener('fullscreenchange', handler);
  document.removeEventListener('webkitfullscreenchange', handler);
  document.removeEventListener('mozfullscreenchange', handler);
  document.removeEventListener('MSFullscreenChange', handler);
};

var isNewSource = function isNewSource(oldSource, newSource) {
  if ((typeof oldSource === 'undefined' ? 'undefined' : _typeof(oldSource)) !== (typeof newSource === 'undefined' ? 'undefined' : _typeof(newSource))) {
    // If the source type changed from string to Array
    // or vice versa, we have a new source
    return true;
  }
  if (Array.isArray(newSource)) {
    if (oldSource.length !== newSource.length) {
      // If the sources are both an Array, and the lengths
      // do not match we evaluate as a new source
      return true;
    }
    // If the sources are both an Array and the same length,
    // verify every element stayed the same
    return newSource.some(function (source, index) {
      return !Array.isArray(oldSource) || source.type !== oldSource[index].type || source.src !== oldSource[index].src;
    });
  }
  // If the sources are both a string, simply compare
  // the new with the old
  return newSource !== oldSource;
};

var Video = function (_React$PureComponent) {
  inherits(Video, _React$PureComponent);

  function Video() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTime: 0,
      duration: 0,
      fullscreen: false
    }, _this.setPlayerRef = function (ref) {
      _this.player = ref;
    }, _this.setVideoRef = function (ref) {
      _this.video = ref;
    }, _this.setPlaybackRate = function (playbackRate) {
      if (_this.video) {
        _this.video.playbackRate = playbackRate;
      }
    }, _this.setVolume = function (volume) {
      if (_this.video) {
        _this.video.volume = volume;
      }
    }, _this.load = function () {
      if (_this.video) {
        _this.video.load();
      }
    }, _this.pause = function () {
      if (_this.video) {
        _this.video.pause();
      }
    }, _this.play = function () {
      if (_this.video) {
        _this.video.play();
      }
    }, _this.seek = function (time) {
      if (_this.video) {
        _this.video.currentTime = time;
      }
    }, _this.toggleFullscreen = function () {
      if (isFullscreen()) {
        exitFullscreen();
      } else if (_this.player) {
        requestFullscreen(_this.player);
      }
    }, _this.handleCanPlay = function (event) {
      var onReady = _this.props.onReady;


      if (onReady) {
        onReady({ event: event });
      }
    }, _this.handleDurationChange = function (event) {
      var onDurationChange = _this.props.onDurationChange;

      var duration = _this.video && _this.video.duration || 0;
      _this.setState({ duration: duration });

      if (onDurationChange) {
        onDurationChange({ event: event, duration: duration });
      }
    }, _this.handleEnded = function (event) {
      var onEnded = _this.props.onEnded;


      if (onEnded) {
        onEnded({ event: event });
      }
    }, _this.handleFullscreenChange = function (event) {
      var onFullscreenChange = _this.props.onFullscreenChange;

      var fullscreen = !!isFullscreen();
      _this.setState({ fullscreen: fullscreen });

      if (onFullscreenChange) {
        onFullscreenChange({ event: event, fullscreen: fullscreen });
      }
    }, _this.handlePlay = function (event) {
      var onPlay = _this.props.onPlay;


      if (onPlay) {
        onPlay({ event: event });
      }
    }, _this.handlePause = function (event) {
      var onPause = _this.props.onPause;


      if (onPause) {
        onPause({ event: event });
      }
    }, _this.handleProgress = function (event) {
      var onLoadedChange = _this.props.onLoadedChange;

      var _ref2 = _this.video || {},
          buffered = _ref2.buffered;

      var loaded = buffered && buffered.length > 0 ? buffered.end(buffered.length - 1) : 0;

      if (onLoadedChange) {
        onLoadedChange({ event: event, loaded: loaded });
      }
    }, _this.handleSeek = function (event) {
      var onSeek = _this.props.onSeek;


      if (onSeek) {
        onSeek({ event: event });
      }
    }, _this.handleTimeUpdate = function (event) {
      var onTimeChange = _this.props.onTimeChange;

      var currentTime = _this.video && _this.video.currentTime || 0;
      _this.setState({ currentTime: currentTime });

      if (onTimeChange) {
        onTimeChange({ event: event, time: currentTime });
      }
    }, _this.handleVolumeChange = function (event) {
      var onVolumeChange = _this.props.onVolumeChange;

      var muted = _this.video && _this.video.muted || false;

      if (onVolumeChange) {
        onVolumeChange({ event: event, volume: muted ? 1 : 0 });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Video, [{
    key: 'componentDidMount',


    /**
     * React lifecycle hooks pertinent to Video
     */

    value: function componentDidMount() {
      var _props = this.props,
          playbackRate = _props.playbackRate,
          playing = _props.playing,
          volume = _props.volume;
      // Set up event listeners to catch backdoors in fullscreen
      // changes such as using the ESC key to exit

      if (typeof document !== 'undefined') {
        addFullscreenEventListener(this.handleFullscreenChange);
      }
      // Load the video to hydrate the DOM after a server render
      this.load();
      // Set the initial volume
      this.setVolume(volume);
      // Set the initial playback rate
      this.setPlaybackRate(playbackRate);
      // Simulate an autoplay effect if the component
      if (playing) {
        this.play();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // If the video source changed, reload the video
      if (isNewSource(prevProps.src, this.props.src)) {
        this.load();
      }
      // If the volume changed, set the new volume
      if (prevProps.volume !== this.props.volume) {
        this.setVolume(this.props.volume);
      }
      // If the playback rate changed, set the new rate
      if (prevProps.playbackRate !== this.props.playbackRate) {
        this.setPlaybackRate(this.props.playbackRate);
      }
      // If the playback changed, play or pause the video
      if (prevProps.playing !== this.props.playing) {
        if (this.props.playing) {
          this.play();
        } else {
          this.pause();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      removeFullscreenEventListener(this.handleFullscreenChange);
    }

    /**
     * DOM reference housekeeping that is needed for functionality
     */

    // The player element encapsulates the actual video DOM
    // element as well as the controls to bring both fullscreen


    // The actual reference to the video HTML DOM element


    /**
     * Functions that directly interact with the HTML video element
     */

    // Set the video to the desired playback rate: 1 (normal)


    // Set the video to the desired volume: 0 (muted) -> 1 (max)


    // Change the video source and re-load the video


    // Pause the video


    // Play the video


    // Seek the video to the desired time


    // Enter/exit fullscreen video player mode


    /**
     * Handlers for various media events on the video
     */

    // Sent when enough data is available that the media can be played


    // The metadata has loaded or changed, indicating a change in
    // duration of the media


    // Sent when playback completes.


    // Sent when the video is switched to/out-of fullscreen mode


    // Sent when playback of the media starts after having been paused.


    // Sent when playback is paused.


    // Sent periodically to inform interested parties of progress downloading the media


    // Sent when a seek operation completes.


    // The time indicated by the element's currentTime attribute has changed


    // Sent when the audio volume changes

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          aspectRatio = _props2.aspectRatio,
          captions = _props2.captions,
          loop = _props2.loop,
          playing = _props2.playing,
          playsInline = _props2.playsInline,
          poster = _props2.poster,
          preload = _props2.preload,
          src = _props2.src,
          volume = _props2.volume;
      var _state = this.state,
          currentTime = _state.currentTime,
          duration = _state.duration,
          fullscreen = _state.fullscreen;


      var paddingBottom = fullscreen && '0' || 1 / aspectRatio * 100 + '%';

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        {
          ref: this.setPlayerRef,
          className: styles$30.player,
          style: { paddingBottom: paddingBottom, height: fullscreen ? '100%' : 0 }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
          'video',
          {
            autoPlay: playing,
            loop: loop,
            muted: volume === 0,
            playsInline: playsInline,
            poster: poster,
            preload: preload,
            src: typeof src === 'string' ? src : undefined,
            ref: this.setVideoRef,
            className: styles$30.video,
            onCanPlay: this.handleCanPlay,
            onDurationChange: this.handleDurationChange,
            onEnded: this.handleEnded,
            onSeeked: this.handleSeek,
            onTimeUpdate: this.handleTimeUpdate,
            onProgress: this.handleProgress
          },
          Array.isArray(src) && src.map(function (source) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('source', { key: source.src, src: source.src, type: source.type });
          }),
          Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('track', { kind: 'captions', src: captions })
        ),
        this.props.controls && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(VideoControls, {
          accessibilityMaximizeLabel: this.props.accessibilityMaximizeLabel,
          accessibilityMinimizeLabel: this.props.accessibilityMinimizeLabel,
          accessibilityMuteLabel: this.props.accessibilityMuteLabel,
          accessibilityPauseLabel: this.props.accessibilityPauseLabel,
          accessibilityPlayLabel: this.props.accessibilityPlayLabel,
          accessibilityUnmuteLabel: this.props.accessibilityUnmuteLabel,
          currentTime: currentTime,
          duration: duration,
          fullscreen: fullscreen,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onFullscreenChange: this.toggleFullscreen,
          onVolumeChange: this.handleVolumeChange,
          playing: playing,
          seek: this.seek,
          volume: volume
        })
      );
    }
  }]);
  return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Video.propTypes = {
  accessibilityMaximizeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessibilityMinimizeLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessibilityMuteLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessibilityPauseLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessibilityPlayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessibilityUnmuteLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  aspectRatio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  captions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDurationChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEnded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFullscreenChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLoadedChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onReady: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onVolumeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  playbackRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  playing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  playsInline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  poster: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'metadata', 'none']),
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['video/m3u8', 'video/mp4', 'video/ogg']).isRequired,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }))]).isRequired,
  volume: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Video.defaultProps = {
  playbackRate: 1,
  playing: false,
  preload: 'auto',
  volume: 1
};


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(39)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(19);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(26);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(35);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(44);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(46);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(10);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(11);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(4);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initialize = initialize;
exports.ga = ga;
exports.set = set;
exports.send = send;
exports.pageview = pageview;
exports.modalview = modalview;
exports.timing = timing;
exports.event = event;
exports.exception = exception;
exports.outboundLink = outboundLink;

var _format2 = __webpack_require__(3);

var _format3 = _interopRequireDefault(_format2);

var _removeLeadingSlash = __webpack_require__(6);

var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

var _loadGA = __webpack_require__(7);

var _loadGA2 = _interopRequireDefault(_loadGA);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

var _log = __webpack_require__(8);

var _log2 = _interopRequireDefault(_log);

var _testModeAPI = __webpack_require__(9);

var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

var _OutboundLink = __webpack_require__(10);

var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * React Google Analytics Module
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @package react-ga
                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
                                                                                                                                                                                                     */

/**
 * Utilities
 */


var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return (0, _format3.default)(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];
  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      (0, _warn2.default)('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    (0, _warn2.default)('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    (0, _loadGA2.default)(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
        (0, _warn2.default)('All configs must be an object');
        return;
      }
      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }
  return true;
}

/**
 * ga:
 * Returns the original GA object.
 */
function ga() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(undefined, args);
    if (_debug) {
      (0, _log2.default)('called ga(\'arguments\');');
      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
    }
  }

  return window.ga;
}

/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    (0, _warn2.default)('`fieldsObject` is required in .set()');
    return;
  }

  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    (0, _warn2.default)('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    (0, _log2.default)('called ga(\'set\', fieldsObject);');
    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
  }
}

/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);
  if (_debug) {
    (0, _log2.default)('called ga(\'send\', fieldObject);');
    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
  }
}

/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */
function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    (0, _warn2.default)('path is required in .pageview()');
    return;
  }

  var path = (0, _trim2.default)(rawPath);
  if (path === '') {
    (0, _warn2.default)('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};
  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _extends({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';
      if (title) {
        extraLog = ' and title: ' + title;
      }
      (0, _log2.default)('with path: ' + path + extraLog);
    }
  }
}

/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    (0, _warn2.default)('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

  if (modalName === '') {
    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = '/modal/' + modalName;
    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      (0, _log2.default)('with path: ' + path);
    }
  }
}

/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments[1];

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}

/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackerNames = arguments[1];

  var category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      (0, _warn2.default)('args.category AND args.action are required in event()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    };

    // Optional Fields
    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        (0, _warn2.default)('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    };

    // Optional Fields
    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        (0, _warn2.default)('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    }

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

var plugin = exports.plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        (0, _warn2.default)('`name` is required in .require()');
        return;
      }

      var name = (0, _trim2.default)(rawName);
      if (name === '') {
        (0, _warn2.default)('`name` cannot be an empty string in .require()');
        return;
      }

      // Optional Fields
      if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
          (0, _warn2.default)('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          (0, _warn2.default)('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
        }
      } else {
        ga('require', name);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload = void 0;
    var actionType = void 0;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        (0, _warn2.default)('Expected `action` arg to be a String.');
      } else {
        var command = pluginName + ':' + action;
        payload = payload || null;
        if (actionType && payload) {
          ga(command, actionType, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
          }
        } else if (payload) {
          ga(command, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
          }
        } else {
          ga(command);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
          }
        }
      }
    }
  }
};

/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */
function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    (0, _warn2.default)('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      (0, _warn2.default)('args.label is required in outboundLink()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };

    var safetyCallbackCalled = false;
    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;

      hitCallback();
    };

    // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data

    // register safety net timeout:
    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);
      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA;

    // Send to GA
    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}

_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
_OutboundLink2.default.trackLink = outboundLink;
var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

exports.default = {
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: _testModeAPI2.default
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _mightBeEmail = __webpack_require__(4);

var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

var _toTitleCase = __webpack_require__(5);

var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if ((0, _mightBeEmail2.default)(s)) {
    (0, _warn2.default)('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return (0, _toTitleCase2.default)(s);
  }

  return s;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTitleCase;

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                * https://github.com/gouch/to-title-case
                                                                                                */

function toTitleCase(string) {
  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (options) {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var gaCalls = exports.gaCalls = [];

exports.default = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;

      var eventMeta = { label: eventLabel };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundLink, [{
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        href: this.props.to,
        onClick: this.handleClick
      });
      delete props.eventLabel;
      return _react2.default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(_react.Component);

OutboundLink.propTypes = {
  eventLabel: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null
};

OutboundLink.trackLink = function () {
  (0, _warn2.default)('ga tracking not enabled');
};

exports.default = OutboundLink;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ })
/******/ ]);
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
module.exports = __webpack_require__(23);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(18).enable();
  window.Promise = __webpack_require__(21);
}

// fetch() polyfill for making API calls.
__webpack_require__(22);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(1);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(8);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(8);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_snapshot__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_snapshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_snapshot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gestalt_dist_gestalt_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gestalt_dist_gestalt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gestalt_dist_gestalt_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(85);
Object(__WEBPACK_IMPORTED_MODULE_1_react_snapshot__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById("root"));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(1),n=__webpack_require__(5),p=__webpack_require__(6),q=__webpack_require__(4),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = undefined;

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = __webpack_require__(33);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = exports.render = function render(rootComponent, domElement) {
  if (navigator.userAgent.match(/Node\.js/i) && window && window.reactSnapshotRender) {
    domElement.innerHTML = _server2.default.renderToString(rootComponent);
    window.reactSnapshotRender();
  } else {
    _reactDom2.default.render(rootComponent, domElement);
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(5),ba=__webpack_require__(0),m=__webpack_require__(27),p=__webpack_require__(1),v=__webpack_require__(4),da=__webpack_require__(28),ea=__webpack_require__(29),fa=__webpack_require__(30),ha=__webpack_require__(6);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(31);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(32);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(34);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(5),r=__webpack_require__(1),t=__webpack_require__(0),w=__webpack_require__(4),x=__webpack_require__(6),y=__webpack_require__(10),z=__webpack_require__(11);
function A(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);p(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var C="function"===typeof Symbol&&Symbol.for,aa=C?Symbol.for("react.portal"):60106,E=C?Symbol.for("react.fragment"):60107,ba=C?Symbol.for("react.strict_mode"):60108,ca=C?Symbol.for("react.profiler"):60114,F=C?Symbol.for("react.provider"):60109,da=C?Symbol.for("react.context"):60110,ea=C?Symbol.for("react.async_mode"):60111,fa=C?Symbol.for("react.forward_ref"):60112,ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
G={},H={};function ia(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ha.test(a))return H[a]=!0;G[a]=!0;return!1}function ja(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function ka(a,b,d,c){if(null===b||"undefined"===typeof b||ja(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var la=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=la.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},ma=r({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},na=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=t.Children.toArray,S=w.thatReturns("");w.thatReturns("");var oa={listing:!0,pre:!0,textarea:!0};
function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var pa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},qa=z(function(a){return y(a)});function ra(a){var b="";t.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function sa(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=x;return b}var ta={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
function V(a,b){void 0===a&&A("152",T(b)||"Component")}
function ua(a,b){function d(c,k){var d=sa(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=r({},e.state,v))}}else if(e=k(c.props,
d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=r({},v,n)):r(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var q in c)q in d?void 0:A("108",T(k)||"Unknown",q)}c&&(b=r({},b,c))}for(;t.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
context:b}}
var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");t.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=t.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:x,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.pushProvider=function(a){var b=
++this.contextIndex,c=a.type._context,k=c._currentValue;this.contextStack[b]=c;this.contextValueStack[b]=k;c._currentValue=a.props.value};a.prototype.popProvider=function(){var a=this.contextIndex,d=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;d._currentValue=c};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-
1];if(c.childIndex>=c.children.length){var k=c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+
M(c);this.previousWasTextNode=!0;return M(c)}d=ua(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!t.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===aa?A("257"):void 0;A("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ba:case ea:case ca:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,
childIndex:0,context:d,footer:""}),""}if("object"===typeof b&&null!==b)switch(b.$$typeof){case fa:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case da:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,
footer:""}),""}A("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(pa.test(b)?void 0:A("65",b),U[b]=!0);var f=a.props;if("input"===b)f=r({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?A("92"):void 0,Array.isArray(l)&&
(1>=l.length?void 0:A("93"),l=l[0]),h=""+l);null==h&&(h="")}f=r({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=r({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=ra(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=r({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)ma[b]&&(null!=
h.children||null!=h.dangerouslySetInnerHTML?A("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?A("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:A("61")),null!=h.style&&"object"!==typeof h.style?A("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="<"+a.type;for(q in h)if(h.hasOwnProperty(q)){var e=h[q];if(null!=e){if("style"===q){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
n=e[g];null!=n&&(v+=u+qa(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ta.hasOwnProperty(q)||(g=q,g=ia(g)&&null!=
e?g+"="+('"'+M(e)+'"'):"");else{m=q;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||ka(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'=""':m+"="+('"'+M(g)+'"')):g=m+"="+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot=""');var q=B;h="";P.hasOwnProperty(b)?q+="/>":(q+=">",h="</"+a.type+">");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=l.__html){l=l.__html;
break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],oa[b]&&"\n"===l.charAt(0)&&(q+="\n"),q+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return q};return a}(),X={renderToString:function(a){return(new W(a,!1)).read(Infinity)},
renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){A("207")},renderToStaticNodeStream:function(){A("208")},version:"16.4.1"},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_product__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_banner__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_category_filter__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_products0_3months__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_emoji__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_mailchimp_subscribe__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_banner_products__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_ga__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_ga__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bannerLinks1=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][1];var bannerLinks2=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][2];var bannerLinks3=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][3];var bannerLinks4=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][4];var bannerLinks5=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][5];var bannerLinks6=__WEBPACK_IMPORTED_MODULE_9__data_banner_products__["a" /* default */][6];var url="https://dausign.us2.list-manage.com/subscribe/post?u=aeb0e6637be109325b11d68b2&amp;id=94e51a0648";var CustomForm=function CustomForm(_ref){var status=_ref.status,message=_ref.message,onValidated=_ref.onValidated;var email=void 0,name=void 0;var submit=function submit(){return email&&name&&email.value.indexOf("@")>-1&&onValidated({EMAIL:email.value,NAME:name.value});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{margin:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"_yp _3r _2u _2s _tf _sc _sd _se _ti _45 _ys _5s _5n _yq",ref:function ref(node){return name=node;},type:"text",placeholder:"Your name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{margin:1,marginBottom:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"_yp _3r _2u _2s _tf _sc _sd _se _ti _45 _ys _5s _5n _yq",ref:function ref(node){return email=node;},type:"email",placeholder:"Your email"})),status==="sending"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"blue"}},"sending..."),status==="error"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"red"},dangerouslySetInnerHTML:{__html:message}}),status==="success"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"green"},dangerouslySetInnerHTML:{__html:message}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["c" /* Button */],{color:"red",text:"Subscribe Now",size:"md",onClick:submit}));};var styles={container:{display:"block",maxWidth:"1060px",margin:"0 auto",padding:"10px"}};var EmojiClicker=function EmojiClicker(_ref2){var emoji=_ref2.emoji,randomEmoji=_ref2.randomEmoji;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"emoji",onClick:randomEmoji},emoji);};var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.handleToggleSmall=_this._handleToggleSmall.bind(_this);_this.randomEmoji=_this._randomEmoji.bind(_this);_this.state={sm:false,activeCategory:"all",emoji:null};return _this;}_createClass(App,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_10_react_ga___default.a.initialize("UA-124209884-1");__WEBPACK_IMPORTED_MODULE_10_react_ga___default.a.pageview(window.location.pathname+window.location.search);}},{key:"componentWillMount",value:function componentWillMount(){this.randomEmoji();}},{key:"_handleCategoryFilterClick",value:function _handleCategoryFilterClick(category){this.setState({activeCategory:category});}},{key:"_handleToggleSmall",value:function _handleToggleSmall(){this.setState(function(prevState){return{sm:!prevState.sm};});}},{key:"_randomEmoji",value:function _randomEmoji(){var emoji=__WEBPACK_IMPORTED_MODULE_7__data_emoji__["a" /* default */][Math.floor(Math.random()*__WEBPACK_IMPORTED_MODULE_7__data_emoji__["a" /* default */].length)];console.log(emoji);this.setState({emoji:emoji});}},{key:"render",value:function render(){var _state=this.state,sm=_state.sm,activeCategory=_state.activeCategory;// const categoryArray = ["all"];
// firstThreeMonths.map(product => {
//   product.category.map(category => {
//     if (categoryArray.indexOf(category) < 0) {
//       categoryArray.push(category);
//     }
//   });
// });
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{color:"white",shape:"rounded",paddingX:6,lgPaddingX:12,paddingY:1,display:"flex",direction:"row",alignItems:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"logo",src:"./assets/images/shopmymom-full-logo.png",alt:""})," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{size:"xs",accessibilityLevel:3,color:"gray"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"logo-subhead"},"everything your baby could want")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{flex:"grow",paddingX:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["h" /* IconButton */],{accessibilityLabel:"Subscribe",bgColor:"lightGray",iconColor:"red",icon:"envelope",size:"md",onClick:this.handleToggleSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks1,imageUrl:"./assets/images/IMG_0696.jpg"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(styles.container),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{display:"flex",direction:"row",wrap:true,paddingY:2,marginBottom:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["k" /* Mask */],{shape:"rounded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"",src:"./assets/images/IMG_0277.jpg",style:{maxWidth:"100%",display:"block"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingY:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{size:"sm",color:"gray",marginBottom:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["j" /* Link */],{inline:true,href:"http://instagram.com/codysharptooth",target:"blank"},"Codysharptooth"),", our doggy rep."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"serif"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Hi, we're a new family living in Los Angeles with a newborn baby. My wife did ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"ALOT")," of research and I can vouch for her that she has great taste! Her purchases have good value, goes well with a modern decor, and is safe, well built, and our daughter loves it all."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The original idea came to me when a coworker, who was pregnant asked to see my wife's registry because she had no idea what half of all the stuff she would need to buy. My wife had gotten it all covered, so why not share this valuable information with the rest of the world? You can also do your own research by checking out the wirecutter who have expert reviewers, or youtube for really indepth suggestions. Think of this website as a ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"cheatsheet")," for all those things you'll need.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["g" /* Icon */],{icon:"heart",accessibilityLabel:"Shopping Bag",color:"red",inline:true,size:20})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We have bought everything on this list unless I've specified. If there's something missing, please let me know!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{alignItems:"center",direction:"row",display:"flex",marginTop:4,marginStart:-1,marginEnd:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["a" /* Avatar */],{size:"md",src:"../assets/images/danau.jpg",name:"Dan",verified:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{bold:true},"Dan Au"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],null,"Shop My Mom")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["e" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{marginTop:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["f" /* Heading */],{size:"xs",color:"red"},"Shopping Guide"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{marginBottom:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["f" /* Heading */],{size:"sm"},"0 - 4 months")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{maxWidth:420,paddingY:0,marginBottom:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],null,"You have a newborn on the way. We spent hours pouring over review sites, blogs, youtube mom channels, and ended up with the following below:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["m" /* Sticky */],{top:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_category_filter__["a" /* default */],{products:__WEBPACK_IMPORTED_MODULE_6__data_products0_3months__["a" /* default */],onChange:this._handleCategoryFilterClick.bind(this),activeCategory:activeCategory})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{display:"flex",direction:"row",wrap:true,paddingY:2},__WEBPACK_IMPORTED_MODULE_6__data_products0_3months__["a" /* default */].map(function(item,index){if(item.category.indexOf(activeCategory)<0&&activeCategory!=="all"){return null;}if(index===7){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks2,imageUrl:"./assets/images/IMG_0700.jpg",spacing:true}));}if(index===15){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks3,imageUrl:"./assets/images/IMG_0702.jpg",spacing:true}));}if(index===21){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks4,imageUrl:"./assets/images/IMG_0703.jpg",spacing:true}));}if(index===25){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks5,imageUrl:"./assets/images/IMG_0711.jpg",spacing:true}));}if(index===33){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_banner__["a" /* default */],{products:bannerLinks6,imageUrl:"./assets/images/IMG_0704.jpg",spacing:true}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["d" /* Column */],{span:12,mdSpan:6,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_product__["a" /* default */],{name:item.name,price:item.price,url:item.url,imageUrl:item.imageUrl,description:item.description}));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingY:12,display:"flex",justifyContent:"center",alignItems:"center",direction:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:4,paddingY:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"footer__cta"},"Sign Up"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"logo",src:"./assets/images/shopmymom-full-logo.png",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_mailchimp_subscribe__["a" /* default */],{url:url,render:function render(_ref3){var subscribe=_ref3.subscribe,status=_ref3.status,message=_ref3.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomForm,{status:status,message:message,onValidated:function onValidated(formData){return subscribe(formData);}});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer__bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{align:"center"},"made in los angeles with"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmojiClicker,{emoji:this.state.emoji,randomEmoji:this.randomEmoji})," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"dausign",href:"http://dausign.com"},"dausign")))),sm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["l" /* Modal */],{accessibilityCloseLabel:"close",accessibilityModalLabel:"Subscribe to Shop My Mom",heading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"logo",src:"./assets/images/shopmymom-full-logo.png",alt:""}),onDismiss:this.handleToggleSmall,size:"sm",footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{padding:2,display:"flex",justifyContent:"center",alignItems:"center",direction:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:4,paddingY:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],null,"We\u2019ve spent a good amount of time finding the best products for our child. Subscribe to get updates, tips, tricks, and hacks for your baby, and more.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_mailchimp_subscribe__["a" /* default */],{url:url,render:function render(_ref4){var subscribe=_ref4.subscribe,status=_ref4.status,message=_ref4.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomForm,{status:status,message:message,onValidated:function onValidated(formData){return subscribe(formData);}});}})))}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(40);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(1);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(43);

var _CSSPropertyOperations = __webpack_require__(12);

var _clean = __webpack_require__(48);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(49);

var _hash = __webpack_require__(66);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(1);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(45);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(47);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(1);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(12);

var _prefixer = __webpack_require__(50);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(51);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(52);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(53);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(54);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(55);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(56);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(57);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(58);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(59);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(60);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(61);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(62);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(63);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(14);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(3);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(3);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(3);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(3);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(64);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(3);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(14);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(65);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__social__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ga__);
var ga=function ga(props){__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:"Product",action:"Product Clicked",label:""+props.name});};var gaEmail=function gaEmail(props){__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:"Social",action:"Email Share Clicked",label:""+props.name});};var gaPinterest=function gaPinterest(props){__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:"Social",action:"Pinterest Share Clicked",label:""+props.name});};var gaFacebook=function gaFacebook(props){__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:"Social",action:"Facebook Share Clicked",label:""+props.name});};function Product(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{padding:2,shape:"rounded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["j" /* Link */],{href:props.url,target:"blank",onClick:function onClick(){return ga(props);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{color:"white",width:"100%",height:"318px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["i" /* Image */],{naturalHeight:1,naturalWidth:1,fit:"contain",alt:props.name,src:props.imageUrl}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{alignItems:"center",justifyContent:"between",direction:"row",display:"flex",padding:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{bold:true,size:"xl"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["j" /* Link */],{href:props.url,target:"blank",onClick:function onClick(){return ga(props);}},props.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],null,"$",props.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{marginBottom:4,padding:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"product-caption"},props.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{shape:"rounded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{display:"flex",direction:"row",justifyContent:"between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{display:"flex",direction:"row",column:6,paddingX:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["c" /* Button */],{accessibilityLabel:"Buy "+props.name,color:"gray",text:"Buy",size:"md",onClick:function onClick(){ga(props);window.open(props.url,"_blank");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{display:"flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["h" /* IconButton */],{accessibilityLabel:"Love",icon:"gmail",iconColor:"darkGray",size:"sm",onClick:function onClick(){gaEmail(props);window.open(Object(__WEBPACK_IMPORTED_MODULE_2__social__["a" /* createEmailShare */])({url:props.url,title:props.name,description:props.description}),"_blank");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["h" /* IconButton */],{accessibilityLabel:"Love",icon:"facebook",iconColor:"darkGray",size:"sm",onClick:function onClick(){gaFacebook(props);window.open(Object(__WEBPACK_IMPORTED_MODULE_2__social__["b" /* createFacebookShare */])({url:props.url,title:props.name}),"_blank");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{paddingX:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["h" /* IconButton */],{accessibilityLabel:"Love",icon:"pinterest",iconColor:"darkGray",size:"sm",onClick:function onClick(){gaPinterest(props);window.open(Object(__WEBPACK_IMPORTED_MODULE_2__social__["c" /* createPinterestShare */])({url:props.url,title:props.name,media:props.imageUrl?props.imageUrl:"",description:props.description}),"_blank");}}))))));}/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serializeRequestParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFacebookShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPinterestShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createEmailShare; });
/**
 * @param { Object } params = an object of params
 * @returns { String } containing the serialized request params
 */var serializeRequestParams=function serializeRequestParams(params){if(!params){return"";}var test=Object.keys(params).reduce(function(memo,key,i){var separator=i===0?"?":"&";var value=params[key];if(value){memo+=""+separator+key+"="+value;}return memo;},"");return test;};/**
 * Creates a Facebook share link. Any tracking parameters added will be passed through to the link params.
 */var createFacebookShare=function createFacebookShare(_ref){var url=_ref.url,title=_ref.title;var baseURL="http://facebook.com/sharer.php";var params={u:encodeURIComponent(url),title:encodeURIComponent(title)};var query=serializeRequestParams(params);return""+baseURL+query;};/**
 * Creates a Pinterest share link. Any tracking parameters added will be passed through to the link params.
 * Using the logic above, monatizable links will be passed through, otherwise we use CMG links
 */var createPinterestShare=function createPinterestShare(_ref2){var url=_ref2.url,title=_ref2.title,media=_ref2.media,description=_ref2.description;var baseURL="https://www.pinterest.com/pin/create/link/";var sharableURL=url;description=encodeURIComponent(description||title);var query=serializeRequestParams({description:description,media:media,url:sharableURL});return""+baseURL+query;};/**
 * Creates a Email share link.
 * TODO This should probably be a small template
 */var createEmailShare=function createEmailShare(_ref3){var title=_ref3.title,url=_ref3.url,name=_ref3.name,body=_ref3.body,subject=_ref3.subject;if(!url){return"";}subject=subject||encodeURIComponent("I think you would like...");name=name||"Shop My Mom ❤️";body=body?encodeURIComponent(body):encodeURIComponent("I just found this on "+name+"\u2014check it out: ");var mailTitle=encodeURIComponent(title).replace(/\'/g,"%27");var params={subject:""+subject,body:body+"%0A%0D"+mailTitle+"%0A%0D"+url};var query=serializeRequestParams(params);return"mailto:"+query;};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__caption__ = __webpack_require__(70);
function Banner(_ref){var products=_ref.products,imageUrl=_ref.imageUrl,spacing=_ref.spacing;if(spacing){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{marginTop:10,marginBottom:10,color:"darkGray",width:"100%",height:"75vh",position:"relative"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["i" /* Image */],{alt:"wide",fit:"cover",naturalHeight:1,naturalWidth:1,src:imageUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__caption__["a" /* default */],{products:products})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{color:"darkGray",width:"100%",height:"75vh",position:"relative"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["i" /* Image */],{alt:"wide",fit:"cover",naturalHeight:1,naturalWidth:1,src:imageUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__caption__["a" /* default */],{products:products})));}/* harmony default export */ __webpack_exports__["a"] = (Banner);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
function Caption(_ref){var products=_ref.products;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{padding:3,position:"absolute",bottom:true,left:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["n" /* Text */],{color:"white"},products.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["j" /* Link */],{key:index,href:item.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,item.name),", $",item.price);})));}/* harmony default export */ __webpack_exports__["a"] = (Caption);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_App_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cx=__WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__src_App_css___default.a);var CategoryFilter=function(_Component){_inherits(CategoryFilter,_Component);function CategoryFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CategoryFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CategoryFilter.__proto__||Object.getPrototypeOf(CategoryFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(category){_this.props.onChange(category);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CategoryFilter,[{key:"render",value:function render(){var _this2=this;var _props=this.props,products=_props.products,activeCategory=_props.activeCategory;var categoryArray=["all"];products.map(function(product){product.category.map(function(category){if(categoryArray.indexOf(category)<0){categoryArray.push(category);}return null;});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"scroll"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["b" /* Box */],{marginTop:3,marginBottom:3},categoryArray.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:cx({categoryFilter:true,font:true,active:category===activeCategory}),key:index,onClick:function onClick(){return _this2.handleChange(category);}},category);})));}}]);return CategoryFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CategoryFilter);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:"2018 UPPAbaby CRUZ Stroller- Gregory (Silver Leather)",price:"549.99 ",url:"https://www.amazon.com/dp/B01MT11067/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01MT11067&linkCode=as2&tag=shopmymom-20&linkId=dca6bea807c87f5af5c63cde8e88998b",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81n%2BxJZ7u%2BL._SX522_.jpg",description:"We looked at a bunch of different strollers, and this was a bit cheaper than our other choice, and is a great build, made from excellent materials, and handles well with fairly large wheels.",category:["Gear"]},{name:"babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",price:"299.00 ",url:"https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",description:"Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",category:["Furniture"]},{name:"Chicco KeyFit 30 Magic Infant Car Seat, Coal",price:"209.99 ",url:"https://www.amazon.com/gp/product/B00WOPRB2Y/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00WOPRB2Y&linkCode=as2&tag=shopmymom-20&linkId=07b2c2ba7954bf119428744b6de80bde",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91y-R%2BRW9hL._SX522_.jpg",description:"This is a really popular car seat. It’s safe, and will last your child until they reach 2.5ft tall or 30lbs. Our daughter is in the 99% percentile for height so we probably only have a few months left.",category:["Car Seats"]},{name:"BABYBJORN Bouncer Balance Soft - Black/Dark Gray, Cotton",price:"199.99 ",url:"https://www.amazon.com/gp/product/B00BQYVOKY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00BQYVOKY&linkCode=as2&tag=shopmymom-20&linkId=50687976ef8efd6a98c7e44c985b346a",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81G43FVEyeL._SX522_.jpg",description:"This Swedish ergonomic bouncer is clean and minimal. When we need a 5 or 10 minute breather, a seat like this in invaluable. Buy the attachable wooden Googly Eyes for her to play with.",category:["Gear"]},{name:"Hatch Baby Rest Night Light, Sound Machine and Time-to-Rise",price:"59.99",url:"https://www.amazon.com/gp/product/B06XMRCC94/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XMRCC94&linkCode=as2&tag=shopmymom-20&linkId=e0e7e527b5baade92f497b709ceead8b",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61ASu-5HgBL._SX522_.jpg",description:"White noise helps her sleep plus you can control it through your phone! There are other convenient ways of controlling it like pressing the top of it to stop or play the most recent. The colors give the room an ambient glow too.",category:["Gear"]},{name:"Slumberkins - BigFoot - Cuddly Creatures with Intention (Snuggler Bundle, Ultra Plush - Brown)",price:"48",url:"https://www.amazon.com/gp/product/B078XNSFZ5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B078XNSFZ5&linkCode=as2&tag=shopmymom-20&linkId=13619c10d1ffbb371fccd19a17ee5eca",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71vRFLviibL._SX679_.jpg",description:"These were featured on sharktank, and our baby loves hers. Apparently, they’re sold out all the time. Could only find this bigfoot one on amazon. They’re very soft and cuddly, and we keep hers in her crib and helps her sleep for sure.",category:["Gear"]},{name:"BABYBJORN Wooden Toy for Bouncer - Googly Eyes",price:"38.76",url:"https://www.amazon.com/gp/product/B001HX4DNE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001HX4DNE&linkCode=as2&tag=shopmymom-20&linkId=5d02faf092e6c2b4c0683535bf811683",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/615bf73PcHL._SX522_.jpg",description:"Attaches to the BabyBjorn bouncer.",category:["Gear"]},{name:"Moonlight Slumber Little Dreamer Dual Sleep Surface Crib Mattress - Waterproof, Hypoallergenic, and Antimicrobial Lightweight Crib Mattress with Extra Firm Infant Side and Plush Toddler Side",price:"196.90 ",url:"https://www.amazon.com/gp/product/B00P9RB0OE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00P9RB0OE&linkCode=as2&tag=shopmymom-20&linkId=5b9c998275bb98ecb80a0a9732942f34",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71g%2Br6qZN3L._SY679_.jpg",description:"We looked at a few mattresses, and chose this one for the dual side sleep system that she can also grow with and it’s high performance ratings.",category:["Furniture"]},{name:"Infant Optics DXR-8 Video Baby Monitor with Interchangeable Optical Lens",price:"165.99 ",url:"https://www.amazon.com/gp/product/B00ECHYTBI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00ECHYTBI&linkCode=as2&tag=shopmymom-20&linkId=3e65992bfccc8c29bc1c3d715ad6de6d",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81g5ls7JhTL._SX522_.jpg",description:"There are alot of options for baby monitors, but ultimately decided on this one because the speakers will go on if there are any sounds emmitted, 360 degree remote access, and night vision. We also chose non-wifi because of the off chance of any hacking into the feed. It's light weight, and screwed into the wall above her crib.",category:["Safety"]},{name:"Baby Tula Free-to-Grow Baby Carrier, Adjustable Newborn to Toddler Carrier, Ergonomic and Multiple Positions for 7 – 45 pounds",price:"159",url:"https://www.amazon.com/gp/product/B01J4K3TEK/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J4K3TEK&linkCode=as2&tag=shopmymom-20&linkId=0ee8b0589f8a49a5c666dcb9e2d817b8",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/712v1D02ZeL._SY679_.jpg",description:"We first bought the Gemini Performance Baby Carrier by Beco, but my wife discovered this one from a Mommy and Me Meetup. We returned the Beco and this is our go to carrier! We actually got the 'Wonder' design, but is out of stock at the moment.",category:["Gear"]},{name:"Skip Hop Explore and More Baby's View 3-Stage Activity Center, Multi, 4 Months",price:"110.19 ",url:"https://www.amazon.com/gp/product/B01J94K9OY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J94K9OY&linkCode=as2&tag=shopmymom-20&linkId=dea60cf8ed5c23737d712eb4aba48324",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81uginCh%2BQL._SX522_.jpg",description:"This was in our registry, and we actually just put it together the other day. She can spin around, and every turn there’s something colorful and new to play with!",category:["Toys"]},{name:"Canon Selphy CP1200 White Wireless Color Photo Printer",price:"99.48 ",url:"https://www.amazon.com/gp/product/B073YHRPV5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B073YHRPV5&linkCode=as2&tag=shopmymom-20&linkId=68fc668c57f5ac0903c78450a917642a",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/313DGG7omnL.jpg",description:"For printing those photos into those picture frames I’m sure you’ll have. Also great for use in scrap/memory books. We used them in The Belly Book and My Baby Book.",category:["Gear"]},{name:"JOOVY Nook High Chair, Coral",price:"94.99 ",url:"https://www.amazon.com/gp/product/B01KQ16MP4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01KQ16MP4&linkCode=as2&tag=shopmymom-20&linkId=366e9f016b5b3cb32137ea2c29dda5e7",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61JHzDGRIgL._SX522_.jpg",description:"It was down to this one or the Scandinavian Stokke Tripp Trapp high chair. Though the Tripp Trapp would have fit with our wooden bench. It came down to costs where it was the half the price. It’s design is so sleek and the Deluxe, Padded Leatherette Seat looks like something you’d find in an Italian sportcar. ",category:["Feeding"]},{name:'Skip Hop Playspot Waterproof Foam Baby Play Mat, Grey/Peach, 70" X 56"',price:"78.99 ",url:"https://www.amazon.com/gp/product/B00SHYJ0G6/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00SHYJ0G6&linkCode=as2&tag=shopmymom-20&linkId=abdee60de659f05c1063881ace324120",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71LLdiwoRnL._SX522_.jpg",description:"We haven’t used this yet, but will be pulled out later when we have a play area on the floor for her.",category:["Toys"]},{name:"Skip Hop Silver Lining Cloud Activity Gym, Multi",price:"62.90 ",url:"https://www.amazon.com/gp/product/B01G1JQXMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01G1JQXMW&linkCode=as2&tag=shopmymom-20&linkId=da4b9e3901be2c4f3bfcb2b5b10fa420",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61q6Sw3cf0L._SX522_.jpg",description:"This was her first playmat where she got plenty of tummy time. We placed a reflective soft mirror in front of her for something to focus on. ",category:["Toys"]},{name:"Graco Pack N’ Play Playard Nimble Nook, Sapphire",price:"55.99",url:"https://www.amazon.com/gp/product/B073HB2ZXW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B073HB2ZXW&linkCode=as2&tag=shopmymom-20&linkId=0e07690fa613ec0aa266f00f9ed59b15",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91EeQVyDKxL._SL1500_.jpg",description:"We used this as her bassinet for the first two months right next to our bed. It comes with a device for vibration, which she seemed to like at first, but was not necessary soon after. We now use it as a playpen as it converts to a larger surface area when you place the mat to the bottom of the pen.",category:["Toys","Furniture"]},{name:"aden + anais Silky Soft Dream Blanket, 100% Cotton Bamboo Muslin, 4 Layer Lightweight and Breathable, 47 X 47 inch, Berry Shibori - Pink",price:"50.96 ",url:"https://www.amazon.com/gp/product/B01LWYAU60/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01LWYAU60&linkCode=as2&tag=shopmymom-20&linkId=71e5548007225224c9dd9c2c26f3cfdf",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81Lzjq4aG6L._SX522_.jpg",description:"A soft muslin with a colorful pattern.",category:["Bedding"]},{name:"UPPAbaby Infant Car Seat Adapter for Chicco",price:"44.99 ",url:"https://www.amazon.com/gp/product/B00YZFYDKY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00YZFYDKY&linkCode=as2&tag=shopmymom-20&linkId=1f21fa11d78c276c3b8cdccb06ea6547",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61fQozVje2L._SX522_.jpg",description:"If you have the UPPAbaby stroller, and the Chicco car seat, this adapter let’s you use both together. Made it convenient to remove the entire carseat and connect to a stroller, especially as a newborn.",category:["Car Seats"]},{name:"KidKraft Sling Bookshelf, Natural",price:"40.83 ",url:"https://www.amazon.com/gp/product/B0018MCVH4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0018MCVH4&linkCode=as2&tag=shopmymom-20&linkId=bd1ee1e1c0e2ee34d7426ca99ddaa2e7",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81Ziq-7XskL._SX679_.jpg",description:"This is a nice, minimal wood colored first bookshelf. Books are prominently displayed face forward.",category:["Toys"]},{name:"UPPAbaby Infant SnugSeat",price:"39.99 ",url:"https://www.amazon.com/gp/product/B0051Y1L1W/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0051Y1L1W&linkCode=as2&tag=shopmymom-20&linkId=dca5bf201e30336481fc4429f11c016b",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/51KpKyNRlgL._SX522_.jpg",description:"This extra additional stroller padding gives her a bit more support.",category:["Car Seats"]},{name:"Boba Wrap, Grey, 0-36 Months",price:"39.95 ",url:"https://www.amazon.com/gp/product/B005SP2LWW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B005SP2LWW&linkCode=as2&tag=shopmymom-20&linkId=cb6b18a773e5837ce7852f8ded7c0992",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91vIWtma2-L._SY679_.jpg",description:"This is one of many carriers we used. It was confusing at first how to put it on, so watch some videos and practice! For men who like minimalist fashion design, their peers might think they’re wearing Rick Owens.😎",category:["Gear"]},{name:"aden + anais Silky Soft Swaddle Baby Blanket, Viscose Bamboo Muslin, Large 47 X 47 inch, 3 Pack, Indigo, Blue",price:"39.49 ",url:"https://www.amazon.com/gp/product/B01CDEP4HO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01CDEP4HO&linkCode=as2&tag=shopmymom-20&linkId=e92e417ddffc7d6cefe861d57b552a93",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/8179DrWpkfL._SX522_.jpg",description:"Part of our swaddling arsenal. We love these, super soft.",category:["Bedding"]},{name:"Lamaze - Octotunes Musical Toy, Help Baby Discover and Play with Sound, with Bright Colors, Fun Textures, and Eight Notes, 0 Months and Older",price:"34.99 ",url:"https://www.amazon.com/gp/product/B000I2MRMY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000I2MRMY&linkCode=as2&tag=shopmymom-20&linkId=7db9a2f5d0766a2c925d270649de8a2c",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/51kPJ-O0lcL.jpg",description:"This is unique since you can squeeze each paw for a different musical note. It’s not played with that much, but maybe when she’s a bit older.",category:["Toys"]},{name:"Organic Crib Mattress Cover Pad – Waterproof and Breathable Bamboo Baby Mattress Pad - Fits ALL Standard Crib Sizes",price:"29.97 ",url:"https://www.amazon.com/gp/product/B00VU8BF14/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00VU8BF14&linkCode=as2&tag=shopmymom-20&linkId=4caaeb8860aa8bc9b34eea18d0012d6d",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/9101BT8fy4L._SX522_.jpg",description:"You’ll want that extra protection for any blow outs or milk vomit. yum.😌",category:["Bedding"]},{name:"Lansinoh Nursing Pads, 4 Packs of 60 (240 count) Stay Dry Disposable Breast Pads",price:"27.96 ",url:"https://www.amazon.com/gp/product/B002TLU5JO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B002TLU5JO&linkCode=as2&tag=shopmymom-20&linkId=25ee013d6559c9727d849d78dd8fb438",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81IEQO7mfXL._SX522AA522_PIbundle-4,TopRight,0,0_AA522_SH20_.jpg",description:"They have a quilted, honeycomb lining and a unique breathable waterproof layer for leakproof protection",category:["Feeding"]},{name:"Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",price:"26.20 ",url:"https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",description:"From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",category:["Nursery Décor"]},{name:"Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",price:"24.99 ",url:"https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",description:"As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",category:["Bedding","Apparel"]},{name:"Burt's Bees Baby - 5 Pack of Burp Cloths, 100% Organic Cotton (1 Cloud, 1 Solid Color, 1 Honey Bee Print, 1 Stripe, 1 Alphabet Bee Print, Heather Grey)",price:"24.95 ",url:"https://www.amazon.com/gp/product/B01HG74QLI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HG74QLI&linkCode=as2&tag=shopmymom-20&linkId=8a624fa76b26163cb65a2f2f0fc51fde",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/9179IuYGLtL._SX522_.jpg",description:"We have a variety of burp cloths, but these just look really nice and are soft and absorbent.",category:["Feeding"]},{name:"HALO SleepSack 100% Cotton Swaddle, Sage, Newborn",price:"22.49 ",url:"https://www.amazon.com/gp/product/B001PBNJ1U/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001PBNJ1U&linkCode=as2&tag=shopmymom-20&linkId=2863b7250c9e35f52cef23c6c23ced29",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81XB4CVLhnL._SX522_.jpg",description:"Moving from swaddling with muslin, this is just as effective though you can't swaddle as tightly.",category:["Bedding","Apparel"]},{name:"HALO SleepSack Micro-Fleece Swaddle, Cream, Small",price:"21.99 ",url:"https://www.amazon.com/gp/product/B001D7JO1U/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001D7JO1U&linkCode=as2&tag=shopmymom-20&linkId=120eebc8122a21609dcc1704b37ec3c0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71QLfgo1DuL._SX522_.jpg",description:"This is the micro-fleece version so good for colder weather.",category:["Bedding","Apparel"]},{name:"AmazonBasics Kids Velvet Hangers - 50-Pack, Beige",price:"20.99 ",url:"https://www.amazon.com/gp/product/B07411XQ74/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07411XQ74&linkCode=as2&tag=shopmymom-20&linkId=67d254117348db37d20f7cf4f4a2569d",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81l0FcIaklL._SX522_.jpg",description:"This is a nice value buy straight from amazon",category:["Apparel"]},{name:"Fridababy NoseFrida Nasal Aspirator with 20 Extra Hygiene Filters",price:"20.00 ",url:"https://www.amazon.com/gp/product/B00RP0GHBO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00RP0GHBO&linkCode=as2&tag=shopmymom-20&linkId=a78bfe4bc8785b4b05092be9dc9fab97",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/41GiWFhmDwL.jpg",description:"We haven’t used it yet, but good to have on hand.",category:["Health"]},{name:"OXO TOT Perfect Pull Wipes Dispenser",price:"19.99",url:"https://www.amazon.com/gp/product/B0771HG9JS/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0771HG9JS&linkCode=as2&tag=shopmymom-20&linkId=1f81ccec8f85feaf7f0bb69268a4c3cb",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81drnEppSxL._SX522_.jpg",description:"Solid dispenser for wipes. Keeps moisture in, good build.",category:["Gear","Diapering"]},{name:"OXO Tot On-The-Go Wipes Dispenser, Gray",price:"7.99",url:"https://www.amazon.com/gp/product/B01MDMYDJO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01MDMYDJO&linkCode=as2&tag=shopmymom-20&linkId=6295c95c366ff3618e93f38197693a50",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61b-VqDprLL._SX522_.jpg",description:"Great for when you’re on the go.",category:["Gear","Diapering"]},{name:"Organic Bamboo Baby Hooded Towel with Bonus Washcloth | Ultra Soft and Super Absorbent Toddler Hooded Bath Towel with Cute Lamb Face Design | Great Infant/Newborn Shower Present for Boy or Girl",price:"19.99 ",url:"https://www.amazon.com/gp/product/B06XCT43MX/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XCT43MX&linkCode=as2&tag=shopmymom-20&linkId=4b6157c2952cdfb343abad9b35822fb6",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71VoR6bPT1L._SX522_.jpg",description:"Your child doesn’t want just any towel, no.. it has to have a cute lamb face.☺️ Also it’s a little bit easier to dry their hair off when they’re wearing it like a little cap.",category:["Bathing & Skin Care"]},{name:"10-Pack Bandana Bibs Upsimples Baby Drool Bibs for Drooling and Teething, 100% Cotton Super Absorbent, 10 Stylish Design for Baby Girls Toddler, Baby Shower Gift Set",price:"18.99 ",url:"https://www.amazon.com/gp/product/B07216Q7ZR/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07216Q7ZR&linkCode=as2&tag=shopmymom-20&linkId=8658d92e42d31831ec2bb81831cf7169",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/713DyKOFA5L._SX522_.jpg",description:"When she’s a bit older, there will be drool and spit up. These little bandana bibs look cute and will be there to catch it.",category:["Feeding"]},{name:"Vicks Baby Rectal Thermometer",price:"18.77",url:"https://www.amazon.com/gp/product/B00LY5KQVS/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00LY5KQVS&linkCode=as2&tag=shopmymom-20&linkId=cc5fe3e525cd75812ce8eb41e041b761",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/41-LWrDru8L.jpg",description:"We’ve read these are better than under arm thermometers with reading temperatures.",category:["Health"]},{name:"Summer Infant Contoured Changing Pad",price:"17.99 ",url:"https://www.amazon.com/gp/product/B009EDSWJA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B009EDSWJA&linkCode=as2&tag=shopmymom-20&linkId=54aba31d563825b601e78d2be55d1760",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81%2Bev0VHJHL._SX522_.jpg",description:"We have this placed on top of our Ikea Hemnes dresser. It’s again, soft, and contoured to keep her in centered. This is a must buy.",category:["Diapering"]},{name:"Earth Mama Sweet Orange Baby Lotion with Organic Calendula, 8-Fluid Ounce",price:"17.99",url:"https://www.amazon.com/gp/product/B000P7M26I/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000P7M26I&linkCode=as2&tag=shopmymom-20&linkId=1caa0ea8164f9cb8471273d75578c354",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61L2fOvkskL._SY679_.jpg",description:"After her daily bath, we massage this baby lotion on her.",category:["Bathing & Skin Care"]},{name:"Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",price:"17.99 ",url:"https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",description:"Nice design, and comfortable.",category:["Bedding"]},{name:"Baby Diaper Caddy Organizer | Bonus Card Holder | Nursery Storage Bin for Diapers, Wipes & Toys | Portable Car Storage Basket | Changing Table Organizer | Great Baby Shower Gift Basket by Pandiee",price:"17.95 ",url:"https://www.amazon.com/gp/product/B074P7CDZP/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B074P7CDZP&linkCode=as2&tag=shopmymom-20&linkId=72fb7140659607abf6217f382d2e5f3a",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/A1gASqU0edL._SX522_.jpg",description:"We’ve got two! One for diapers in the nursery, and the other in the living room for toys and burp cloths.",category:["Toys","Diapering"]},{name:"Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Heather Grey)",price:"17.95 ",url:"https://www.amazon.com/gp/product/B011CK9FIE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B011CK9FIE&linkCode=as2&tag=shopmymom-20&linkId=3b6d15b67cabb9b46e77edc2bb46a940",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81BCjKH5YaL._SX522_.jpg",description:"Heather Grey edition, tally-ho 🙌",category:["Bedding"]},{name:"Carter's Baby 2-Pack Sleeper Gowns with Elephant Print Newborn",price:"15.98",url:"https://www.amazon.com/gp/product/B072JK58QR/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B072JK58QR&linkCode=as2&tag=shopmymom-20&linkId=3983fa521875d7ac41dcf49ef32cd550",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81Grq5DV5-L._UY879_.jpg",description:"These were wonderful when she was a newborn. Can sleep all comfy in this.",category:["Apparel"]},{name:"Sophie La Girafe - So Pure Teether Giraffe",price:"15.19 ",url:"https://www.amazon.com/gp/product/B0038JDAJ8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0038JDAJ8&linkCode=as2&tag=shopmymom-20&linkId=fd9b14aae0c23bfd1b0cbd6f60d50bb5",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71YnQNyhhIL._SX522_.jpg",description:"She’s not quite teething yet, but she’ll still chew on this regardless.",category:["Toys"]},{name:"Manhattan Toy Whoozit Space Blankie Sensory Development Toy",price:"15.07 ",url:"https://www.amazon.com/gp/product/B00VANVD0M/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00VANVD0M&linkCode=as2&tag=shopmymom-20&linkId=5c0bb56e2ac02474fc17aba6b632426c",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71vsyUg0uuL._SX679_.jpg",description:"She played with this early on as newborn. It’s colorful, and we usually had her play with it in the play gym.",category:["Toys"]},{name:"Wubbanub Infant Pacifier - Birthday Bichon",price:"14.95 ",url:"https://www.amazon.com/gp/product/B0713TP16Q/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0713TP16Q&linkCode=as2&tag=shopmymom-20&linkId=661b3ec85956f38d5cb4719928edaeef",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71NExCpFh8L._SX522_.jpg",description:"She was sucking on the pacifier early, early on, but she’s switched to her thumb!",category:["Feeding"]},{name:"Manhattan Toy Classic Baby Beads Wood Rattle, Teether, and Clutching Toy",price:"14.69 ",url:"https://www.amazon.com/gp/product/B002LARAOG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B002LARAOG&linkCode=as2&tag=shopmymom-20&linkId=2dc8fd7fb06b1b0ca80b6c8a64f95a24",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/615cCas6uIL._SX522_.jpg",description:"I just pulled this out, and she immedietly put it to her mouth 😂",category:["Toys"]},{name:"Sonilove Baby Car Mirror",price:"13.98 ",url:"https://www.amazon.com/gp/product/B01K478YBA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01K478YBA&linkCode=as2&tag=shopmymom-20&linkId=cdfdfcc246d520e9a5b11815f011866c",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/517-KRGXIFL.jpg",description:"This is a novel way of checking on your baby while driving.",category:["Car Seats"]},{name:"Comotomo Natural Feel Baby Bottle, Green, 8 Ounces",price:"13.25 ",url:"https://www.amazon.com/gp/product/B004C053AQ/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004C053AQ&linkCode=as2&tag=shopmymom-20&linkId=cc50789db1d4532aaa653f40eb3d4551",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61oAstrEdwL._SX522_.jpg",description:"We started with these bottles, and we approve! They’re soft to hold, and has a natural feel.",category:["Feeding"]},{name:"Stretchy Changing Pad Covers-BROLEX 2 Pack Jersey Knit Change Pad Covers For Girls Boys,Pink & White Arrow",price:"12.99 ",url:"https://www.amazon.com/gp/product/B071L4GTMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B071L4GTMW&linkCode=as2&tag=shopmymom-20&linkId=a93036de85345b53aaee1cce1517e621",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61Xr0wv-agL._SX522_.jpg",description:"These go over for the changing pad, and is a fun pattern.",category:["Diapering","Bedding"]},{name:"Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Blossom)",price:"12.99 ",url:"https://www.amazon.com/gp/product/B00LY36WNG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00LY36WNG&linkCode=as2&tag=shopmymom-20&linkId=a58c0c7b6083ab6f993f1dea95291a5e",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71jNrLa5A2L._SX522_.jpg",description:"You’ll need plenty of these crib sheets, so buy a variety of patterns.",category:["Bedding"]},{name:"Car seat Canopy Nursing Cover - Multi use Baby Stroller and carseat Cover, Breastfeeding Nursing Covers, Boys and Girls Shower Gifts (Classical Arrows)",price:"12.95 ",url:"https://www.amazon.com/gp/product/B06XCGH232/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XCGH232&linkCode=as2&tag=shopmymom-20&linkId=6e37b12de8a5b89593eb392eafb7ffb1",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/818lBt1Q6eL._SX522_.jpg",description:"This is a really useful cover for the stroller, or when nursing out in public.",category:["Feeding","Car Seats"]},{name:"Comotomo Natural Feel Baby Bottle, Pink, 8 Ounces",price:"11.98 ",url:"https://www.amazon.com/gp/product/B004C053AG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004C053AG&linkCode=as2&tag=shopmymom-20&linkId=b89b59af6b1036579e7676ea7028291b",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/612gtwx536L._SX522_.jpg",description:"The pink version.",category:["Feeding"]},{name:"Manhattan Toy Skwish Classic Rattle and Teether Grasping Activity Toy",price:"11.98 ",url:"https://www.amazon.com/gp/product/B000GI0S4E/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000GI0S4E&linkCode=as2&tag=shopmymom-20&linkId=4af2f626a854f48a848d597d4d36b36e",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71Qfh8Bj91L._SX522_.jpg",description:"This is another toy she plays with quite regularly. She’ll either put it in her mouth, or hold it. If you turn it, the beads fall towards that side and has a somewhat hypnotic effect.",category:["Toys"]},{name:"White Newborn Baby Mittens by Nurses Choice (Includes 6 Pairs of No Scratch Cotton Mittens)",price:"10.99 ",url:"https://www.amazon.com/gp/product/B01KKETQPU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01KKETQPU&linkCode=as2&tag=shopmymom-20&linkId=9d5795698826fb421ecdbb035c73ce85",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61xGVeAKRiL._SX522_.jpg",description:"Our baby does scratch herself in her sleep, so these can be helpful, though these newborn ones only last for a month or so.",category:["Apparel"]},{name:"Black, White & Red Infant-Stim Clip Along High Contrast Flash Cards for Baby",price:"10.95 ",url:"https://www.amazon.com/gp/product/B01HMXOI6E/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HMXOI6E&linkCode=as2&tag=shopmymom-20&linkId=038d5c740d8e9649a288c7c08f152b63",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61c-wB4bUuL._SX522_.jpg",description:"When she first arrived in our home, we showed her these cards to look at and would say the name of the animal or person to her. It can be a talking point, and just something to focus on.",category:["Toys"]},{name:"Kassa Inc Static Cling UV Protection Car Sun Shades, Black, Set of 2",price:"9.99 ",url:"https://www.amazon.com/gp/product/B00P0A6OM8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00P0A6OM8&linkCode=as2&tag=shopmymom-20&linkId=2d41367438e5c1dfee3e4f33f96ae1f0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/51LAvFhc0vL.jpg",description:"It’s recommended that you don’t use any sunscreen on your child, so this can be good for the backseat area to keep a little more sunlight out.",category:["Car Seats"]},{name:"Sassy Developmental Bumpy Ball",price:"9.99 ",url:"https://www.amazon.com/gp/product/B004AHMCMI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004AHMCMI&linkCode=as2&tag=shopmymom-20&linkId=e353adcafa55aaa9b6f935614d4fb3e0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91O2QHfRwsL._SX522_.jpg",description:"We’ve just introduced this toy as well, and she puts this to her mouth as well and likes rolling it around. ",category:["Toys"]},{name:"Skip Hop Moby Bath Tear-Free Waterfall Rinser Bath Cup, Blue",price:"9.99 ",url:"https://www.amazon.com/gp/product/B00FXR5S20/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00FXR5S20&linkCode=as2&tag=shopmymom-20&linkId=34da791df9d51c70fd0f5b3a75f11f61",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/817z3ag2L%2BL._SX522_.jpg",description:"We have a whale theme going on in the bathroom so we use this for every bath. We’ll fill this up and gently pour on her head for washing her hair as well as just washing soap off. ",category:["Bathing & Skin Care"]},{name:"Skip Hop Silver Lining Cloud Jitter Stroller Toy, Multi",price:"9.99 ",url:"https://www.amazon.com/gp/product/B01HG1LA6S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HG1LA6S&linkCode=as2&tag=shopmymom-20&linkId=f5130bdbda2bcaa587c98583a2b427dc",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/510DMq4jhqL._SX522_.jpg",description:"We have stuck this in different areas. Right now it’s on her activity center, or earlier, it was looped to the top canopy of the playmat. ",category:["Toys"]},{name:"Manhattan Toy Winkel Rattle and Sensory Teether Toy",price:"9.99 ",url:"https://www.amazon.com/gp/product/B000BNCA4K/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000BNCA4K&linkCode=as2&tag=shopmymom-20&linkId=15762c1fa56aa3a9ec7c2e325787381d",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71drfXxQz3L._SX522_.jpg",description:"You can never have enough teething toys!",category:["Toys"]},{name:"Gerber Baby Unisex 6 Pack Socks, White, 0-3 Months",price:"9.99 ",url:"https://www.amazon.com/gp/product/B007C4GHS6/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B007C4GHS6&linkCode=as2&tag=shopmymom-20&linkId=472b1f164064f7a3ef4d1d6f2cdfecf8",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71mWpiwtn%2BL._UX679_.jpg",description:"Keeps their feet warm when going out, otherwise seldom used.",category:["Apparel"]},{name:"Baby Closet Dividers, First Bouquet, Girl, Set of 6 Size Organizers, Flowers",price:"9.90 ",url:"https://www.amazon.com/gp/product/B07BMJ9GKH/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07BMJ9GKH&linkCode=as2&tag=shopmymom-20&linkId=19a2bf371e3c8ab6099de002e02d48c0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71XC8X5Tu1L._SX522_.jpg",description:"When you start organizing their clothes, you‘ll want to segment them by age. You’ll probably want dividers for better clarity. ",category:["Apparel"]},{name:"Gerber Unisex-Baby Newborn 4 Pack Organic Onesies Brand, White, Newborn",price:"8.94 ",url:"https://www.amazon.com/gp/product/B007B9K9KO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B007B9K9KO&linkCode=as2&tag=shopmymom-20&linkId=7006759587052f4db2bdffe8dfc7b87a",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71WmiitjY3L._UY679_.jpg",description:"She dresses in onesies all day, all night unless she‘s out and about. There was also a great black friday sale on Gap Kids where everything was 50% off. Stock up on these. ☝️",category:["Apparel"]}]);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (["😐","😶","🤑","😎","😘","🤩"]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_to_querystring__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_to_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_to_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleForm__ = __webpack_require__(83);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var getAjaxUrl = function getAjaxUrl(url) {
  return url.replace("/post?", "/post-json?");
};

var MailchimpSubscribe = function (_React$Component) {
  _inherits(MailchimpSubscribe, _React$Component);

  function MailchimpSubscribe() {
    var _temp, _this, _ret;

    _classCallCheck(this, MailchimpSubscribe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      status: null,
      message: null
    }, _this.subscribe = function (data) {
      var params = __WEBPACK_IMPORTED_MODULE_3_to_querystring___default()(data);
      var url = getAjaxUrl(_this.props.url) + "&" + params;
      _this.setState({
        status: "sending",
        message: null
      }, function () {
        return __WEBPACK_IMPORTED_MODULE_2_jsonp___default()(url, {
          param: "c"
        }, function (err, data) {
          console.log("err, data", err, data);
          if (err) {
            _this.setState({
              status: "error",
              message: err
            });
          } else if (data.result !== "success") {
            _this.setState({
              status: "error",
              message: data.msg
            });
          } else {
            _this.setState({
              status: "success",
              message: data.msg
            });
          }
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MailchimpSubscribe.prototype.render = function render() {
    return this.props.render({
      subscribe: this.subscribe,
      status: this.state.status,
      message: this.state.message
    });
  };

  return MailchimpSubscribe;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MailchimpSubscribe.propTypes =  false ? {
  render: PropTypes.func,
  url: PropTypes.string.isRequired
} : {};

MailchimpSubscribe.defaultProps = {
  render: function render(_ref) {
    var subscribe = _ref.subscribe,
        status = _ref.status,
        message = _ref.message;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SimpleForm__["a" /* default */], {
      status: status,
      message: message,
      onSubmitted: function onSubmitted(formData) {
        return subscribe(formData);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MailchimpSubscribe);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(78)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(80);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(81);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("to-querystring",[],e):"object"==typeof exports?exports["to-querystring"]=e():t["to-querystring"]=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=0)}([function(t,e,n){"use strict";function o(t,e,n){if("object"===(void 0===e?"undefined":i(e))){return""+u(e,""+n+(""+t+(n&&"]")+"["))}return n&&n.length?""+n+t+"]="+encodeURIComponent(e):t+"="+encodeURIComponent(e)}function r(t,e,n){return e.map(function(e){return o(t,e,n)}).join("&")}function u(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return Object.keys(t).filter(function(e){return void 0!==t[e]}).map(function(n){return t[n]&&Array.isArray(t[n])?r(n,t[n],e):o(n,t[n],e)}).join("&").replace(/%20/g,"+")}Object.defineProperty(e,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=u}])});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


// a basic form
var SimpleForm = function SimpleForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      className = _ref.className,
      style = _ref.style,
      onSubmitted = _ref.onSubmitted;

  var input = void 0;
  var submit = function submit() {
    return input && input.value.indexOf("@") > -1 && onSubmitted({
      EMAIL: input.value
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className, style: style },
    status === "sending" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { color: "blue" } },
      "sending..."
    ),
    status === "error" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: { color: "red" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    status === "success" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: { color: "green" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      ref: function ref(node) {
        return input = node;
      },
      type: "email",
      placeholder: "Your email"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { onClick: submit },
      "Submit"
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleForm);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({1:[{name:"babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",price:"299.00 ",url:"https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",description:"Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",category:["Furniture"]},{name:"Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",price:"26.20 ",url:"https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",description:"From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",category:["Nursery Décor"]},{name:"Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",price:"24.99 ",url:"https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",description:"As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",category:["Bedding","Apparel"]},{name:"Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",price:"17.99 ",url:"https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",description:"Nice design, and comfortable.",category:["Bedding"]}],2:[{name:"Summer Infant Contoured Changing Pad",price:"17.99 ",url:"https://www.amazon.com/gp/product/B009EDSWJA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B009EDSWJA&linkCode=as2&tag=shopmymom-20&linkId=54aba31d563825b601e78d2be55d1760",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81%2Bev0VHJHL._SX522_.jpg",description:"We have this placed on top of our Ikea Hemnes dresser. It’s again, soft, and contoured to keep her in centered. This is a must buy.",category:["Diapering"]},{name:"Stretchy Changing Pad Covers-BROLEX 2 Pack Jersey Knit Change Pad Covers For Girls Boys,Pink & White Arrow",price:"12.99 ",url:"https://www.amazon.com/gp/product/B071L4GTMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B071L4GTMW&linkCode=as2&tag=shopmymom-20&linkId=a93036de85345b53aaee1cce1517e621",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/61Xr0wv-agL._SX522_.jpg",description:"These go over for the changing pad, and is a fun pattern.",category:["Diapering","Bedding"]}],3:[{name:"KidKraft Sling Bookshelf, Natural",price:"40.83 ",url:"https://www.amazon.com/gp/product/B0018MCVH4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0018MCVH4&linkCode=as2&tag=shopmymom-20&linkId=bd1ee1e1c0e2ee34d7426ca99ddaa2e7",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81Ziq-7XskL._SX679_.jpg",description:"This is a nice, minimal wood colored first bookshelf. Books are prominently displayed face forward.",category:["Toys"]}],4:[{name:"babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",price:"299.00 ",url:"https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",description:"Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",category:["Furniture"]},{name:"Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",price:"26.20 ",url:"https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",description:"From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",category:["Nursery Décor"]},{name:"Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",price:"24.99 ",url:"https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",description:"As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",category:["Bedding","Apparel"]},{name:"Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",price:"17.99 ",url:"https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",description:"Nice design, and comfortable.",category:["Bedding"]}],5:[{name:"Skip Hop Explore and More Baby's View 3-Stage Activity Center, Multi, 4 Months",price:"110.19 ",url:"https://www.amazon.com/gp/product/B01J94K9OY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J94K9OY&linkCode=as2&tag=shopmymom-20&linkId=dea60cf8ed5c23737d712eb4aba48324",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/81uginCh%2BQL._SX522_.jpg",description:"This was in our registry, and we actually just put it together the other day. She can spin around, and every turn there’s something colorful and new to play with!",category:["Toys"]}],6:[{name:"Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",price:"26.20 ",url:"https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",imageUrl:"https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",description:"From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",category:["Nursery Décor"]}]});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.5998ecde.js